(function () {
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2096"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2096"] = parcelRequire;
}
parcelRequire.register("e1ad9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Swiper", function () { return (parcelRequire("2pSj8")).default; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("2pSj8")).default; });
$parcel$export(module.exports, "Virtual", function () { return (parcelRequire("8yLOY")).default; });
$parcel$export(module.exports, "Keyboard", function () { return (parcelRequire("30g62")).default; });
$parcel$export(module.exports, "Mousewheel", function () { return (parcelRequire("83sVu")).default; });
$parcel$export(module.exports, "Navigation", function () { return (parcelRequire("9WMMt")).default; });
$parcel$export(module.exports, "Pagination", function () { return (parcelRequire("b8pg8")).default; });
$parcel$export(module.exports, "Scrollbar", function () { return (parcelRequire("YTZEf")).default; });
$parcel$export(module.exports, "Parallax", function () { return (parcelRequire("kAoeR")).default; });
$parcel$export(module.exports, "Zoom", function () { return (parcelRequire("3EEOo")).default; });
$parcel$export(module.exports, "Lazy", function () { return (parcelRequire("cOWzW")).default; });
$parcel$export(module.exports, "Controller", function () { return (parcelRequire("fmgxr")).default; });
$parcel$export(module.exports, "A11y", function () { return (parcelRequire("03NU9")).default; });
$parcel$export(module.exports, "History", function () { return (parcelRequire("7GhHM")).default; });
$parcel$export(module.exports, "HashNavigation", function () { return (parcelRequire("4wI1J")).default; });
$parcel$export(module.exports, "Autoplay", function () { return (parcelRequire("aKPtp")).default; });
$parcel$export(module.exports, "Thumbs", function () { return (parcelRequire("bRKLr")).default; });
$parcel$export(module.exports, "FreeMode", function () { return (parcelRequire("f36ow")).default; });
$parcel$export(module.exports, "Grid", function () { return (parcelRequire("aiDHc")).default; });
$parcel$export(module.exports, "Manipulation", function () { return (parcelRequire("cfI62")).default; });
$parcel$export(module.exports, "EffectFade", function () { return (parcelRequire("gLF5N")).default; });
$parcel$export(module.exports, "EffectCube", function () { return (parcelRequire("cvfCB")).default; });
$parcel$export(module.exports, "EffectFlip", function () { return (parcelRequire("4XBnY")).default; });
$parcel$export(module.exports, "EffectCoverflow", function () { return (parcelRequire("fQuuL")).default; });
$parcel$export(module.exports, "EffectCreative", function () { return (parcelRequire("k5zRe")).default; });
$parcel$export(module.exports, "EffectCards", function () { return (parcelRequire("cYKtI")).default; });
/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ 
var $2pSj8 = parcelRequire("2pSj8");

var $8yLOY = parcelRequire("8yLOY");

var $30g62 = parcelRequire("30g62");

var $83sVu = parcelRequire("83sVu");

var $9WMMt = parcelRequire("9WMMt");

var $b8pg8 = parcelRequire("b8pg8");

var $YTZEf = parcelRequire("YTZEf");

var $kAoeR = parcelRequire("kAoeR");

var $3EEOo = parcelRequire("3EEOo");

var $cOWzW = parcelRequire("cOWzW");

var $fmgxr = parcelRequire("fmgxr");

var $03NU9 = parcelRequire("03NU9");

var $7GhHM = parcelRequire("7GhHM");

var $4wI1J = parcelRequire("4wI1J");

var $aKPtp = parcelRequire("aKPtp");

var $bRKLr = parcelRequire("bRKLr");

var $f36ow = parcelRequire("f36ow");

var $aiDHc = parcelRequire("aiDHc");

var $cfI62 = parcelRequire("cfI62");

var $gLF5N = parcelRequire("gLF5N");

var $cvfCB = parcelRequire("cvfCB");

var $4XBnY = parcelRequire("4XBnY");

var $fQuuL = parcelRequire("fQuuL");

var $k5zRe = parcelRequire("k5zRe");

var $cYKtI = parcelRequire("cYKtI");

});
parcelRequire.register("2pSj8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c280aeb2839a22d$export$2e2bcd8739ae039; });
/* eslint no-param-reassign: "off" */ 
var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");

var $1EjTE = parcelRequire("1EjTE");

var $ledMJ = parcelRequire("ledMJ");

var $4rC3V = parcelRequire("4rC3V");

var $lhE85 = parcelRequire("lhE85");

var $hoK65 = parcelRequire("hoK65");

var $5NIfu = parcelRequire("5NIfu");

var $3lgo1 = parcelRequire("3lgo1");

var $42aG2 = parcelRequire("42aG2");

var $lUFJw = parcelRequire("lUFJw");

var $59lEw = parcelRequire("59lEw");

var $itDrZ = parcelRequire("itDrZ");

var $aSak5 = parcelRequire("aSak5");

var $61axM = parcelRequire("61axM");

var $lrPYL = parcelRequire("lrPYL");

var $lWyhG = parcelRequire("lWyhG");

var $9Vwwo = parcelRequire("9Vwwo");

var $66U5O = parcelRequire("66U5O");

var $h5TWE = parcelRequire("h5TWE");

var $959nv = parcelRequire("959nv");

var $6gDqh = parcelRequire("6gDqh");
const $1c280aeb2839a22d$var$prototypes = {
    eventsEmitter: $3lgo1.default,
    update: $42aG2.default,
    translate: $lUFJw.default,
    transition: $59lEw.default,
    slide: $itDrZ.default,
    loop: $aSak5.default,
    grabCursor: $61axM.default,
    events: $lrPYL.default,
    breakpoints: $lWyhG.default,
    checkOverflow: $h5TWE.default,
    classes: $9Vwwo.default,
    images: $66U5O.default
};
const $1c280aeb2839a22d$var$extendedDefaults = {};
class $1c280aeb2839a22d$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $1EjTE.extend)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $24nTO.default)(params.el).length > 1) {
            const swipers = [];
            (0, $24nTO.default)(params.el).each((containerEl)=>{
                const newParams = (0, $1EjTE.extend)({}, params, {
                    el: containerEl
                });
                swipers.push(new $1c280aeb2839a22d$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $ledMJ.getSupport)();
        swiper.device = (0, $4rC3V.getDevice)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $lhE85.getBrowser)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $6gDqh.default)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $1EjTE.extend)({}, (0, $959nv.default), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $1EjTE.extend)({}, swiperParams, $1c280aeb2839a22d$var$extendedDefaults, params);
        swiper.originalParams = (0, $1EjTE.extend)({}, swiper.params);
        swiper.passedParams = (0, $1EjTE.extend)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $24nTO.default); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $24nTO.default)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel"
                ];
                const desktop = [
                    "pointerdown",
                    "pointermove",
                    "pointerup"
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $1EjTE.now)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper"); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === "auto" || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $24nTO.default)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $24nTO.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $24nTO.default)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $58sFY.getDocument)();
            const wrapper = document.createElement("div");
            $wrapperEl = (0, $24nTO.default)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
            wrongRTL: $wrapperEl.css("display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit"); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy"); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr("style");
            $wrapperEl.removeAttr("style");
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index");
        }
        swiper.emit("destroy"); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $1EjTE.deleteProps)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $1EjTE.extend)($1c280aeb2839a22d$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $1c280aeb2839a22d$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $959nv.default;
    }
    static installModule(mod) {
        if (!$1c280aeb2839a22d$var$Swiper.prototype.__modules__) $1c280aeb2839a22d$var$Swiper.prototype.__modules__ = [];
        const modules = $1c280aeb2839a22d$var$Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$1c280aeb2839a22d$var$Swiper.installModule(m));
            return $1c280aeb2839a22d$var$Swiper;
        }
        $1c280aeb2839a22d$var$Swiper.installModule(module);
        return $1c280aeb2839a22d$var$Swiper;
    }
}
Object.keys($1c280aeb2839a22d$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($1c280aeb2839a22d$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $1c280aeb2839a22d$var$Swiper.prototype[protoMethod] = $1c280aeb2839a22d$var$prototypes[prototypeGroup][protoMethod];
    });
});
$1c280aeb2839a22d$var$Swiper.use([
    (0, $hoK65.default),
    (0, $5NIfu.default)
]);
var $1c280aeb2839a22d$export$2e2bcd8739ae039 = $1c280aeb2839a22d$var$Swiper;

});
parcelRequire.register("58sFY", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $3bd3f193ccd5630c$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $3bd3f193ccd5630c$export$38b2d434cce3ea22; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $3bd3f193ccd5630c$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $3bd3f193ccd5630c$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($3bd3f193ccd5630c$var$isObject(src[key]) && $3bd3f193ccd5630c$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $3bd3f193ccd5630c$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $3bd3f193ccd5630c$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $3bd3f193ccd5630c$export$f65ca476c09acec0() {
    const doc = typeof document !== "undefined" ? document : {};
    $3bd3f193ccd5630c$export$8b58be045bf06082(doc, $3bd3f193ccd5630c$export$3fdcb9b4d81368d8);
    return doc;
}
const $3bd3f193ccd5630c$export$8582633f185c62bb = {
    document: $3bd3f193ccd5630c$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $3bd3f193ccd5630c$export$38b2d434cce3ea22() {
    const win = typeof window !== "undefined" ? window : {};
    $3bd3f193ccd5630c$export$8b58be045bf06082(win, $3bd3f193ccd5630c$export$8582633f185c62bb);
    return win;
}

});

parcelRequire.register("24nTO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $181e7e5b06640d28$export$2e2bcd8739ae039; });

var $gl2xo = parcelRequire("gl2xo");
const $181e7e5b06640d28$var$Methods = {
    addClass: $gl2xo.addClass,
    removeClass: $gl2xo.removeClass,
    hasClass: $gl2xo.hasClass,
    toggleClass: $gl2xo.toggleClass,
    attr: $gl2xo.attr,
    removeAttr: $gl2xo.removeAttr,
    transform: $gl2xo.transform,
    transition: $gl2xo.transition,
    on: $gl2xo.on,
    off: $gl2xo.off,
    trigger: $gl2xo.trigger,
    transitionEnd: $gl2xo.transitionEnd,
    outerWidth: $gl2xo.outerWidth,
    outerHeight: $gl2xo.outerHeight,
    styles: $gl2xo.styles,
    offset: $gl2xo.offset,
    css: $gl2xo.css,
    each: $gl2xo.each,
    html: $gl2xo.html,
    text: $gl2xo.text,
    is: $gl2xo.is,
    index: $gl2xo.index,
    eq: $gl2xo.eq,
    append: $gl2xo.append,
    prepend: $gl2xo.prepend,
    next: $gl2xo.next,
    nextAll: $gl2xo.nextAll,
    prev: $gl2xo.prev,
    prevAll: $gl2xo.prevAll,
    parent: $gl2xo.parent,
    parents: $gl2xo.parents,
    closest: $gl2xo.closest,
    find: $gl2xo.find,
    children: $gl2xo.children,
    filter: $gl2xo.filter,
    remove: $gl2xo.remove
};
Object.keys($181e7e5b06640d28$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $gl2xo.$).fn, methodName, {
        value: $181e7e5b06640d28$var$Methods[methodName],
        writable: true
    });
});
var $181e7e5b06640d28$export$2e2bcd8739ae039 = (0, $gl2xo.$);

});
parcelRequire.register("gl2xo", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $be50936c4ecb1713$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "addClass", function () { return $be50936c4ecb1713$export$d2cf6cd1dc7067d3; });
$parcel$export(module.exports, "removeClass", function () { return $be50936c4ecb1713$export$c2255604a80b4506; });
$parcel$export(module.exports, "toggleClass", function () { return $be50936c4ecb1713$export$4a80062ca50b57c7; });
$parcel$export(module.exports, "hasClass", function () { return $be50936c4ecb1713$export$4ea3d958472af68f; });
$parcel$export(module.exports, "attr", function () { return $be50936c4ecb1713$export$7aabe8b3a840d2fd; });
$parcel$export(module.exports, "removeAttr", function () { return $be50936c4ecb1713$export$842f2b51efdcb631; });
$parcel$export(module.exports, "transform", function () { return $be50936c4ecb1713$export$51186ad6e864892a; });
$parcel$export(module.exports, "transition", function () { return $be50936c4ecb1713$export$66bb15e2994e6a26; });
$parcel$export(module.exports, "on", function () { return $be50936c4ecb1713$export$af631764ddc44097; });
$parcel$export(module.exports, "off", function () { return $be50936c4ecb1713$export$8c8705df4a2dcec9; });
$parcel$export(module.exports, "trigger", function () { return $be50936c4ecb1713$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "transitionEnd", function () { return $be50936c4ecb1713$export$358dc01d65cad417; });
$parcel$export(module.exports, "outerWidth", function () { return $be50936c4ecb1713$export$e823f88e4111159a; });
$parcel$export(module.exports, "outerHeight", function () { return $be50936c4ecb1713$export$fc5b8aac72846d1e; });
$parcel$export(module.exports, "offset", function () { return $be50936c4ecb1713$export$cc800923e997bb8; });
$parcel$export(module.exports, "styles", function () { return $be50936c4ecb1713$export$9dd6ff9ea0189349; });
$parcel$export(module.exports, "css", function () { return $be50936c4ecb1713$export$dbf350e5966cf602; });
$parcel$export(module.exports, "each", function () { return $be50936c4ecb1713$export$79b2f7037acddd43; });
$parcel$export(module.exports, "filter", function () { return $be50936c4ecb1713$export$3dea766d36a8935f; });
$parcel$export(module.exports, "html", function () { return $be50936c4ecb1713$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "text", function () { return $be50936c4ecb1713$export$6f093cfa640b7166; });
$parcel$export(module.exports, "is", function () { return $be50936c4ecb1713$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "index", function () { return $be50936c4ecb1713$export$b610b8812bbcded9; });
$parcel$export(module.exports, "eq", function () { return $be50936c4ecb1713$export$9663ddc1cf085b32; });
$parcel$export(module.exports, "append", function () { return $be50936c4ecb1713$export$10d8903dec122b9d; });
$parcel$export(module.exports, "prepend", function () { return $be50936c4ecb1713$export$68159836694e22c1; });
$parcel$export(module.exports, "next", function () { return $be50936c4ecb1713$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "nextAll", function () { return $be50936c4ecb1713$export$3cd99760d81ede63; });
$parcel$export(module.exports, "prev", function () { return $be50936c4ecb1713$export$232faf9add678146; });
$parcel$export(module.exports, "prevAll", function () { return $be50936c4ecb1713$export$5a01ccd45552d0b4; });
$parcel$export(module.exports, "parent", function () { return $be50936c4ecb1713$export$91124bb58bc04465; });
$parcel$export(module.exports, "parents", function () { return $be50936c4ecb1713$export$7901f6cd558b9a93; });
$parcel$export(module.exports, "closest", function () { return $be50936c4ecb1713$export$ff7f7c97cdce86e; });
$parcel$export(module.exports, "find", function () { return $be50936c4ecb1713$export$71aa6c912b956294; });
$parcel$export(module.exports, "children", function () { return $be50936c4ecb1713$export$bacb5cc5a11aef16; });
$parcel$export(module.exports, "remove", function () { return $be50936c4ecb1713$export$cd7f480d6b8286c3; });
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $58sFY = parcelRequire("58sFY");
/* eslint-disable no-proto */ function $be50936c4ecb1713$var$makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, "__proto__", {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class $be50936c4ecb1713$var$Dom7 extends Array {
    constructor(items){
        if (typeof items === "number") super(items);
        else {
            super(...items || []);
            $be50936c4ecb1713$var$makeReactive(this);
        }
    }
}
function $be50936c4ecb1713$var$arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...$be50936c4ecb1713$var$arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function $be50936c4ecb1713$var$arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function $be50936c4ecb1713$var$arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function $be50936c4ecb1713$var$toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function $be50936c4ecb1713$var$qsa(selector, context) {
    if (typeof selector !== "string") return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $be50936c4ecb1713$export$3d8c2f653ac9d0b9(selector, context) {
    const window = (0, $58sFY.getWindow)();
    const document = (0, $58sFY.getDocument)();
    let arr = [];
    if (!context && selector instanceof $be50936c4ecb1713$var$Dom7) return selector;
    if (!selector) return new $be50936c4ecb1713$var$Dom7(arr);
    if (typeof selector === "string") {
        const html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
            let toCreate = "div";
            if (html.indexOf("<li") === 0) toCreate = "ul";
            if (html.indexOf("<tr") === 0) toCreate = "tbody";
            if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0) toCreate = "tr";
            if (html.indexOf("<tbody") === 0) toCreate = "table";
            if (html.indexOf("<option") === 0) toCreate = "select";
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = $be50936c4ecb1713$var$qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof $be50936c4ecb1713$var$Dom7) return selector;
        arr = selector;
    }
    return new $be50936c4ecb1713$var$Dom7($be50936c4ecb1713$var$arrayUnique(arr));
}
$be50936c4ecb1713$export$3d8c2f653ac9d0b9.fn = $be50936c4ecb1713$var$Dom7.prototype;
// eslint-disable-next-line
function $be50936c4ecb1713$export$d2cf6cd1dc7067d3(...classes) {
    const classNames = $be50936c4ecb1713$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function $be50936c4ecb1713$export$c2255604a80b4506(...classes) {
    const classNames = $be50936c4ecb1713$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function $be50936c4ecb1713$export$4a80062ca50b57c7(...classes) {
    const classNames = $be50936c4ecb1713$var$arrayFlat(classes.map((c)=>c.split(" ")));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function $be50936c4ecb1713$export$4ea3d958472af68f(...classes) {
    const classNames = $be50936c4ecb1713$var$arrayFlat(classes.map((c)=>c.split(" ")));
    return $be50936c4ecb1713$var$arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function $be50936c4ecb1713$export$7aabe8b3a840d2fd(attrs, value) {
    if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function $be50936c4ecb1713$export$842f2b51efdcb631(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function $be50936c4ecb1713$export$977f3f6a9323c0f6(props, value) {
    if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function $be50936c4ecb1713$export$4051a07651545597(key, value) {
    let el;
    if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function $be50936c4ecb1713$export$33f1b464f736cf21(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function $be50936c4ecb1713$export$ff416b0d33795a06() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf("data-") >= 0) dataset[$be50936c4ecb1713$var$toCamelCase(attr.name.split("data-")[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function $be50936c4ecb1713$export$b02c28252f48c6ac(value) {
    if (typeof value === "undefined") {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === "select") for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function $be50936c4ecb1713$export$2ab9a8f9f1186f14(value) {
    return this.val(value);
}
function $be50936c4ecb1713$export$51186ad6e864892a(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function $be50936c4ecb1713$export$66bb15e2994e6a26(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== "string" ? `${duration}ms` : duration;
    return this;
}
function $be50936c4ecb1713$export$af631764ddc44097(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($be50936c4ecb1713$export$3d8c2f653ac9d0b9(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $be50936c4ecb1713$export$3d8c2f653ac9d0b9(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($be50936c4ecb1713$export$3d8c2f653ac9d0b9(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(" ");
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function $be50936c4ecb1713$export$8c8705df4a2dcec9(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(" ");
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function $be50936c4ecb1713$export$d2de3aaeafa91619(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === "function") {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function $be50936c4ecb1713$export$e614dc9140f7ae71(...args) {
    const window = (0, $58sFY.getWindow)();
    const events = args[0].split(" ");
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function $be50936c4ecb1713$export$1f5f3fbd0c021f73(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionstart", fireCallBack);
    }
    if (callback) dom.on("transitionstart", fireCallBack);
    return this;
}
function $be50936c4ecb1713$export$358dc01d65cad417(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
    }
    if (callback) dom.on("transitionend", fireCallBack);
    return this;
}
function $be50936c4ecb1713$export$70f051812b89bf32(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
    }
    if (callback) dom.on("animationend", fireCallBack);
    return this;
}
function $be50936c4ecb1713$export$7e3df82ee760448c() {
    const window = (0, $58sFY.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css("width"));
    return null;
}
function $be50936c4ecb1713$export$e823f88e4111159a(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue("margin-right")) + parseFloat(styles.getPropertyValue("margin-left"));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function $be50936c4ecb1713$export$ac607276a8fe9f0a() {
    const window = (0, $58sFY.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css("height"));
    return null;
}
function $be50936c4ecb1713$export$fc5b8aac72846d1e(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue("margin-top")) + parseFloat(styles.getPropertyValue("margin-bottom"));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function $be50936c4ecb1713$export$cc800923e997bb8() {
    if (this.length > 0) {
        const window = (0, $58sFY.getWindow)();
        const document = (0, $58sFY.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function $be50936c4ecb1713$export$fe8985bb6374093c() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = "none";
    return this;
}
function $be50936c4ecb1713$export$57bf213be019eeb0() {
    const window = (0, $58sFY.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === "none") el.style.display = "";
        if (window.getComputedStyle(el, null).getPropertyValue("display") === "none") // Still not visible
        el.style.display = "block";
    }
    return this;
}
function $be50936c4ecb1713$export$9dd6ff9ea0189349() {
    const window = (0, $58sFY.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function $be50936c4ecb1713$export$dbf350e5966cf602(props, value) {
    const window = (0, $58sFY.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === "string") {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function $be50936c4ecb1713$export$79b2f7037acddd43(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function $be50936c4ecb1713$export$3dea766d36a8935f(callback) {
    const result = $be50936c4ecb1713$var$arrayFilter(this, callback);
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9(result);
}
function $be50936c4ecb1713$export$c0bb0b647f701bb5(html) {
    if (typeof html === "undefined") return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function $be50936c4ecb1713$export$6f093cfa640b7166(text) {
    if (typeof text === "undefined") return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function $be50936c4ecb1713$export$226b3eccf92c9ed9(selector) {
    const window = (0, $58sFY.getWindow)();
    const document = (0, $58sFY.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === "undefined") return false;
    if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $be50936c4ecb1713$export$3d8c2f653ac9d0b9(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof $be50936c4ecb1713$var$Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function $be50936c4ecb1713$export$b610b8812bbcded9() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $be50936c4ecb1713$export$9663ddc1cf085b32(index) {
    if (typeof index === "undefined") return this;
    const length = this.length;
    if (index > length - 1) return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
        return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([
            this[returnIndex]
        ]);
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([
        this[index]
    ]);
}
function $be50936c4ecb1713$export$10d8903dec122b9d(...els) {
    let newChild;
    const document = (0, $58sFY.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === "string") {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof $be50936c4ecb1713$var$Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function $be50936c4ecb1713$export$9ceefe31f12a3778(parent) {
    $be50936c4ecb1713$export$3d8c2f653ac9d0b9(parent).append(this);
    return this;
}
function $be50936c4ecb1713$export$68159836694e22c1(newChild) {
    const document = (0, $58sFY.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === "string") {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof $be50936c4ecb1713$var$Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function $be50936c4ecb1713$export$44da2b52169043ea(parent) {
    $be50936c4ecb1713$export$3d8c2f653ac9d0b9(parent).prepend(this);
    return this;
}
function $be50936c4ecb1713$export$86b68c7dbeb53c22(selector) {
    const before = $be50936c4ecb1713$export$3d8c2f653ac9d0b9(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function $be50936c4ecb1713$export$c4f94c8b3850a5a9(selector) {
    const after = $be50936c4ecb1713$export$3d8c2f653ac9d0b9(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function $be50936c4ecb1713$export$48cfd1e771a65c4f(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $be50936c4ecb1713$export$3d8c2f653ac9d0b9(this[0].nextElementSibling).is(selector)) return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([
                this[0].nextElementSibling
            ]);
            return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
        }
        if (this[0].nextElementSibling) return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([
            this[0].nextElementSibling
        ]);
        return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
}
function $be50936c4ecb1713$export$3cd99760d81ede63(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($be50936c4ecb1713$export$3d8c2f653ac9d0b9(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9(nextEls);
}
function $be50936c4ecb1713$export$232faf9add678146(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $be50936c4ecb1713$export$3d8c2f653ac9d0b9(el.previousElementSibling).is(selector)) return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([
                el.previousElementSibling
            ]);
            return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
        }
        if (el.previousElementSibling) return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([
            el.previousElementSibling
        ]);
        return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
}
function $be50936c4ecb1713$export$5a01ccd45552d0b4(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($be50936c4ecb1713$export$3d8c2f653ac9d0b9(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9(prevEls);
}
function $be50936c4ecb1713$export$9866dd70b0dcd4c3(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function $be50936c4ecb1713$export$91124bb58bc04465(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($be50936c4ecb1713$export$3d8c2f653ac9d0b9(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9(parents);
}
function $be50936c4ecb1713$export$7901f6cd558b9a93(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($be50936c4ecb1713$export$3d8c2f653ac9d0b9(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9(parents);
}
function $be50936c4ecb1713$export$ff7f7c97cdce86e(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === "undefined") return $be50936c4ecb1713$export$3d8c2f653ac9d0b9([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function $be50936c4ecb1713$export$71aa6c912b956294(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9(foundElements);
}
function $be50936c4ecb1713$export$bacb5cc5a11aef16(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $be50936c4ecb1713$export$3d8c2f653ac9d0b9(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $be50936c4ecb1713$export$3d8c2f653ac9d0b9(children);
}
function $be50936c4ecb1713$export$cd7f480d6b8286c3() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function $be50936c4ecb1713$export$3f780019ff766da6() {
    return this.remove();
}
function $be50936c4ecb1713$export$e16d8520af44a096(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $be50936c4ecb1713$export$3d8c2f653ac9d0b9(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function $be50936c4ecb1713$export$6e22c362a0406a2c() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = "";
        }
    }
    return this;
}
// eslint-disable-next-line
function $be50936c4ecb1713$export$3f99968195accfaf(...args) {
    const window = (0, $58sFY.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === "undefined") easing = "swing";
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") easing = "swing";
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === "linear" ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function $be50936c4ecb1713$export$3e0c8fa3b5e4b3b9(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function $be50936c4ecb1713$export$6eddf9bc7f2b7d80(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === "function") [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function $be50936c4ecb1713$export$e3607ec2d7a891c4(initialProps, initialParams) {
    const window = (0, $58sFY.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: "swing" // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === "swing") return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === "function") return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(",", ".");
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, "");
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue: initialValue, finalValue: finalValue, unit: unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === "stop") animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function $be50936c4ecb1713$export$fa6813432f753b0d() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const $be50936c4ecb1713$var$noTrigger = "resize scroll".split(" ");
function $be50936c4ecb1713$var$shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === "undefined") {
            for(let i = 0; i < this.length; i += 1)if ($be50936c4ecb1713$var$noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $be50936c4ecb1713$export$3d8c2f653ac9d0b9(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const $be50936c4ecb1713$export$64ef1bee2b9504c1 = $be50936c4ecb1713$var$shortcut("click");
const $be50936c4ecb1713$export$2cc7ff91bcacba5e = $be50936c4ecb1713$var$shortcut("blur");
const $be50936c4ecb1713$export$d7ddd398f22d79ef = $be50936c4ecb1713$var$shortcut("focus");
const $be50936c4ecb1713$export$e7fa4ea7f1bfcb53 = $be50936c4ecb1713$var$shortcut("focusin");
const $be50936c4ecb1713$export$d0dc5134b51e78ad = $be50936c4ecb1713$var$shortcut("focusout");
const $be50936c4ecb1713$export$d26052c770f81a55 = $be50936c4ecb1713$var$shortcut("keyup");
const $be50936c4ecb1713$export$e65a0c4970da3025 = $be50936c4ecb1713$var$shortcut("keydown");
const $be50936c4ecb1713$export$563caf6ae76a8875 = $be50936c4ecb1713$var$shortcut("keypress");
const $be50936c4ecb1713$export$853c27de4ce0f746 = $be50936c4ecb1713$var$shortcut("submit");
const $be50936c4ecb1713$export$d8a7b8f475ec0161 = $be50936c4ecb1713$var$shortcut("change");
const $be50936c4ecb1713$export$8b0cb8993e7a9391 = $be50936c4ecb1713$var$shortcut("mousedown");
const $be50936c4ecb1713$export$6d0a9e0f4f73830a = $be50936c4ecb1713$var$shortcut("mousemove");
const $be50936c4ecb1713$export$c367b5bd9b361db9 = $be50936c4ecb1713$var$shortcut("mouseup");
const $be50936c4ecb1713$export$474cd8abd87e2f89 = $be50936c4ecb1713$var$shortcut("mouseenter");
const $be50936c4ecb1713$export$996a190879e3098b = $be50936c4ecb1713$var$shortcut("mouseleave");
const $be50936c4ecb1713$export$c3a736a37c400eb8 = $be50936c4ecb1713$var$shortcut("mouseout");
const $be50936c4ecb1713$export$41b161f130dc7f9 = $be50936c4ecb1713$var$shortcut("mouseover");
const $be50936c4ecb1713$export$9f22968b38117503 = $be50936c4ecb1713$var$shortcut("touchstart");
const $be50936c4ecb1713$export$3c6ab5207a63e8f7 = $be50936c4ecb1713$var$shortcut("touchend");
const $be50936c4ecb1713$export$3086217c4efdbcc9 = $be50936c4ecb1713$var$shortcut("touchmove");
const $be50936c4ecb1713$export$4380c87abf28fdf = $be50936c4ecb1713$var$shortcut("resize");
const $be50936c4ecb1713$export$209876d7b1ac8f3 = $be50936c4ecb1713$var$shortcut("scroll");
var $be50936c4ecb1713$export$2e2bcd8739ae039 = $be50936c4ecb1713$export$3d8c2f653ac9d0b9;

});


parcelRequire.register("1EjTE", function(module, exports) {

$parcel$export(module.exports, "deleteProps", function () { return $1338f5f0d60fe216$export$8694e5c03a4df8e6; });
$parcel$export(module.exports, "nextTick", function () { return $1338f5f0d60fe216$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "now", function () { return $1338f5f0d60fe216$export$461939dd4422153; });
$parcel$export(module.exports, "getTranslate", function () { return $1338f5f0d60fe216$export$5ec402b7fcf74398; });
$parcel$export(module.exports, "isObject", function () { return $1338f5f0d60fe216$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "extend", function () { return $1338f5f0d60fe216$export$8b58be045bf06082; });
$parcel$export(module.exports, "setCSSProperty", function () { return $1338f5f0d60fe216$export$a607267f322101fd; });
$parcel$export(module.exports, "animateCSSModeScroll", function () { return $1338f5f0d60fe216$export$a5dd2b4b1a116d6d; });

var $58sFY = parcelRequire("58sFY");
function $1338f5f0d60fe216$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $1338f5f0d60fe216$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $1338f5f0d60fe216$export$461939dd4422153() {
    return Date.now();
}
function $1338f5f0d60fe216$export$3735103072e4a80(el) {
    const window1 = (0, $58sFY.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $1338f5f0d60fe216$export$5ec402b7fcf74398(el, axis = "x") {
    const window1 = (0, $58sFY.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $1338f5f0d60fe216$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $1338f5f0d60fe216$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $1338f5f0d60fe216$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $1338f5f0d60fe216$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$1338f5f0d60fe216$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($1338f5f0d60fe216$export$a6cdc56e425d0d0a(to[nextKey]) && $1338f5f0d60fe216$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $1338f5f0d60fe216$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$1338f5f0d60fe216$export$a6cdc56e425d0d0a(to[nextKey]) && $1338f5f0d60fe216$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $1338f5f0d60fe216$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $1338f5f0d60fe216$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $1338f5f0d60fe216$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $58sFY.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}

});

parcelRequire.register("ledMJ", function(module, exports) {

$parcel$export(module.exports, "getSupport", function () { return $f745992e8d1b1180$export$d61c7b85ff180578; });

var $58sFY = parcelRequire("58sFY");
let $f745992e8d1b1180$var$support;
function $f745992e8d1b1180$var$calcSupport() {
    const window = (0, $58sFY.getWindow)();
    const document = (0, $58sFY.getDocument)();
    return {
        smoothScroll: document.documentElement && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, "passive", {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener("testPassiveListener", null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return "ongesturestart" in window;
        }()
    };
}
function $f745992e8d1b1180$export$d61c7b85ff180578() {
    if (!$f745992e8d1b1180$var$support) $f745992e8d1b1180$var$support = $f745992e8d1b1180$var$calcSupport();
    return $f745992e8d1b1180$var$support;
}

});

parcelRequire.register("4rC3V", function(module, exports) {

$parcel$export(module.exports, "getDevice", function () { return $33c7356d035118c5$export$30c823bc834d6ab4; });

var $58sFY = parcelRequire("58sFY");

var $ledMJ = parcelRequire("ledMJ");
let $33c7356d035118c5$var$deviceCached;
function $33c7356d035118c5$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $ledMJ.getSupport)();
    const window = (0, $58sFY.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel"; // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    } // Export object
    return device;
}
function $33c7356d035118c5$export$30c823bc834d6ab4(overrides = {}) {
    if (!$33c7356d035118c5$var$deviceCached) $33c7356d035118c5$var$deviceCached = $33c7356d035118c5$var$calcDevice(overrides);
    return $33c7356d035118c5$var$deviceCached;
}

});

parcelRequire.register("lhE85", function(module, exports) {

$parcel$export(module.exports, "getBrowser", function () { return $f7ea505fdac53fb2$export$89e15fc796a4a429; });

var $58sFY = parcelRequire("58sFY");
let $f7ea505fdac53fb2$var$browser;
function $f7ea505fdac53fb2$var$calcBrowser() {
    const window = (0, $58sFY.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $f7ea505fdac53fb2$export$89e15fc796a4a429() {
    if (!$f7ea505fdac53fb2$var$browser) $f7ea505fdac53fb2$var$browser = $f7ea505fdac53fb2$var$calcBrowser();
    return $f7ea505fdac53fb2$var$browser;
}

});

parcelRequire.register("hoK65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caa86f81f75e9730$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");
function $caa86f81f75e9730$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $58sFY.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}

});

parcelRequire.register("5NIfu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4393da3adccaa7db$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");
function $4393da3adccaa7db$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $58sFY.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}

});

parcelRequire.register("3lgo1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26f00b4681ced12e$export$2e2bcd8739ae039; });
/* eslint-disable no-underscore-dangle */ var $26f00b4681ced12e$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};

});

parcelRequire.register("42aG2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2effa18fdcd4ebca$export$2e2bcd8739ae039; });

var $gXfEI = parcelRequire("gXfEI");

var $fdMLQ = parcelRequire("fdMLQ");

var $56ZNO = parcelRequire("56ZNO");

var $hIP6N = parcelRequire("hIP6N");

var $dW6z4 = parcelRequire("dW6z4");

var $5P2Nk = parcelRequire("5P2Nk");

var $1kvfj = parcelRequire("1kvfj");

var $KG4bf = parcelRequire("KG4bf");

var $9VeMF = parcelRequire("9VeMF");
var $2effa18fdcd4ebca$export$2e2bcd8739ae039 = {
    updateSize: $gXfEI.default,
    updateSlides: $fdMLQ.default,
    updateAutoHeight: $56ZNO.default,
    updateSlidesOffset: $hIP6N.default,
    updateSlidesProgress: $dW6z4.default,
    updateProgress: $5P2Nk.default,
    updateSlidesClasses: $1kvfj.default,
    updateActiveIndex: $KG4bf.default,
    updateClickedSlide: $9VeMF.default
};

});
parcelRequire.register("gXfEI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c57e4cf0a3cc0e9b$export$2e2bcd8739ae039; });
function $c57e4cf0a3cc0e9b$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css("padding-left") || 0, 10) - parseInt($el.css("padding-right") || 0, 10);
    height = height - parseInt($el.css("padding-top") || 0, 10) - parseInt($el.css("padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}

});

parcelRequire.register("fdMLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b14de6c650ce395b$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");
function $b14de6c650ce395b$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: "",
        marginBottom: "",
        marginTop: ""
    });
    else slides.css({
        marginRight: "",
        marginBottom: "",
        marginTop: ""
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $1EjTE.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-before", "");
        (0, $1EjTE.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css("display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = "none";
            if (currentWebKitTransform) slide[0].style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $1EjTE.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $1EjTE.setCSSProperty)(swiper.wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}

});

parcelRequire.register("56ZNO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b8d73f2acfa0ea0$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");
function $3b8d73f2acfa0ea0$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $24nTO.default)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css("height", `${newHeight}px`);
}

});

parcelRequire.register("hIP6N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce6e30db971b8f6a$export$2e2bcd8739ae039; });
function $ce6e30db971b8f6a$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}

});

parcelRequire.register("dW6z4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a255c8b825922753$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");
function $a255c8b825922753$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $24nTO.default)(swiper.visibleSlides);
}

});

parcelRequire.register("5P2Nk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43d3e22542fd4c38$export$2e2bcd8739ae039; });
function $43d3e22542fd4c38$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}

});

parcelRequire.register("1kvfj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f7fe5860e74601f$export$2e2bcd8739ae039; });
function $0f7fe5860e74601f$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr("data-swiper-slide-index")}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}

});

parcelRequire.register("KG4bf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08c4ed821325a44e$export$2e2bcd8739ae039; });
function $08c4ed821325a44e$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === "undefined") {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== "undefined") {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}

});

parcelRequire.register("9VeMF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7394e7bbbcd710e0$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");
function $7394e7bbbcd710e0$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $24nTO.default)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $24nTO.default)(slide).attr("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}

});


parcelRequire.register("lUFJw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff3f3346f9416381$export$2e2bcd8739ae039; });

var $1vNo4 = parcelRequire("1vNo4");

var $kCYKF = parcelRequire("kCYKF");

var $7THKu = parcelRequire("7THKu");

var $dzDR0 = parcelRequire("dzDR0");

var $dVcfr = parcelRequire("dVcfr");
var $ff3f3346f9416381$export$2e2bcd8739ae039 = {
    getTranslate: $1vNo4.default,
    setTranslate: $kCYKF.default,
    minTranslate: $7THKu.default,
    maxTranslate: $dzDR0.default,
    translateTo: $dVcfr.default
};

});
parcelRequire.register("1vNo4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $119efefc5c17e954$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");
function $119efefc5c17e954$export$2e2bcd8739ae039(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $1EjTE.getTranslate)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}

});

parcelRequire.register("kCYKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0467b48c9fa9010$export$2e2bcd8739ae039; });
function $f0467b48c9fa9010$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}

});

parcelRequire.register("7THKu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bff9b105f3a15ca$export$2e2bcd8739ae039; });
function $5bff9b105f3a15ca$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}

});

parcelRequire.register("dzDR0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e1d7562301634ad$export$2e2bcd8739ae039; });
function $9e1d7562301634ad$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}

});

parcelRequire.register("dVcfr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a22a1974ce4a087e$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");
function $a22a1974ce4a087e$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $1EjTE.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}

});


parcelRequire.register("59lEw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bfe96c57afe6ca0$export$2e2bcd8739ae039; });

var $kR0Vg = parcelRequire("kR0Vg");

var $488q8 = parcelRequire("488q8");

var $99Zle = parcelRequire("99Zle");
var $3bfe96c57afe6ca0$export$2e2bcd8739ae039 = {
    setTransition: $kR0Vg.default,
    transitionStart: $488q8.default,
    transitionEnd: $99Zle.default
};

});
parcelRequire.register("kR0Vg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2e9791e5099a2fd$export$2e2bcd8739ae039; });
function $f2e9791e5099a2fd$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit("setTransition", duration, byController);
}

});

parcelRequire.register("488q8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $301e70f0ee5514cd$export$2e2bcd8739ae039; });

var $4aOW6 = parcelRequire("4aOW6");
function $301e70f0ee5514cd$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $4aOW6.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}

});
parcelRequire.register("4aOW6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $309f9b76d4fd47ea$export$2e2bcd8739ae039; });
function $309f9b76d4fd47ea$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}

});


parcelRequire.register("99Zle", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ab48978240ea54a$export$2e2bcd8739ae039; });

var $4aOW6 = parcelRequire("4aOW6");
function $6ab48978240ea54a$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $4aOW6.default)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}

});


parcelRequire.register("itDrZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7398976190fd90b$export$2e2bcd8739ae039; });

var $OZIeq = parcelRequire("OZIeq");

var $cGTS6 = parcelRequire("cGTS6");

var $7Y909 = parcelRequire("7Y909");

var $3B7dt = parcelRequire("3B7dt");

var $dhKLJ = parcelRequire("dhKLJ");

var $fn7l8 = parcelRequire("fn7l8");

var $hk5na = parcelRequire("hk5na");
var $d7398976190fd90b$export$2e2bcd8739ae039 = {
    slideTo: $OZIeq.default,
    slideToLoop: $cGTS6.default,
    slideNext: $7Y909.default,
    slidePrev: $3B7dt.default,
    slideReset: $dhKLJ.default,
    slideToClosest: $fn7l8.default,
    slideToClickedSlide: $hk5na.default
};

});
parcelRequire.register("OZIeq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09948a6d2dc2571f$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");
function $09948a6d2dc2571f$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== "number" && typeof index !== "string") throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset"; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $1EjTE.animateCSSModeScroll)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener("webkitTransitionEnd", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}

});

parcelRequire.register("cGTS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93d4bf3a931cd83e$export$2e2bcd8739ae039; });
function $93d4bf3a931cd83e$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === "string") {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

});

parcelRequire.register("7Y909", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cd51e7a21111153$export$2e2bcd8739ae039; });
/* eslint no-unused-vars: "off" */ function $5cd51e7a21111153$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

});

parcelRequire.register("3B7dt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29ea6cd54fa440bc$export$2e2bcd8739ae039; });
/* eslint no-unused-vars: "off" */ function $29ea6cd54fa440bc$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

});

parcelRequire.register("dhKLJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ac1243abd623ac0$export$2e2bcd8739ae039; });
/* eslint no-unused-vars: "off" */ function $9ac1243abd623ac0$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

});

parcelRequire.register("fn7l8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b30eb28584e91039$export$2e2bcd8739ae039; });
/* eslint no-unused-vars: "off" */ function $b30eb28584e91039$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}

});

parcelRequire.register("hk5na", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c878d368de6346$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");

var $1EjTE = parcelRequire("1EjTE");
function $c9c878d368de6346$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $24nTO.default)(swiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $1EjTE.nextTick)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $1EjTE.nextTick)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}

});


parcelRequire.register("aSak5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ea6f47a36945eb6$export$2e2bcd8739ae039; });

var $3Gh7G = parcelRequire("3Gh7G");

var $7AnfI = parcelRequire("7AnfI");

var $5gsL1 = parcelRequire("5gsL1");
var $7ea6f47a36945eb6$export$2e2bcd8739ae039 = {
    loopCreate: $3Gh7G.default,
    loopFix: $7AnfI.default,
    loopDestroy: $5gsL1.default
};

});
parcelRequire.register("3Gh7G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ae2939469a141d4$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");
function $2ae2939469a141d4$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $58sFY.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $24nTO.default)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $24nTO.default)(document.createElement("div")).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === "auto" && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $24nTO.default)(el);
        slide.attr("data-swiper-slide-index", index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $24nTO.default)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $24nTO.default)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}

});

parcelRequire.register("7AnfI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $585deea5b955cef7$export$2e2bcd8739ae039; });
function $585deea5b955cef7$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit("beforeLoopFix");
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
}

});

parcelRequire.register("5gsL1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d54c101ba970f47$export$2e2bcd8739ae039; });
function $3d54c101ba970f47$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr("data-swiper-slide-index");
}

});


parcelRequire.register("61axM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $012177cdd3ce0659$export$2e2bcd8739ae039; });

var $3mSh2 = parcelRequire("3mSh2");

var $aozqy = parcelRequire("aozqy");
var $012177cdd3ce0659$export$2e2bcd8739ae039 = {
    setGrabCursor: $3mSh2.default,
    unsetGrabCursor: $aozqy.default
};

});
parcelRequire.register("3mSh2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273d86d6596c268d$export$2e2bcd8739ae039; });
function $273d86d6596c268d$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
}

});

parcelRequire.register("aozqy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7917a06587c5c882$export$2e2bcd8739ae039; });
function $7917a06587c5c882$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
}

});


parcelRequire.register("lrPYL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9d4708c1dfbfc0b$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $97DRT = parcelRequire("97DRT");

var $ex2Z8 = parcelRequire("ex2Z8");

var $1OTa3 = parcelRequire("1OTa3");

var $kXZZT = parcelRequire("kXZZT");

var $35dR0 = parcelRequire("35dR0");

var $19FtL = parcelRequire("19FtL");
let $f9d4708c1dfbfc0b$var$dummyEventAttached = false;
function $f9d4708c1dfbfc0b$var$dummyEventListener() {}
const $f9d4708c1dfbfc0b$var$events = (swiper, method)=>{
    const document = (0, $58sFY.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === "touchstart" && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $kXZZT.default), true);
    else swiper[swiperMethod]("observerUpdate", (0, $kXZZT.default), true);
};
function $f9d4708c1dfbfc0b$var$attachEvents() {
    const swiper = this;
    const document = (0, $58sFY.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $97DRT.default).bind(swiper);
    swiper.onTouchMove = (0, $ex2Z8.default).bind(swiper);
    swiper.onTouchEnd = (0, $1OTa3.default).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $19FtL.default).bind(swiper);
    swiper.onClick = (0, $35dR0.default).bind(swiper);
    if (support.touch && !$f9d4708c1dfbfc0b$var$dummyEventAttached) {
        document.addEventListener("touchstart", $f9d4708c1dfbfc0b$var$dummyEventListener);
        $f9d4708c1dfbfc0b$var$dummyEventAttached = true;
    }
    $f9d4708c1dfbfc0b$var$events(swiper, "on");
}
function $f9d4708c1dfbfc0b$var$detachEvents() {
    const swiper = this;
    $f9d4708c1dfbfc0b$var$events(swiper, "off");
}
var $f9d4708c1dfbfc0b$export$2e2bcd8739ae039 = {
    attachEvents: $f9d4708c1dfbfc0b$var$attachEvents,
    detachEvents: $f9d4708c1dfbfc0b$var$detachEvents
};

});
parcelRequire.register("97DRT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a43b17d59f348c6$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");

var $1EjTE = parcelRequire("1EjTE");
function $6a43b17d59f348c6$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $58sFY.getDocument)() || el === (0, $58sFY.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $6a43b17d59f348c6$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $58sFY.getDocument)();
    const window = (0, $58sFY.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $24nTO.default)(e.target);
    if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === "touchstart";
    if (!data.isTouchEvent && "which" in e && e.which === 3) return;
    if (!data.isTouchEvent && "button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ""; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $24nTO.default)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $6a43b17d59f348c6$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $1EjTE.now)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== "touchstart") {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === "SELECT") data.isTouched = false;
        }
        if (document.activeElement && (0, $24nTO.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}

});

parcelRequire.register("ex2Z8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02baf1653270db8e$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");

var $1EjTE = parcelRequire("1EjTE");
function $02baf1653270db8e$export$2e2bcd8739ae039(event) {
    const document = (0, $58sFY.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    if (data.isTouchEvent && e.type !== "touchmove") return;
    const targetTouch = e.type === "touchmove" && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
    const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $24nTO.default)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $1EjTE.now)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $24nTO.default)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}

});

parcelRequire.register("1OTa3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15353fd53fa0afb1$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");
function $15353fd53fa0afb1$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $1EjTE.now)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $1EjTE.now)();
    (0, $1EjTE.nextTick)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}

});

parcelRequire.register("kXZZT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43968ae768025a8$export$2e2bcd8739ae039; });
function $f43968ae768025a8$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}

});

parcelRequire.register("35dR0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23ec95d99b99a94a$export$2e2bcd8739ae039; });
function $23ec95d99b99a94a$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}

});

parcelRequire.register("19FtL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d76ce9bb77be3f2$export$2e2bcd8739ae039; });
function $0d76ce9bb77be3f2$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}

});


parcelRequire.register("lWyhG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff999bdc5ea561ff$export$2e2bcd8739ae039; });

var $bGu4B = parcelRequire("bGu4B");

var $7ogML = parcelRequire("7ogML");
var $ff999bdc5ea561ff$export$2e2bcd8739ae039 = {
    setBreakpoint: $bGu4B.default,
    getBreakpoint: $7ogML.default
};

});
parcelRequire.register("bGu4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $881af1db6e44c2b5$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");
const $881af1db6e44c2b5$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $881af1db6e44c2b5$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $881af1db6e44c2b5$var$isGridEnabled(swiper, params);
    const isMultiRow = $881af1db6e44c2b5$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $1EjTE.extend)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit("breakpoint", breakpointParams);
}

});

parcelRequire.register("7ogML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5617cb898a0f8fe0$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");
function $5617cb898a0f8fe0$export$2e2bcd8739ae039(breakpoints, base = "window", containerEl) {
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $58sFY.getWindow)();
    const currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}

});


parcelRequire.register("9Vwwo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73a2aa00ea89ae97$export$2e2bcd8739ae039; });

var $g0Bml = parcelRequire("g0Bml");

var $8Ubu7 = parcelRequire("8Ubu7");
var $73a2aa00ea89ae97$export$2e2bcd8739ae039 = {
    addClasses: $g0Bml.default,
    removeClasses: $8Ubu7.default
};

});
parcelRequire.register("g0Bml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba79a0353521e453$export$2e2bcd8739ae039; });
function $ba79a0353521e453$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $ba79a0353521e453$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $ba79a0353521e453$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "pointer-events": !support.touch
        },
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(" "));
    swiper.emitContainerClasses();
}

});

parcelRequire.register("8Ubu7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67bc7655f50fd7fe$export$2e2bcd8739ae039; });
function $67bc7655f50fd7fe$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(" "));
    swiper.emitContainerClasses();
}

});


parcelRequire.register("66U5O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $472ed07d5829f35b$export$2e2bcd8739ae039; });

var $l7DWr = parcelRequire("l7DWr");

var $jHAg5 = parcelRequire("jHAg5");
var $472ed07d5829f35b$export$2e2bcd8739ae039 = {
    loadImage: $l7DWr.default,
    preloadImages: $jHAg5.default
};

});
parcelRequire.register("l7DWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6093bfe5ae71b99$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");
function $f6093bfe5ae71b99$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $58sFY.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $24nTO.default)(imageEl).parent("picture")[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}

});

parcelRequire.register("jHAg5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e57e28a5b381e75d$export$2e2bcd8739ae039; });
function $e57e28a5b381e75d$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find("img");
    function onReady() {
        if (typeof swiper === "undefined" || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit("imagesReady");
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute("src"), imageEl.srcset || imageEl.getAttribute("srcset"), imageEl.sizes || imageEl.getAttribute("sizes"), true, onReady);
    }
}

});


parcelRequire.register("h5TWE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c71e4cd26750bb38$export$2e2bcd8739ae039; });
function $c71e4cd26750bb38$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $c71e4cd26750bb38$export$2e2bcd8739ae039 = {
    checkOverflow: $c71e4cd26750bb38$var$checkOverflow
};

});

parcelRequire.register("959nv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69cbdaf801d551aa$export$2e2bcd8739ae039; });
var $69cbdaf801d551aa$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};

});

parcelRequire.register("6gDqh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4902d140bb7ee8d5$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");
function $4902d140bb7ee8d5$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $1EjTE.extend)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $1EjTE.extend)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $1EjTE.extend)(allModulesParams, obj);
    };
}

});


parcelRequire.register("8yLOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63b697fb1df2e4b2$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");

var $1EjTE = parcelRequire("1EjTE");
function $63b697fb1df2e4b2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $24nTO.default)(params.renderSlide.call(swiper, slide, index)) : (0, $24nTO.default)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr("data-swiper-slide-index")) $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === "undefined" || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children(".swiper-slide").css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
                if (cachedElIndex) $cachedEl.attr("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $1EjTE.setCSSProperty)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}

});

parcelRequire.register("30g62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22fddb9675a62d77$export$2e2bcd8739ae039; });
/* eslint-disable consistent-return */ 
var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");
function $22fddb9675a62d77$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $58sFY.getDocument)();
    const window = (0, $58sFY.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $24nTO.default)(document).on("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $24nTO.default)(document).off("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}

});

parcelRequire.register("83sVu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dd50aafd6ca9eb8$export$2e2bcd8739ae039; });
/* eslint-disable consistent-return */ 
var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");

var $1EjTE = parcelRequire("1EjTE");
function $5dd50aafd6ca9eb8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $58sFY.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $1EjTE.now)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $1EjTE.now)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $1EjTE.now)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $24nTO.default)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $1EjTE.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $1EjTE.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $1EjTE.nextTick)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $1EjTE.nextTick)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit("scroll", e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") target = (0, $24nTO.default)(swiper.params.mousewheel.eventsTarget);
        target[method]("mouseenter", handleMouseEnter);
        target[method]("mouseleave", handleMouseLeave);
        target[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("on");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("off");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}

});

parcelRequire.register("9WMMt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73df5eb817a37a3a$export$2e2bcd8739ae039; });

var $kYZkc = parcelRequire("kYZkc");

var $24nTO = parcelRequire("24nTO");
function $73df5eb817a37a3a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $24nTO.default)(el);
            if (swiper.params.uniqueNavElements && typeof el === "string" && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
            if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $kYZkc.default)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on("click", onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on("click", onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off("click", onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off("click", onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? "removeClass" : "addClass"](swiper.params.navigation.lockClass);
    });
    on("click", (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $24nTO.default)(targetEl).is($prevEl) && !(0, $24nTO.default)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRequire.register("kYZkc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f468fb17181f9684$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");
function $f468fb17181f9684$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $58sFY.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement("div");
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

});


parcelRequire.register("b8pg8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81b40901656d9843$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");

var $9SBI0 = parcelRequire("9SBI0");

var $kYZkc = parcelRequire("kYZkc");
function $81b40901656d9843$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== "bullets") current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
                $el.css(swiper.isHorizontal() ? "width" : "height", `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                "",
                "-next",
                "-next-next",
                "-prev",
                "-prev-prev",
                "-main"
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(" "));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $24nTO.default)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets($bullet, "next");
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, "prev");
                            setSideBullets($lastDisplayedBullet, "next");
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, "prev");
                        setSideBullets($lastDisplayedBullet, "next");
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.css(swiper.isHorizontal() ? offsetProp : "top", `${bulletsOffset}px`);
            }
        }
        if (params.type === "fraction") {
            $el.find((0, $9SBI0.default)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $9SBI0.default)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
            else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === "horizontal") scaleX = scale;
            else scaleY = scale;
            $el.find((0, $9SBI0.default)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit("paginationRender", $el[0]);
        } else emit("paginationUpdate", $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $9SBI0.default)(params.bulletClass));
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== "custom") emit("paginationRender", swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $kYZkc.default)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $24nTO.default)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $24nTO.default)(el).parents(".swiper")[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === "bullets" && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === "bullets" && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === "progressbar" && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on("click", (0, $9SBI0.default)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $24nTO.default)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off("click", (0, $9SBI0.default)(params.bulletClass));
    }
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        if (!swiper.params.loop) update();
    });
    on("slidesLengthChange", ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on("snapGridLengthChange", ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.pagination.lockClass);
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $24nTO.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRequire.register("9SBI0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73166865f7b54cd7$export$2e2bcd8739ae039; });
function $73166865f7b54cd7$export$2e2bcd8739ae039(classes = "") {
    return `.${classes.trim().replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}

});


parcelRequire.register("YTZEf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b7109d1c8f39f1a$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");

var $1EjTE = parcelRequire("1EjTE");

var $kYZkc = parcelRequire("kYZkc");
function $0b7109d1c8f39f1a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $58sFY.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = "none";
        else $el[0].style.display = "";
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientX : e.clientX;
        return e.type === "touchstart" || e.type === "touchmove" ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css("opacity", 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css("scroll-snap-type", "none");
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css("scroll-snap-type", "");
            $wrapperEl.transition("");
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $1EjTE.nextTick)(()=>{
                $el.css("opacity", 0);
                $el.transition(400);
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $kYZkc.default)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $24nTO.default)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $24nTO.default)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? "removeClass" : "addClass"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}

});

parcelRequire.register("kAoeR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efc9f8b9ad992202$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");
function $efc9f8b9ad992202$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $24nTO.default)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr("data-swiper-parallax") || "0";
        let x = $el.attr("data-swiper-parallax-x");
        let y = $el.attr("data-swiper-parallax-y");
        const scale = $el.attr("data-swiper-parallax-scale");
        const opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $24nTO.default)(slideEl).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each((parallaxEl)=>{
            const $parallaxEl = (0, $24nTO.default)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

});

parcelRequire.register("3EEOo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a94c3e88f1ccd22$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");

var $1EjTE = parcelRequire("1EjTE");
function $2a94c3e88f1ccd22$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $58sFY.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== "touchstart" || e.type === "touchstart" && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $24nTO.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== "touchmove" || e.type === "touchmove" && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === "gesturechange") onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== "touchend" || e.type === "touchend" && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $1EjTE.getTranslate)(gesture.$imageWrapEl[0], "x") || 0;
            image.startY = (0, $1EjTE.getTranslate)(gesture.$imageWrapEl[0], "y") || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform("translate3d(0,0,0)");
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $24nTO.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === "touchstart" && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]("gesturestart", slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]("gesturechange", slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]("gestureend", slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures("on");
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures("off");
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === "touchstart") {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

});

parcelRequire.register("cOWzW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9557980825b2aeb1$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");
function $9557980825b2aeb1$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: "",
            elementClass: "swiper-lazy",
            loadingClass: "swiper-lazy-loading",
            loadedClass: "swiper-lazy-loaded",
            preloaderClass: "swiper-lazy-preloader"
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $24nTO.default)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr("data-background");
            const src = $imageEl.attr("data-src");
            const srcset = $imageEl.attr("data-srcset");
            const sizes = $imageEl.attr("data-sizes");
            const $pictureEl = $imageEl.parent("picture");
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === "undefined" || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css("background-image", `url("${background}")`);
                    $imageEl.removeAttr("data-background");
                } else {
                    if (srcset) {
                        $imageEl.attr("srcset", srcset);
                        $imageEl.removeAttr("data-srcset");
                    }
                    if (sizes) {
                        $imageEl.attr("sizes", sizes);
                        $imageEl.removeAttr("data-sizes");
                    }
                    if ($pictureEl.length) $pictureEl.children("source").each((sourceEl)=>{
                        const $source = (0, $24nTO.default)(sourceEl);
                        if ($source.attr("data-srcset")) {
                            $source.attr("srcset", $source.attr("data-srcset"));
                            $source.removeAttr("data-srcset");
                        }
                    });
                    if (src) {
                        $imageEl.attr("src", src);
                        $imageEl.removeAttr("data-src");
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr("data-swiper-slide-index");
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit("lazyImageReady", $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $24nTO.default)(slideEl).attr("data-swiper-slide-index");
            return (0, $24nTO.default)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $24nTO.default)(slideEl).attr("data-swiper-slide-index") : (0, $24nTO.default)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $58sFY.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $24nTO.default)(swiper.params.lazy.scrollingElement) : (0, $24nTO.default)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === "touchstart" && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
        }
    }
    on("beforeInit", ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on("init", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("scroll", ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on("scrollbarDragMove resize _freeModeNoMomentumRelease", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("transitionStart", ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on("transitionEnd", ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on("slideChange", ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on("destroy", ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}

});

parcelRequire.register("fmgxr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2e5bd4620659e33$export$2e2bcd8739ae039; });
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
var $1EjTE = parcelRequire("1EjTE");
function $b2e5bd4620659e33$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $1EjTE.nextTick)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === "slide") c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}

});

parcelRequire.register("03NU9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00b6fdf3534059fe$export$2e2bcd8739ae039; });

var $9SBI0 = parcelRequire("9SBI0");

var $24nTO = parcelRequire("24nTO");
function $00b6fdf3534059fe$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
    }
    function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
    }
    function addElRole($el, role) {
        $el.attr("role", role);
    }
    function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
    }
    function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
    }
    function addElLabel($el, label) {
        $el.attr("aria-label", label);
    }
    function addElId($el, id) {
        $el.attr("id", id);
    }
    function addElLive($el, live) {
        $el.attr("aria-live", live);
    }
    function disableEl($el) {
        $el.attr("aria-disabled", true);
    }
    function enableEl($el) {
        $el.attr("aria-disabled", false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $24nTO.default)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $9SBI0.default)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $24nTO.default)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, "button");
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr("aria-current", "true");
            else $bulletEl.removeAttr("aria-current");
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== "BUTTON") {
            addElRole($el, "button");
            $el.on("keydown", onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $24nTO.default)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $24nTO.default)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $24nTO.default)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on("keydown", (0, $9SBI0.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on("focus", handleFocus, true);
        swiper.$el.on("pointerdown", handlePointerDown, true);
        swiper.$el.on("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off("keydown", onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off("keydown", onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off("keydown", (0, $9SBI0.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off("focus", handleFocus, true);
        swiper.$el.off("pointerdown", handlePointerDown, true);
        swiper.$el.off("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $24nTO.default)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

});

parcelRequire.register("7GhHM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $597a308a3fedaecc$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");
function $597a308a3fedaecc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $58sFY.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $58sFY.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr("data-history"));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $58sFY.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $58sFY.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

});

parcelRequire.register("4wI1J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34bc4d6807295200$export$2e2bcd8739ae039; });

var $58sFY = parcelRequire("58sFY");

var $24nTO = parcelRequire("24nTO");
function $34bc4d6807295200$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $58sFY.getDocument)();
    const window = (0, $58sFY.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr("data-hash");
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === "undefined") return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr("data-hash")}` || "");
            emit("hashSet");
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr("data-hash") || slide.attr("data-history");
            document.location.hash = hash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr("data-hash") || slide.attr("data-history");
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $24nTO.default)(window).on("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $24nTO.default)(window).off("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

});

parcelRequire.register("aKPtp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d4620c4aa49e0e0$export$2e2bcd8739ae039; });
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $58sFY = parcelRequire("58sFY");

var $1EjTE = parcelRequire("1EjTE");
function $7d4620c4aa49e0e0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) delay = $activeSlideEl.attr("data-swiper-autoplay") || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $1EjTE.nextTick)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit("autoplay");
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit("autoplay");
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit("autoplayStart");
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === "undefined") return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit("autoplayStop");
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $58sFY.getDocument)();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) pause();
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit("autoplayPause");
            pause();
        }
        [
            "transitionend",
            "webkitTransitionEnd"
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit("autoplayResume");
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on("mouseenter", onMouseEnter);
            swiper.$el.on("mouseleave", onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off("mouseenter", onMouseEnter);
        swiper.$el.off("mouseleave", onMouseLeave);
    }
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $58sFY.getDocument)();
            document.addEventListener("visibilitychange", onVisibilityChange);
            attachMouseEvents();
        }
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on("sliderFirstMove", ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on("touchEnd", ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on("destroy", ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $58sFY.getDocument)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}

});

parcelRequire.register("bRKLr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a38eb54cad30271$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");

var $24nTO = parcelRequire("24nTO");
function $8a38eb54cad30271$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $24nTO.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $24nTO.default)(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
            else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $1EjTE.isObject)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === "undefined") newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === "undefined") newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}

});

parcelRequire.register("f36ow", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af4c18a3e248131c$export$2e2bcd8739ae039; });

var $1EjTE = parcelRequire("1EjTE");
function $af4c18a3e248131c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $1EjTE.now)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $1EjTE.now)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $1EjTE.now)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}

});

parcelRequire.register("aiDHc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77fa60978fb4db69$export$2e2bcd8739ae039; });
function $77fa60978fb4db69$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                "-webkit-order": newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel("margin-top"), row !== 0 ? spaceBetween && `${spaceBetween}px` : "");
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel("width")]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}

});

parcelRequire.register("cfI62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eb9175b35adb905$export$2e2bcd8739ae039; });

var $l0Zfj = parcelRequire("l0Zfj");

var $3rkwo = parcelRequire("3rkwo");

var $25OJB = parcelRequire("25OJB");

var $9JMn0 = parcelRequire("9JMn0");

var $QbhcQ = parcelRequire("QbhcQ");
function $8eb9175b35adb905$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $l0Zfj.default).bind(swiper),
        prependSlide: (0, $3rkwo.default).bind(swiper),
        addSlide: (0, $25OJB.default).bind(swiper),
        removeSlide: (0, $9JMn0.default).bind(swiper),
        removeAllSlides: (0, $QbhcQ.default).bind(swiper)
    });
}

});
parcelRequire.register("l0Zfj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4c91b3b7f316ab7$export$2e2bcd8739ae039; });
function $f4c91b3b7f316ab7$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}

});

parcelRequire.register("3rkwo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2813cfd83c41305e$export$2e2bcd8739ae039; });
function $2813cfd83c41305e$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRequire.register("25OJB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18636735d4558718$export$2e2bcd8739ae039; });
function $18636735d4558718$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRequire.register("9JMn0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $716dd64e8af94877$export$2e2bcd8739ae039; });
function $716dd64e8af94877$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

});

parcelRequire.register("QbhcQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09cd9ab98ba19d8c$export$2e2bcd8739ae039; });
function $09cd9ab98ba19d8c$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}

});


parcelRequire.register("gLF5N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c350e93cde64b627$export$2e2bcd8739ae039; });

var $cYG3S = parcelRequire("cYG3S");

var $e4VWZ = parcelRequire("e4VWZ");

var $4m87x = parcelRequire("4m87x");
function $c350e93cde64b627$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $e4VWZ.default)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $4m87x.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $cYG3S.default)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRequire.register("cYG3S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $972bb72b4792baa3$export$2e2bcd8739ae039; });
function $972bb72b4792baa3$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

});

parcelRequire.register("e4VWZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3fe64242580cf29$export$2e2bcd8739ae039; });
function $a3fe64242580cf29$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        "backface-visibility": "hidden",
        "-webkit-backface-visibility": "hidden"
    });
    return $slideEl;
}

});

parcelRequire.register("4m87x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32bf8419d687a016$export$2e2bcd8739ae039; });
function $32bf8419d687a016$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                "webkitTransitionEnd",
                "transitionend"
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}

});


parcelRequire.register("cvfCB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91a47f6635ab6e34$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");

var $cYG3S = parcelRequire("cYG3S");
function $91a47f6635ab6e34$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $24nTO.default)(`<div class="swiper-slide-shadow-${isHorizontal ? "left" : "top"}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $24nTO.default)(`<div class="swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $24nTO.default)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $24nTO.default)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find(".swiper-cube-shadow");
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $24nTO.default)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            "-webkit-transform-origin": `50% 50% -${swiperSize / 2}px`,
            "transform-origin": `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find(".swiper-cube-shadow").transition(duration);
    };
    (0, $cYG3S.default)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

});

parcelRequire.register("4XBnY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c9ac1e5fc0a929$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");

var $eCKkc = parcelRequire("eCKkc");

var $cYG3S = parcelRequire("cYG3S");

var $e4VWZ = parcelRequire("e4VWZ");

var $4m87x = parcelRequire("4m87x");
function $39c9ac1e5fc0a929$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) shadowBefore = (0, $eCKkc.default)(params, $slideEl, swiper.isHorizontal() ? "left" : "top");
        if (shadowAfter.length === 0) shadowAfter = (0, $eCKkc.default)(params, $slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $24nTO.default)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $e4VWZ.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
        (0, $4m87x.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $cYG3S.default)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRequire.register("eCKkc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa588c71d5569b8d$export$2e2bcd8739ae039; });

var $24nTO = parcelRequire("24nTO");
function $aa588c71d5569b8d$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $24nTO.default)(`<div class="swiper-slide-shadow${side ? `-${side}` : ""}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}

});


parcelRequire.register("fQuuL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8935e0ef97f22e7$export$2e2bcd8739ae039; });

var $eCKkc = parcelRequire("eCKkc");

var $cYG3S = parcelRequire("cYG3S");

var $e4VWZ = parcelRequire("e4VWZ");
function $b8935e0ef97f22e7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $e4VWZ.default)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-left") : $slideEl.find(".swiper-slide-shadow-top");
                let $shadowAfterEl = isHorizontal ? $slideEl.find(".swiper-slide-shadow-right") : $slideEl.find(".swiper-slide-shadow-bottom");
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $eCKkc.default)(params, $slideEl, isHorizontal ? "left" : "top");
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $eCKkc.default)(params, $slideEl, isHorizontal ? "right" : "bottom");
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(duration);
    };
    (0, $cYG3S.default)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

});

parcelRequire.register("k5zRe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea0016d2f975bd19$export$2e2bcd8739ae039; });

var $eCKkc = parcelRequire("eCKkc");

var $cYG3S = parcelRequire("cYG3S");

var $e4VWZ = parcelRequire("e4VWZ");

var $4m87x = parcelRequire("4m87x");
function $ea0016d2f975bd19$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children(".swiper-slide-shadow");
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $eCKkc.default)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $e4VWZ.default)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css("transform-origin", data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $4m87x.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $cYG3S.default)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});

parcelRequire.register("cYKtI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $972f243acdc28125$export$2e2bcd8739ae039; });

var $eCKkc = parcelRequire("eCKkc");

var $cYG3S = parcelRequire("cYG3S");

var $e4VWZ = parcelRequire("e4VWZ");

var $4m87x = parcelRequire("4m87x");
function $972f243acdc28125$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find(".swiper-slide-shadow");
                if ($shadowEl.length === 0) $shadowEl = (0, $eCKkc.default)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $e4VWZ.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find(".swiper-slide-shadow").transition(duration);
        (0, $4m87x.default)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $cYG3S.default)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});


parcelRequire.register("24sIZ", function(module, exports) {
"object" == typeof navigator && function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    function e(e, t, i) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var s = i.call(e, t || "default");
                    if ("object" != typeof s) return s;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
            }(e, "string");
            return "symbol" == typeof t ? t : String(t);
        }(t)) in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function t(e, t) {
        for(var i = 0; i < t.length; i++){
            var s = t[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    function i(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function s(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t && (s = s.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), i.push.apply(i, s);
        }
        return i;
    }
    function n(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function(t) {
                i(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var a = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    var l = function(e) {
        return null != e ? e.constructor : null;
    }, r = function(e, t) {
        return !!(e && t && e instanceof t);
    }, o = function(e) {
        return null == e;
    }, c = function(e) {
        return l(e) === Object;
    }, u = function(e) {
        return l(e) === String;
    }, h = function(e) {
        return Array.isArray(e);
    }, d = function(e) {
        return r(e, NodeList);
    }, m = {
        nullOrUndefined: o,
        object: c,
        number: function(e) {
            return l(e) === Number && !Number.isNaN(e);
        },
        string: u,
        boolean: function(e) {
            return l(e) === Boolean;
        },
        function: function(e) {
            return l(e) === Function;
        },
        array: h,
        nodeList: d,
        element: function(e) {
            return r(e, Element);
        },
        event: function(e) {
            return r(e, Event);
        },
        empty: function(e) {
            return o(e) || (u(e) || h(e) || d(e)) && !e.length || c(e) && !Object.keys(e).length;
        }
    };
    function p(e, t) {
        if (1 > t) {
            var i = function(e) {
                var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
            }(t);
            return parseFloat(e.toFixed(i));
        }
        return Math.round(e / t) * t;
    }
    var g = function() {
        function e(t, i) {
            (function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e), m.element(t) ? this.element = t : m.string(t) && (this.element = document.querySelector(t)), m.element(this.element) && m.empty(this.element.rangeTouch) && (this.config = n({}, a, {}, i), this.init());
        }
        return function(e, i, s) {
            i && t(e.prototype, i), s && t(e, s);
        }(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, i = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[i](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !m.event(t)) return null;
                    var i, s = t.target, n = t.changedTouches[0], a = parseFloat(s.getAttribute("min")) || 0, l = parseFloat(s.getAttribute("max")) || 100, r = parseFloat(s.getAttribute("step")) || 1, o = s.getBoundingClientRect(), c = 100 / o.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (i = 100 / o.width * (n.clientX - o.left)) ? i = 0 : 100 < i && (i = 100), 50 > i ? i -= (100 - 2 * i) * c : 50 < i && (i += 2 * (i - 50) * c), a + p(i / 100 * (l - a), r);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && m.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), function(e, t) {
                        if (e && t) {
                            var i = new Event(t, {
                                bubbles: !0
                            });
                            e.dispatchEvent(i);
                        }
                    }(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s = null;
                    if (m.empty(t) || m.string(t) ? s = Array.from(document.querySelectorAll(m.string(t) ? t : 'input[type="range"]')) : m.element(t) ? s = [
                        t
                    ] : m.nodeList(t) ? s = Array.from(t) : m.array(t) && (s = t.filter(m.element)), m.empty(s)) return null;
                    var l = n({}, a, {}, i);
                    if (m.string(t) && l.watch) {
                        var r = new MutationObserver(function(i) {
                            Array.from(i).forEach(function(i) {
                                Array.from(i.addedNodes).forEach(function(i) {
                                    m.element(i) && function(e, t) {
                                        return (function() {
                                            return Array.from(document.querySelectorAll(t)).includes(this);
                                        }).call(e, t);
                                    }(i, t) && new e(i, l);
                                });
                            });
                        });
                        r.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return s.map(function(t) {
                        return new e(t, i);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    const f = (e)=>null != e ? e.constructor : null, y = (e, t)=>Boolean(e && t && e instanceof t), b = (e)=>null == e, v = (e)=>f(e) === Object, w = (e)=>f(e) === String, T = (e)=>"function" == typeof e, k = (e)=>Array.isArray(e), C = (e)=>y(e, NodeList), A = (e)=>b(e) || (w(e) || k(e) || C(e)) && !e.length || v(e) && !Object.keys(e).length;
    var S = {
        nullOrUndefined: b,
        object: v,
        number: (e)=>f(e) === Number && !Number.isNaN(e),
        string: w,
        boolean: (e)=>f(e) === Boolean,
        function: T,
        array: k,
        weakMap: (e)=>y(e, WeakMap),
        nodeList: C,
        element: (e)=>null !== e && "object" == typeof e && 1 === e.nodeType && "object" == typeof e.style && "object" == typeof e.ownerDocument,
        textNode: (e)=>f(e) === Text,
        event: (e)=>y(e, Event),
        keyboardEvent: (e)=>y(e, KeyboardEvent),
        cue: (e)=>y(e, window.TextTrackCue) || y(e, window.VTTCue),
        track: (e)=>y(e, TextTrack) || !b(e) && w(e.kind),
        promise: (e)=>y(e, Promise) && T(e.then),
        url: (e)=>{
            if (y(e, window.URL)) return !0;
            if (!w(e)) return !1;
            let t = e;
            e.startsWith("http://") && e.startsWith("https://") || (t = `http://${e}`);
            try {
                return !A(new URL(t).hostname);
            } catch (e) {
                return !1;
            }
        },
        empty: A
    };
    const E = (()=>{
        const e = document.createElement("span"), t = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        }, i = Object.keys(t).find((t)=>void 0 !== e.style[t]);
        return !!S.string(i) && t[i];
    })();
    function P(e, t) {
        setTimeout(()=>{
            try {
                e.hidden = !0, e.offsetHeight, e.hidden = !1;
            } catch (e) {}
        }, t);
    }
    var M = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebKit: "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIPadOS: "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    function N(e, t) {
        return t.split(".").reduce((e, t)=>e && e[t], e);
    }
    function x(e = {}, ...t) {
        if (!t.length) return e;
        const i = t.shift();
        return S.object(i) ? (Object.keys(i).forEach((t)=>{
            S.object(i[t]) ? (Object.keys(e).includes(t) || Object.assign(e, {
                [t]: {}
            }), x(e[t], i[t])) : Object.assign(e, {
                [t]: i[t]
            });
        }), x(e, ...t)) : e;
    }
    function L(e, t) {
        const i = e.length ? e : [
            e
        ];
        Array.from(i).reverse().forEach((e, i)=>{
            const s = i > 0 ? t.cloneNode(!0) : t, n = e.parentNode, a = e.nextSibling;
            s.appendChild(e), a ? n.insertBefore(s, a) : n.appendChild(s);
        });
    }
    function I(e, t) {
        S.element(e) && !S.empty(t) && Object.entries(t).filter(([, e])=>!S.nullOrUndefined(e)).forEach(([t, i])=>e.setAttribute(t, i));
    }
    function $(e, t, i) {
        const s = document.createElement(e);
        return S.object(t) && I(s, t), S.string(i) && (s.innerText = i), s;
    }
    function _(e, t, i, s) {
        S.element(t) && t.appendChild($(e, i, s));
    }
    function O(e) {
        S.nodeList(e) || S.array(e) ? Array.from(e).forEach(O) : S.element(e) && S.element(e.parentNode) && e.parentNode.removeChild(e);
    }
    function j(e) {
        if (!S.element(e)) return;
        let { length: t } = e.childNodes;
        for(; t > 0;)e.removeChild(e.lastChild), t -= 1;
    }
    function q(e, t) {
        return S.element(t) && S.element(t.parentNode) && S.element(e) ? (t.parentNode.replaceChild(e, t), e) : null;
    }
    function D(e, t) {
        if (!S.string(e) || S.empty(e)) return {};
        const i = {}, s = x({}, t);
        return e.split(",").forEach((e)=>{
            const t = e.trim(), n = t.replace(".", ""), a = t.replace(/[[\]]/g, "").split("="), [l] = a, r = a.length > 1 ? a[1].replace(/["']/g, "") : "";
            switch(t.charAt(0)){
                case ".":
                    S.string(s.class) ? i.class = `${s.class} ${n}` : i.class = n;
                    break;
                case "#":
                    i.id = t.replace("#", "");
                    break;
                case "[":
                    i[l] = r;
            }
        }), x(s, i);
    }
    function H(e, t) {
        if (!S.element(e)) return;
        let i = t;
        S.boolean(i) || (i = !e.hidden), e.hidden = i;
    }
    function R(e, t, i) {
        if (S.nodeList(e)) return Array.from(e).map((e)=>R(e, t, i));
        if (S.element(e)) {
            let s = "toggle";
            return void 0 !== i && (s = i ? "add" : "remove"), e.classList[s](t), e.classList.contains(t);
        }
        return !1;
    }
    function F(e, t) {
        return S.element(e) && e.classList.contains(t);
    }
    function V(e, t) {
        const { prototype: i } = Element;
        return (i.matches || i.webkitMatchesSelector || i.mozMatchesSelector || i.msMatchesSelector || function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function U(e) {
        return this.elements.container.querySelectorAll(e);
    }
    function B(e) {
        return this.elements.container.querySelector(e);
    }
    function W(e = null, t = !1) {
        S.element(e) && e.focus({
            preventScroll: !0,
            focusVisible: t
        });
    }
    const z = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora"
    }, K = {
        audio: "canPlayType" in document.createElement("audio"),
        video: "canPlayType" in document.createElement("video"),
        check (e, t) {
            const i = K[e] || "html5" !== t;
            return {
                api: i,
                ui: i && K.rangeInput
            };
        },
        pip: !(M.isIPhone || !S.function($("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || $("video").disablePictureInPicture)),
        airplay: S.function(window.WebKitPlaybackTargetAvailabilityEvent),
        playsinline: "playsInline" in document.createElement("video"),
        mime (e) {
            if (S.empty(e)) return !1;
            const [t] = e.split("/");
            let i = e;
            if (!this.isHTML5 || t !== this.type) return !1;
            Object.keys(z).includes(i) && (i += `; codecs="${z[e]}"`);
            try {
                return Boolean(i && this.media.canPlayType(i).replace(/no/, ""));
            } catch (e) {
                return !1;
            }
        },
        textTracks: "textTracks" in document.createElement("video"),
        rangeInput: (()=>{
            const e = document.createElement("input");
            return e.type = "range", "range" === e.type;
        })(),
        touch: "ontouchstart" in document.documentElement,
        transitions: !1 !== E,
        reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
    }, Y = (()=>{
        let e = !1;
        try {
            const t = Object.defineProperty({}, "passive", {
                get: ()=>(e = !0, null)
            });
            window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
    })();
    function Q(e, t, i, s = !1, n = !0, a = !1) {
        if (!e || !("addEventListener" in e) || S.empty(t) || !S.function(i)) return;
        const l = t.split(" ");
        let r = a;
        Y && (r = {
            passive: n,
            capture: a
        }), l.forEach((t)=>{
            this && this.eventListeners && s && this.eventListeners.push({
                element: e,
                type: t,
                callback: i,
                options: r
            }), e[s ? "addEventListener" : "removeEventListener"](t, i, r);
        });
    }
    function X(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !0, s, n);
    }
    function J(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !1, s, n);
    }
    function G(e, t = "", i, s = !0, n = !1) {
        const a = (...l)=>{
            J(e, t, a, s, n), i.apply(this, l);
        };
        Q.call(this, e, t, a, !0, s, n);
    }
    function Z(e, t = "", i = !1, s = {}) {
        if (!S.element(e) || S.empty(t)) return;
        const n = new CustomEvent(t, {
            bubbles: i,
            detail: {
                ...s,
                plyr: this
            }
        });
        e.dispatchEvent(n);
    }
    function ee() {
        this && this.eventListeners && (this.eventListeners.forEach((e)=>{
            const { element: t, type: i, callback: s, options: n } = e;
            t.removeEventListener(i, s, n);
        }), this.eventListeners = []);
    }
    function te() {
        return new Promise((e)=>this.ready ? setTimeout(e, 0) : X.call(this, this.elements.container, "ready", e)).then(()=>{});
    }
    function ie(e) {
        S.promise(e) && e.then(null, ()=>{});
    }
    function se(e) {
        return S.array(e) ? e.filter((t, i)=>e.indexOf(t) === i) : e;
    }
    function ne(e, t) {
        return S.array(e) && e.length ? e.reduce((e, i)=>Math.abs(i - t) < Math.abs(e - t) ? i : e) : null;
    }
    function ae(e) {
        return !(!window || !window.CSS) && window.CSS.supports(e);
    }
    const le = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((e, [t, i])=>({
            ...e,
            [t / i]: [
                t,
                i
            ]
        }), {});
    function re(e) {
        if (!(S.array(e) || S.string(e) && e.includes(":"))) return !1;
        return (S.array(e) ? e : e.split(":")).map(Number).every(S.number);
    }
    function oe(e) {
        if (!S.array(e) || !e.every(S.number)) return null;
        const [t, i] = e, s = (e, t)=>0 === t ? e : s(t, e % t), n = s(t, i);
        return [
            t / n,
            i / n
        ];
    }
    function ce(e) {
        const t = (e)=>re(e) ? e.split(":").map(Number) : null;
        let i = t(e);
        if (null === i && (i = t(this.config.ratio)), null === i && !S.empty(this.embed) && S.array(this.embed.ratio) && ({ ratio: i } = this.embed), null === i && this.isHTML5) {
            const { videoWidth: e, videoHeight: t } = this.media;
            i = [
                e,
                t
            ];
        }
        return oe(i);
    }
    function ue(e) {
        if (!this.isVideo) return {};
        const { wrapper: t } = this.elements, i = ce.call(this, e);
        if (!S.array(i)) return {};
        const [s, n] = oe(i), a = 100 / s * n;
        if (ae(`aspect-ratio: ${s}/${n}`) ? t.style.aspectRatio = `${s}/${n}` : t.style.paddingBottom = `${a}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const e = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), i = (e - a) / (e / 50);
            this.fullscreen.active ? t.style.paddingBottom = null : this.media.style.transform = `translateY(-${i}%)`;
        } else this.isHTML5 && t.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: a,
            ratio: i
        };
    }
    function he(e, t, i = .05) {
        const s = e / t, n = ne(Object.keys(le), s);
        return Math.abs(n - s) <= i ? le[n] : [
            e,
            t
        ];
    }
    const de = {
        getSources () {
            if (!this.isHTML5) return [];
            return Array.from(this.media.querySelectorAll("source")).filter((e)=>{
                const t = e.getAttribute("type");
                return !!S.empty(t) || K.mime.call(this, t);
            });
        },
        getQualityOptions () {
            return this.config.quality.forced ? this.config.quality.options : de.getSources.call(this).map((e)=>Number(e.getAttribute("size"))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const e = this;
            e.options.speed = e.config.speed.options, S.empty(this.config.ratio) || ue.call(e), Object.defineProperty(e.media, "quality", {
                get () {
                    const t = de.getSources.call(e).find((t)=>t.getAttribute("src") === e.source);
                    return t && Number(t.getAttribute("size"));
                },
                set (t) {
                    if (e.quality !== t) {
                        if (e.config.quality.forced && S.function(e.config.quality.onChange)) e.config.quality.onChange(t);
                        else {
                            const i = de.getSources.call(e).find((e)=>Number(e.getAttribute("size")) === t);
                            if (!i) return;
                            const { currentTime: s, paused: n, preload: a, readyState: l, playbackRate: r } = e.media;
                            e.media.src = i.getAttribute("src"), ("none" !== a || l) && (e.once("loadedmetadata", ()=>{
                                e.speed = r, e.currentTime = s, n || ie(e.play());
                            }), e.media.load());
                        }
                        Z.call(e, e.media, "qualitychange", !1, {
                            quality: t
                        });
                    }
                }
            });
        },
        cancelRequests () {
            this.isHTML5 && (O(de.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
        }
    };
    function me(e, ...t) {
        return S.empty(e) ? e : e.toString().replace(/{(\d+)}/g, (e, i)=>t[i].toString());
    }
    const pe = (e = "", t = "", i = "")=>e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i.toString()), ge = (e = "")=>e.toString().replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.slice(1).toLowerCase());
    function fe(e = "") {
        let t = e.toString();
        return t = function(e = "") {
            let t = e.toString();
            return t = pe(t, "-", " "), t = pe(t, "_", " "), t = ge(t), pe(t, " ", "");
        }(t), t.charAt(0).toLowerCase() + t.slice(1);
    }
    function ye(e) {
        const t = document.createElement("div");
        return t.appendChild(e), t.innerHTML;
    }
    const be = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube"
    }, ve = {
        get (e = "", t = {}) {
            if (S.empty(e) || S.empty(t)) return "";
            let i = N(t.i18n, e);
            if (S.empty(i)) return Object.keys(be).includes(e) ? be[e] : "";
            const s = {
                "{seektime}": t.seekTime,
                "{title}": t.title
            };
            return Object.entries(s).forEach(([e, t])=>{
                i = pe(i, e, t);
            }), i;
        }
    };
    class we {
        constructor(t){
            e(this, "get", (e)=>{
                if (!we.supported || !this.enabled) return null;
                const t = window.localStorage.getItem(this.key);
                if (S.empty(t)) return null;
                const i = JSON.parse(t);
                return S.string(e) && e.length ? i[e] : i;
            }), e(this, "set", (e)=>{
                if (!we.supported || !this.enabled) return;
                if (!S.object(e)) return;
                let t = this.get();
                S.empty(t) && (t = {}), x(t, e);
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(t));
                } catch (e) {}
            }), this.enabled = t.config.storage.enabled, this.key = t.config.storage.key;
        }
        static get supported() {
            try {
                if (!("localStorage" in window)) return !1;
                const e = "___test";
                return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
            } catch (e) {
                return !1;
            }
        }
    }
    function Te(e, t = "text") {
        return new Promise((i, s)=>{
            try {
                const s = new XMLHttpRequest;
                if (!("withCredentials" in s)) return;
                s.addEventListener("load", ()=>{
                    if ("text" === t) try {
                        i(JSON.parse(s.responseText));
                    } catch (e) {
                        i(s.responseText);
                    }
                    else i(s.response);
                }), s.addEventListener("error", ()=>{
                    throw new Error(s.status);
                }), s.open("GET", e, !0), s.responseType = t, s.send();
            } catch (e) {
                s(e);
            }
        });
    }
    function ke(e, t) {
        if (!S.string(e)) return;
        const i = "cache", s = S.string(t);
        let n = !1;
        const a = ()=>null !== document.getElementById(t), l = (e, t)=>{
            e.innerHTML = t, s && a() || document.body.insertAdjacentElement("afterbegin", e);
        };
        if (!s || !a()) {
            const a = we.supported, r = document.createElement("div");
            if (r.setAttribute("hidden", ""), s && r.setAttribute("id", t), a) {
                const e = window.localStorage.getItem(`${i}-${t}`);
                if (n = null !== e, n) {
                    const t = JSON.parse(e);
                    l(r, t.content);
                }
            }
            Te(e).then((e)=>{
                if (!S.empty(e)) {
                    if (a) try {
                        window.localStorage.setItem(`${i}-${t}`, JSON.stringify({
                            content: e
                        }));
                    } catch (e) {}
                    l(r, e);
                }
            }).catch(()=>{});
        }
    }
    const Ce = (e)=>Math.trunc(e / 60 / 60 % 60, 10), Ae = (e)=>Math.trunc(e / 60 % 60, 10), Se = (e)=>Math.trunc(e % 60, 10);
    function Ee(e = 0, t = !1, i = !1) {
        if (!S.number(e)) return Ee(void 0, t, i);
        const s = (e)=>`0${e}`.slice(-2);
        let n = Ce(e);
        const a = Ae(e), l = Se(e);
        return n = t || n > 0 ? `${n}:` : "", `${i && e > 0 ? "-" : ""}${n}${s(a)}:${s(l)}`;
    }
    const Pe = {
        getIconUrl () {
            const e = new URL(this.config.iconUrl, window.location), t = window.location.host ? window.location.host : window.top.location.host, i = e.host !== t || M.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: i
            };
        },
        findElements () {
            try {
                return this.elements.controls = B.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
                    play: U.call(this, this.config.selectors.buttons.play),
                    pause: B.call(this, this.config.selectors.buttons.pause),
                    restart: B.call(this, this.config.selectors.buttons.restart),
                    rewind: B.call(this, this.config.selectors.buttons.rewind),
                    fastForward: B.call(this, this.config.selectors.buttons.fastForward),
                    mute: B.call(this, this.config.selectors.buttons.mute),
                    pip: B.call(this, this.config.selectors.buttons.pip),
                    airplay: B.call(this, this.config.selectors.buttons.airplay),
                    settings: B.call(this, this.config.selectors.buttons.settings),
                    captions: B.call(this, this.config.selectors.buttons.captions),
                    fullscreen: B.call(this, this.config.selectors.buttons.fullscreen)
                }, this.elements.progress = B.call(this, this.config.selectors.progress), this.elements.inputs = {
                    seek: B.call(this, this.config.selectors.inputs.seek),
                    volume: B.call(this, this.config.selectors.inputs.volume)
                }, this.elements.display = {
                    buffer: B.call(this, this.config.selectors.display.buffer),
                    currentTime: B.call(this, this.config.selectors.display.currentTime),
                    duration: B.call(this, this.config.selectors.display.duration)
                }, S.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), !0;
            } catch (e) {
                return this.debug.warn("It looks like there is a problem with your custom controls HTML", e), this.toggleNativeControls(!0), !1;
            }
        },
        createIcon (e, t) {
            const i = "http://www.w3.org/2000/svg", s = Pe.getIconUrl.call(this), n = `${s.cors ? "" : s.url}#${this.config.iconPrefix}`, a = document.createElementNS(i, "svg");
            I(a, x(t, {
                "aria-hidden": "true",
                focusable: "false"
            }));
            const l = document.createElementNS(i, "use"), r = `${n}-${e}`;
            return "href" in l && l.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), l.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", r), a.appendChild(l), a;
        },
        createLabel (e, t = {}) {
            const i = ve.get(e, this.config);
            return $("span", {
                ...t,
                class: [
                    t.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(" ")
            }, i);
        },
        createBadge (e) {
            if (S.empty(e)) return null;
            const t = $("span", {
                class: this.config.classNames.menu.value
            });
            return t.appendChild($("span", {
                class: this.config.classNames.menu.badge
            }, e)), t;
        },
        createButton (e, t) {
            const i = x({}, t);
            let s = fe(e);
            const n = {
                element: "button",
                toggle: !1,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            switch([
                "element",
                "icon",
                "label"
            ].forEach((e)=>{
                Object.keys(i).includes(e) && (n[e] = i[e], delete i[e]);
            }), "button" !== n.element || Object.keys(i).includes("type") || (i.type = "button"), Object.keys(i).includes("class") ? i.class.split(" ").some((e)=>e === this.config.classNames.control) || x(i, {
                class: `${i.class} ${this.config.classNames.control}`
            }) : i.class = this.config.classNames.control, e){
                case "play":
                    n.toggle = !0, n.label = "play", n.labelPressed = "pause", n.icon = "play", n.iconPressed = "pause";
                    break;
                case "mute":
                    n.toggle = !0, n.label = "mute", n.labelPressed = "unmute", n.icon = "volume", n.iconPressed = "muted";
                    break;
                case "captions":
                    n.toggle = !0, n.label = "enableCaptions", n.labelPressed = "disableCaptions", n.icon = "captions-off", n.iconPressed = "captions-on";
                    break;
                case "fullscreen":
                    n.toggle = !0, n.label = "enterFullscreen", n.labelPressed = "exitFullscreen", n.icon = "enter-fullscreen", n.iconPressed = "exit-fullscreen";
                    break;
                case "play-large":
                    i.class += ` ${this.config.classNames.control}--overlaid`, s = "play", n.label = "play", n.icon = "play";
                    break;
                default:
                    S.empty(n.label) && (n.label = s), S.empty(n.icon) && (n.icon = e);
            }
            const a = $(n.element);
            return n.toggle ? (a.appendChild(Pe.createIcon.call(this, n.iconPressed, {
                class: "icon--pressed"
            })), a.appendChild(Pe.createIcon.call(this, n.icon, {
                class: "icon--not-pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.labelPressed, {
                class: "label--pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.label, {
                class: "label--not-pressed"
            }))) : (a.appendChild(Pe.createIcon.call(this, n.icon)), a.appendChild(Pe.createLabel.call(this, n.label))), x(i, D(this.config.selectors.buttons[s], i)), I(a, i), "play" === s ? (S.array(this.elements.buttons[s]) || (this.elements.buttons[s] = []), this.elements.buttons[s].push(a)) : this.elements.buttons[s] = a, a;
        },
        createRange (e, t) {
            const i = $("input", x(D(this.config.selectors.inputs[e]), {
                type: "range",
                min: 0,
                max: 100,
                step: .01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": ve.get(e, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
            }, t));
            return this.elements.inputs[e] = i, Pe.updateRangeFill.call(this, i), g.setup(i), i;
        },
        createProgress (e, t) {
            const i = $("progress", x(D(this.config.selectors.display[e]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0
            }, t));
            if ("volume" !== e) {
                i.appendChild($("span", null, "0"));
                const t = {
                    played: "played",
                    buffer: "buffered"
                }[e], s = t ? ve.get(t, this.config) : "";
                i.innerText = `% ${s.toLowerCase()}`;
            }
            return this.elements.display[e] = i, i;
        },
        createTime (e, t) {
            const i = D(this.config.selectors.display[e], t), s = $("div", x(i, {
                class: `${i.class ? i.class : ""} ${this.config.classNames.display.time} `.trim(),
                "aria-label": ve.get(e, this.config),
                role: "timer"
            }), "00:00");
            return this.elements.display[e] = s, s;
        },
        bindMenuItemShortcuts (e, t) {
            X.call(this, e, "keydown keyup", (i)=>{
                if (![
                    " ",
                    "ArrowUp",
                    "ArrowDown",
                    "ArrowRight"
                ].includes(i.key)) return;
                if (i.preventDefault(), i.stopPropagation(), "keydown" === i.type) return;
                const s = V(e, '[role="menuitemradio"]');
                if (!s && [
                    " ",
                    "ArrowRight"
                ].includes(i.key)) Pe.showMenuPanel.call(this, t, !0);
                else {
                    let t;
                    " " !== i.key && ("ArrowDown" === i.key || s && "ArrowRight" === i.key ? (t = e.nextElementSibling, S.element(t) || (t = e.parentNode.firstElementChild)) : (t = e.previousElementSibling, S.element(t) || (t = e.parentNode.lastElementChild)), W.call(this, t, !0));
                }
            }, !1), X.call(this, e, "keyup", (e)=>{
                "Return" === e.key && Pe.focusFirstMenuItem.call(this, null, !0);
            });
        },
        createMenuItem ({ value: e, list: t, type: i, title: s, badge: n = null, checked: a = !1 }) {
            const l = D(this.config.selectors.inputs[i]), r = $("button", x(l, {
                type: "button",
                role: "menuitemradio",
                class: `${this.config.classNames.control} ${l.class ? l.class : ""}`.trim(),
                "aria-checked": a,
                value: e
            })), o = $("span");
            o.innerHTML = s, S.element(n) && o.appendChild(n), r.appendChild(o), Object.defineProperty(r, "checked", {
                enumerable: !0,
                get: ()=>"true" === r.getAttribute("aria-checked"),
                set (e) {
                    e && Array.from(r.parentNode.children).filter((e)=>V(e, '[role="menuitemradio"]')).forEach((e)=>e.setAttribute("aria-checked", "false")), r.setAttribute("aria-checked", e ? "true" : "false");
                }
            }), this.listeners.bind(r, "click keyup", (t)=>{
                if (!S.keyboardEvent(t) || " " === t.key) {
                    switch(t.preventDefault(), t.stopPropagation(), r.checked = !0, i){
                        case "language":
                            this.currentTrack = Number(e);
                            break;
                        case "quality":
                            this.quality = e;
                            break;
                        case "speed":
                            this.speed = parseFloat(e);
                    }
                    Pe.showMenuPanel.call(this, "home", S.keyboardEvent(t));
                }
            }, i, !1), Pe.bindMenuItemShortcuts.call(this, r, i), t.appendChild(r);
        },
        formatTime (e = 0, t = !1) {
            if (!S.number(e)) return e;
            return Ee(e, Ce(this.duration) > 0, t);
        },
        updateTimeDisplay (e = null, t = 0, i = !1) {
            S.element(e) && S.number(t) && (e.innerText = Pe.formatTime(t, i));
        },
        updateVolume () {
            this.supported.ui && (S.element(this.elements.inputs.volume) && Pe.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), S.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
        },
        setRange (e, t = 0) {
            S.element(e) && (e.value = t, Pe.updateRangeFill.call(this, e));
        },
        updateProgress (e) {
            if (!this.supported.ui || !S.event(e)) return;
            let t = 0;
            const i = (e, t)=>{
                const i = S.number(t) ? t : 0, s = S.element(e) ? e : this.elements.display.buffer;
                if (S.element(s)) {
                    s.value = i;
                    const e = s.getElementsByTagName("span")[0];
                    S.element(e) && (e.childNodes[0].nodeValue = i);
                }
            };
            if (e) switch(e.type){
                case "timeupdate":
                case "seeking":
                case "seeked":
                    s = this.currentTime, n = this.duration, t = 0 === s || 0 === n || Number.isNaN(s) || Number.isNaN(n) ? 0 : (s / n * 100).toFixed(2), "timeupdate" === e.type && Pe.setRange.call(this, this.elements.inputs.seek, t);
                    break;
                case "playing":
                case "progress":
                    i(this.elements.display.buffer, 100 * this.buffered);
            }
            var s, n;
        },
        updateRangeFill (e) {
            const t = S.event(e) ? e.target : e;
            if (S.element(t) && "range" === t.getAttribute("type")) {
                if (V(t, this.config.selectors.inputs.seek)) {
                    t.setAttribute("aria-valuenow", this.currentTime);
                    const e = Pe.formatTime(this.currentTime), i = Pe.formatTime(this.duration), s = ve.get("seekLabel", this.config);
                    t.setAttribute("aria-valuetext", s.replace("{currentTime}", e).replace("{duration}", i));
                } else if (V(t, this.config.selectors.inputs.volume)) {
                    const e = 100 * t.value;
                    t.setAttribute("aria-valuenow", e), t.setAttribute("aria-valuetext", `${e.toFixed(1)}%`);
                } else t.setAttribute("aria-valuenow", t.value);
                (M.isWebKit || M.isIPadOS) && t.style.setProperty("--value", t.value / t.max * 100 + "%");
            }
        },
        updateSeekTooltip (e) {
            var t, i;
            if (!this.config.tooltips.seek || !S.element(this.elements.inputs.seek) || !S.element(this.elements.display.seekTooltip) || 0 === this.duration) return;
            const s = this.elements.display.seekTooltip, n = `${this.config.classNames.tooltip}--visible`, a = (e)=>R(s, n, e);
            if (this.touch) return void a(!1);
            let l = 0;
            const r = this.elements.progress.getBoundingClientRect();
            if (S.event(e)) l = 100 / r.width * (e.pageX - r.left);
            else {
                if (!F(s, n)) return;
                l = parseFloat(s.style.left, 10);
            }
            l < 0 ? l = 0 : l > 100 && (l = 100);
            const o = this.duration / 100 * l;
            s.innerText = Pe.formatTime(o);
            const c = null === (t = this.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(o));
            c && s.insertAdjacentHTML("afterbegin", `${c.label}<br>`), s.style.left = `${l}%`, S.event(e) && [
                "mouseenter",
                "mouseleave"
            ].includes(e.type) && a("mouseenter" === e.type);
        },
        timeUpdate (e) {
            const t = !S.element(this.elements.display.duration) && this.config.invertTime;
            Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t), e && "timeupdate" === e.type && this.media.seeking || Pe.updateProgress.call(this, e);
        },
        durationUpdate () {
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            if (this.duration >= 2 ** 32) return H(this.elements.display.currentTime, !0), void H(this.elements.progress, !0);
            S.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
            const e = S.element(this.elements.display.duration);
            !e && this.config.displayDuration && this.paused && Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e && Pe.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && Pe.setMarkers.call(this), Pe.updateSeekTooltip.call(this);
        },
        toggleMenuButton (e, t) {
            H(this.elements.settings.buttons[e], !t);
        },
        updateSetting (e, t, i) {
            const s = this.elements.settings.panels[e];
            let n = null, a = t;
            if ("captions" === e) n = this.currentTrack;
            else {
                if (n = S.empty(i) ? this[e] : i, S.empty(n) && (n = this.config[e].default), !S.empty(this.options[e]) && !this.options[e].includes(n)) return void this.debug.warn(`Unsupported value of '${n}' for ${e}`);
                if (!this.config[e].options.includes(n)) return void this.debug.warn(`Disabled value of '${n}' for ${e}`);
            }
            if (S.element(a) || (a = s && s.querySelector('[role="menu"]')), !S.element(a)) return;
            this.elements.settings.buttons[e].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = Pe.getLabel.call(this, e, n);
            const l = a && a.querySelector(`[value="${n}"]`);
            S.element(l) && (l.checked = !0);
        },
        getLabel (e, t) {
            switch(e){
                case "speed":
                    return 1 === t ? ve.get("normal", this.config) : `${t}&times;`;
                case "quality":
                    if (S.number(t)) {
                        const e = ve.get(`qualityLabel.${t}`, this.config);
                        return e.length ? e : `${t}p`;
                    }
                    return ge(t);
                case "captions":
                    return xe.getLabel.call(this);
                default:
                    return null;
            }
        },
        setQualityMenu (e) {
            if (!S.element(this.elements.settings.panels.quality)) return;
            const t = "quality", i = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            S.array(e) && (this.options.quality = se(e).filter((e)=>this.config.quality.options.includes(e)));
            const s = !S.empty(this.options.quality) && this.options.quality.length > 1;
            if (Pe.toggleMenuButton.call(this, t, s), j(i), Pe.checkMenu.call(this), !s) return;
            const n = (e)=>{
                const t = ve.get(`qualityBadge.${e}`, this.config);
                return t.length ? Pe.createBadge.call(this, t) : null;
            };
            this.options.quality.sort((e, t)=>{
                const i = this.config.quality.options;
                return i.indexOf(e) > i.indexOf(t) ? 1 : -1;
            }).forEach((e)=>{
                Pe.createMenuItem.call(this, {
                    value: e,
                    list: i,
                    type: t,
                    title: Pe.getLabel.call(this, "quality", e),
                    badge: n(e)
                });
            }), Pe.updateSetting.call(this, t, i);
        },
        setCaptionsMenu () {
            if (!S.element(this.elements.settings.panels.captions)) return;
            const e = "captions", t = this.elements.settings.panels.captions.querySelector('[role="menu"]'), i = xe.getTracks.call(this), s = Boolean(i.length);
            if (Pe.toggleMenuButton.call(this, e, s), j(t), Pe.checkMenu.call(this), !s) return;
            const n = i.map((e, i)=>({
                    value: i,
                    checked: this.captions.toggled && this.currentTrack === i,
                    title: xe.getLabel.call(this, e),
                    badge: e.language && Pe.createBadge.call(this, e.language.toUpperCase()),
                    list: t,
                    type: "language"
                }));
            n.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: ve.get("disabled", this.config),
                list: t,
                type: "language"
            }), n.forEach(Pe.createMenuItem.bind(this)), Pe.updateSetting.call(this, e, t);
        },
        setSpeedMenu () {
            if (!S.element(this.elements.settings.panels.speed)) return;
            const e = "speed", t = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            this.options.speed = this.options.speed.filter((e)=>e >= this.minimumSpeed && e <= this.maximumSpeed);
            const i = !S.empty(this.options.speed) && this.options.speed.length > 1;
            Pe.toggleMenuButton.call(this, e, i), j(t), Pe.checkMenu.call(this), i && (this.options.speed.forEach((i)=>{
                Pe.createMenuItem.call(this, {
                    value: i,
                    list: t,
                    type: e,
                    title: Pe.getLabel.call(this, "speed", i)
                });
            }), Pe.updateSetting.call(this, e, t));
        },
        checkMenu () {
            const { buttons: e } = this.elements.settings, t = !S.empty(e) && Object.values(e).some((e)=>!e.hidden);
            H(this.elements.settings.menu, !t);
        },
        focusFirstMenuItem (e, t = !1) {
            if (this.elements.settings.popup.hidden) return;
            let i = e;
            S.element(i) || (i = Object.values(this.elements.settings.panels).find((e)=>!e.hidden));
            const s = i.querySelector('[role^="menuitem"]');
            W.call(this, s, t);
        },
        toggleMenu (e) {
            const { popup: t } = this.elements.settings, i = this.elements.buttons.settings;
            if (!S.element(t) || !S.element(i)) return;
            const { hidden: s } = t;
            let n = s;
            if (S.boolean(e)) n = e;
            else if (S.keyboardEvent(e) && "Escape" === e.key) n = !1;
            else if (S.event(e)) {
                const s = S.function(e.composedPath) ? e.composedPath()[0] : e.target, a = t.contains(s);
                if (a || !a && e.target !== i && n) return;
            }
            i.setAttribute("aria-expanded", n), H(t, !n), R(this.elements.container, this.config.classNames.menu.open, n), n && S.keyboardEvent(e) ? Pe.focusFirstMenuItem.call(this, null, !0) : n || s || W.call(this, i, S.keyboardEvent(e));
        },
        getMenuSize (e) {
            const t = e.cloneNode(!0);
            t.style.position = "absolute", t.style.opacity = 0, t.removeAttribute("hidden"), e.parentNode.appendChild(t);
            const i = t.scrollWidth, s = t.scrollHeight;
            return O(t), {
                width: i,
                height: s
            };
        },
        showMenuPanel (e = "", t = !1) {
            const i = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e}`);
            if (!S.element(i)) return;
            const s = i.parentNode, n = Array.from(s.children).find((e)=>!e.hidden);
            if (K.transitions && !K.reducedMotion) {
                s.style.width = `${n.scrollWidth}px`, s.style.height = `${n.scrollHeight}px`;
                const e = Pe.getMenuSize.call(this, i), t = (e)=>{
                    e.target === s && [
                        "width",
                        "height"
                    ].includes(e.propertyName) && (s.style.width = "", s.style.height = "", J.call(this, s, E, t));
                };
                X.call(this, s, E, t), s.style.width = `${e.width}px`, s.style.height = `${e.height}px`;
            }
            H(n, !0), H(i, !1), Pe.focusFirstMenuItem.call(this, i, t);
        },
        setDownloadUrl () {
            const e = this.elements.buttons.download;
            S.element(e) && e.setAttribute("href", this.download);
        },
        create (e) {
            const { bindMenuItemShortcuts: t, createButton: i, createProgress: s, createRange: n, createTime: a, setQualityMenu: l, setSpeedMenu: r, showMenuPanel: o } = Pe;
            this.elements.controls = null, S.array(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i.call(this, "play-large"));
            const c = $("div", D(this.config.selectors.controls.wrapper));
            this.elements.controls = c;
            const u = {
                class: "plyr__controls__item"
            };
            return se(S.array(this.config.controls) ? this.config.controls : []).forEach((l)=>{
                if ("restart" === l && c.appendChild(i.call(this, "restart", u)), "rewind" === l && c.appendChild(i.call(this, "rewind", u)), "play" === l && c.appendChild(i.call(this, "play", u)), "fast-forward" === l && c.appendChild(i.call(this, "fast-forward", u)), "progress" === l) {
                    const t = $("div", {
                        class: `${u.class} plyr__progress__container`
                    }), i = $("div", D(this.config.selectors.progress));
                    if (i.appendChild(n.call(this, "seek", {
                        id: `plyr-seek-${e.id}`
                    })), i.appendChild(s.call(this, "buffer")), this.config.tooltips.seek) {
                        const e = $("span", {
                            class: this.config.classNames.tooltip
                        }, "00:00");
                        i.appendChild(e), this.elements.display.seekTooltip = e;
                    }
                    this.elements.progress = i, t.appendChild(this.elements.progress), c.appendChild(t);
                }
                if ("current-time" === l && c.appendChild(a.call(this, "currentTime", u)), "duration" === l && c.appendChild(a.call(this, "duration", u)), "mute" === l || "volume" === l) {
                    let { volume: t } = this.elements;
                    if (S.element(t) && c.contains(t) || (t = $("div", x({}, u, {
                        class: `${u.class} plyr__volume`.trim()
                    })), this.elements.volume = t, c.appendChild(t)), "mute" === l && t.appendChild(i.call(this, "mute")), "volume" === l && !M.isIos && !M.isIPadOS) {
                        const i = {
                            max: 1,
                            step: .05,
                            value: this.config.volume
                        };
                        t.appendChild(n.call(this, "volume", x(i, {
                            id: `plyr-volume-${e.id}`
                        })));
                    }
                }
                if ("captions" === l && c.appendChild(i.call(this, "captions", u)), "settings" === l && !S.empty(this.config.settings)) {
                    const s = $("div", x({}, u, {
                        class: `${u.class} plyr__menu`.trim(),
                        hidden: ""
                    }));
                    s.appendChild(i.call(this, "settings", {
                        "aria-haspopup": !0,
                        "aria-controls": `plyr-settings-${e.id}`,
                        "aria-expanded": !1
                    }));
                    const n = $("div", {
                        class: "plyr__menu__container",
                        id: `plyr-settings-${e.id}`,
                        hidden: ""
                    }), a = $("div"), l = $("div", {
                        id: `plyr-settings-${e.id}-home`
                    }), r = $("div", {
                        role: "menu"
                    });
                    l.appendChild(r), a.appendChild(l), this.elements.settings.panels.home = l, this.config.settings.forEach((i)=>{
                        const s = $("button", x(D(this.config.selectors.buttons.settings), {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: "menuitem",
                            "aria-haspopup": !0,
                            hidden: ""
                        }));
                        t.call(this, s, i), X.call(this, s, "click", ()=>{
                            o.call(this, i, !1);
                        });
                        const n = $("span", null, ve.get(i, this.config)), l = $("span", {
                            class: this.config.classNames.menu.value
                        });
                        l.innerHTML = e[i], n.appendChild(l), s.appendChild(n), r.appendChild(s);
                        const c = $("div", {
                            id: `plyr-settings-${e.id}-${i}`,
                            hidden: ""
                        }), u = $("button", {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        u.appendChild($("span", {
                            "aria-hidden": !0
                        }, ve.get(i, this.config))), u.appendChild($("span", {
                            class: this.config.classNames.hidden
                        }, ve.get("menuBack", this.config))), X.call(this, c, "keydown", (e)=>{
                            "ArrowLeft" === e.key && (e.preventDefault(), e.stopPropagation(), o.call(this, "home", !0));
                        }, !1), X.call(this, u, "click", ()=>{
                            o.call(this, "home", !1);
                        }), c.appendChild(u), c.appendChild($("div", {
                            role: "menu"
                        })), a.appendChild(c), this.elements.settings.buttons[i] = s, this.elements.settings.panels[i] = c;
                    }), n.appendChild(a), s.appendChild(n), c.appendChild(s), this.elements.settings.popup = n, this.elements.settings.menu = s;
                }
                if ("pip" === l && K.pip && c.appendChild(i.call(this, "pip", u)), "airplay" === l && K.airplay && c.appendChild(i.call(this, "airplay", u)), "download" === l) {
                    const e = x({}, u, {
                        element: "a",
                        href: this.download,
                        target: "_blank"
                    });
                    this.isHTML5 && (e.download = "");
                    const { download: t } = this.config.urls;
                    !S.url(t) && this.isEmbed && x(e, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    }), c.appendChild(i.call(this, "download", e));
                }
                "fullscreen" === l && c.appendChild(i.call(this, "fullscreen", u));
            }), this.isHTML5 && l.call(this, de.getQualityOptions.call(this)), r.call(this), c;
        },
        inject () {
            if (this.config.loadSprite) {
                const e = Pe.getIconUrl.call(this);
                e.cors && ke(e.url, "sprite-plyr");
            }
            this.id = Math.floor(1e4 * Math.random());
            let e = null;
            this.elements.controls = null;
            const t = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let i = !0;
            S.function(this.config.controls) && (this.config.controls = this.config.controls.call(this, t)), this.config.controls || (this.config.controls = []), S.element(this.config.controls) || S.string(this.config.controls) ? e = this.config.controls : (e = Pe.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: xe.getLabel.call(this)
            }), i = !1);
            let s;
            i && S.string(this.config.controls) && (e = ((e)=>{
                let i = e;
                return Object.entries(t).forEach(([e, t])=>{
                    i = pe(i, `{${e}}`, t);
                }), i;
            })(e)), S.string(this.config.selectors.controls.container) && (s = document.querySelector(this.config.selectors.controls.container)), S.element(s) || (s = this.elements.container);
            if (s[S.element(e) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e), S.element(this.elements.controls) || Pe.findElements.call(this), !S.empty(this.elements.buttons)) {
                const e = (e)=>{
                    const t = this.config.classNames.controlPressed;
                    e.setAttribute("aria-pressed", "false"), Object.defineProperty(e, "pressed", {
                        configurable: !0,
                        enumerable: !0,
                        get: ()=>F(e, t),
                        set (i = !1) {
                            R(e, t, i), e.setAttribute("aria-pressed", i ? "true" : "false");
                        }
                    });
                };
                Object.values(this.elements.buttons).filter(Boolean).forEach((t)=>{
                    S.array(t) || S.nodeList(t) ? Array.from(t).filter(Boolean).forEach(e) : e(t);
                });
            }
            if (M.isEdge && P(s), this.config.tooltips.controls) {
                const { classNames: e, selectors: t } = this.config, i = `${t.controls.wrapper} ${t.labels} .${e.hidden}`, s = U.call(this, i);
                Array.from(s).forEach((e)=>{
                    R(e, this.config.classNames.hidden, !1), R(e, this.config.classNames.tooltip, !0);
                });
            }
        },
        setMediaMetadata () {
            try {
                "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                }));
            } catch (e) {}
        },
        setMarkers () {
            var e, t;
            if (!this.duration || this.elements.markers) return;
            const i = null === (e = this.config.markers) || void 0 === e || null === (t = e.points) || void 0 === t ? void 0 : t.filter(({ time: e })=>e > 0 && e < this.duration);
            if (null == i || !i.length) return;
            const s = document.createDocumentFragment(), n = document.createDocumentFragment();
            let a = null;
            const l = `${this.config.classNames.tooltip}--visible`, r = (e)=>R(a, l, e);
            i.forEach((e)=>{
                const t = $("span", {
                    class: this.config.classNames.marker
                }, ""), i = e.time / this.duration * 100 + "%";
                a && (t.addEventListener("mouseenter", ()=>{
                    e.label || (a.style.left = i, a.innerHTML = e.label, r(!0));
                }), t.addEventListener("mouseleave", ()=>{
                    r(!1);
                })), t.addEventListener("click", ()=>{
                    this.currentTime = e.time;
                }), t.style.left = i, n.appendChild(t);
            }), s.appendChild(n), this.config.tooltips.seek || (a = $("span", {
                class: this.config.classNames.tooltip
            }, ""), s.appendChild(a)), this.elements.markers = {
                points: n,
                tip: a
            }, this.elements.progress.appendChild(s);
        }
    };
    function Me(e, t = !0) {
        let i = e;
        if (t) {
            const e = document.createElement("a");
            e.href = i, i = e.href;
        }
        try {
            return new URL(i);
        } catch (e) {
            return null;
        }
    }
    function Ne(e) {
        const t = new URLSearchParams;
        return S.object(e) && Object.entries(e).forEach(([e, i])=>{
            t.set(e, i);
        }), t;
    }
    const xe = {
        setup () {
            if (!this.supported.ui) return;
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !K.textTracks) return void (S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this));
            var e, t;
            if (S.element(this.elements.captions) || (this.elements.captions = $("div", D(this.config.selectors.captions)), this.elements.captions.setAttribute("dir", "auto"), e = this.elements.captions, t = this.elements.wrapper, S.element(e) && S.element(t) && t.parentNode.insertBefore(e, t.nextSibling)), M.isIE && window.URL) {
                const e = this.media.querySelectorAll("track");
                Array.from(e).forEach((e)=>{
                    const t = e.getAttribute("src"), i = Me(t);
                    null !== i && i.hostname !== window.location.href.hostname && [
                        "http:",
                        "https:"
                    ].includes(i.protocol) && Te(t, "blob").then((t)=>{
                        e.setAttribute("src", window.URL.createObjectURL(t));
                    }).catch(()=>{
                        O(e);
                    });
                });
            }
            const i = se((navigator.languages || [
                navigator.language || navigator.userLanguage || "en"
            ]).map((e)=>e.split("-")[0]));
            let s = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
            "auto" === s && ([s] = i);
            let n = this.storage.get("captions");
            if (S.boolean(n) || ({ active: n } = this.config.captions), Object.assign(this.captions, {
                toggled: !1,
                active: n,
                language: s,
                languages: i
            }), this.isHTML5) {
                const e = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                X.call(this, this.media.textTracks, e, xe.update.bind(this));
            }
            setTimeout(xe.update.bind(this), 0);
        },
        update () {
            const e = xe.getTracks.call(this, !0), { active: t, language: i, meta: s, currentTrackNode: n } = this.captions, a = Boolean(e.find((e)=>e.language === i));
            this.isHTML5 && this.isVideo && e.filter((e)=>!s.get(e)).forEach((e)=>{
                this.debug.log("Track added", e), s.set(e, {
                    default: "showing" === e.mode
                }), "showing" === e.mode && (e.mode = "hidden"), X.call(this, e, "cuechange", ()=>xe.updateCues.call(this));
            }), (a && this.language !== i || !e.includes(n)) && (xe.setLanguage.call(this, i), xe.toggle.call(this, t && a)), this.elements && R(this.elements.container, this.config.classNames.captions.enabled, !S.empty(e)), S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this);
        },
        toggle (e, t = !0) {
            if (!this.supported.ui) return;
            const { toggled: i } = this.captions, s = this.config.classNames.captions.active, n = S.nullOrUndefined(e) ? !i : e;
            if (n !== i) {
                if (t || (this.captions.active = n, this.storage.set({
                    captions: n
                })), !this.language && n && !t) {
                    const e = xe.getTracks.call(this), t = xe.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], !0);
                    return this.captions.language = t.language, void xe.set.call(this, e.indexOf(t));
                }
                this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n), R(this.elements.container, s, n), this.captions.toggled = n, Pe.updateSetting.call(this, "captions"), Z.call(this, this.media, n ? "captionsenabled" : "captionsdisabled");
            }
            setTimeout(()=>{
                n && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
            });
        },
        set (e, t = !0) {
            const i = xe.getTracks.call(this);
            if (-1 !== e) {
                if (S.number(e)) {
                    if (e in i) {
                        if (this.captions.currentTrack !== e) {
                            this.captions.currentTrack = e;
                            const s = i[e], { language: n } = s || {};
                            this.captions.currentTrackNode = s, Pe.updateSetting.call(this, "captions"), t || (this.captions.language = n, this.storage.set({
                                language: n
                            })), this.isVimeo && this.embed.enableTextTrack(n), Z.call(this, this.media, "languagechange");
                        }
                        xe.toggle.call(this, !0, t), this.isHTML5 && this.isVideo && xe.updateCues.call(this);
                    } else this.debug.warn("Track not found", e);
                } else this.debug.warn("Invalid caption argument", e);
            } else xe.toggle.call(this, !1, t);
        },
        setLanguage (e, t = !0) {
            if (!S.string(e)) return void this.debug.warn("Invalid language argument", e);
            const i = e.toLowerCase();
            this.captions.language = i;
            const s = xe.getTracks.call(this), n = xe.findTrack.call(this, [
                i
            ]);
            xe.set.call(this, s.indexOf(n), t);
        },
        getTracks (e = !1) {
            return Array.from((this.media || {}).textTracks || []).filter((t)=>!this.isHTML5 || e || this.captions.meta.has(t)).filter((e)=>[
                    "captions",
                    "subtitles"
                ].includes(e.kind));
        },
        findTrack (e, t = !1) {
            const i = xe.getTracks.call(this), s = (e)=>Number((this.captions.meta.get(e) || {}).default), n = Array.from(i).sort((e, t)=>s(t) - s(e));
            let a;
            return e.every((e)=>(a = n.find((t)=>t.language === e), !a)), a || (t ? n[0] : void 0);
        },
        getCurrentTrack () {
            return xe.getTracks.call(this)[this.currentTrack];
        },
        getLabel (e) {
            let t = e;
            return !S.track(t) && K.textTracks && this.captions.toggled && (t = xe.getCurrentTrack.call(this)), S.track(t) ? S.empty(t.label) ? S.empty(t.language) ? ve.get("enabled", this.config) : e.language.toUpperCase() : t.label : ve.get("disabled", this.config);
        },
        updateCues (e) {
            if (!this.supported.ui) return;
            if (!S.element(this.elements.captions)) return void this.debug.warn("No captions element to render to");
            if (!S.nullOrUndefined(e) && !Array.isArray(e)) return void this.debug.warn("updateCues: Invalid input", e);
            let t = e;
            if (!t) {
                const e = xe.getCurrentTrack.call(this);
                t = Array.from((e || {}).activeCues || []).map((e)=>e.getCueAsHTML()).map(ye);
            }
            const i = t.map((e)=>e.trim()).join("\n");
            if (i !== this.elements.captions.innerHTML) {
                j(this.elements.captions);
                const e = $("span", D(this.config.selectors.caption));
                e.innerHTML = i, this.elements.captions.appendChild(e), Z.call(this, this.media, "cuechange");
            }
        }
    }, Le = {
        enabled: !0,
        title: "",
        debug: !1,
        autoplay: !1,
        autopause: !0,
        playsinline: !0,
        seekTime: 10,
        volume: 1,
        muted: !1,
        duration: null,
        displayDuration: !0,
        invertTime: !0,
        toggleInvert: !0,
        ratio: null,
        clickToPlay: !0,
        hideControls: !0,
        resetOnEnd: !1,
        disableContextMenu: !0,
        loadSprite: !0,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg",
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        quality: {
            default: 576,
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: !1,
            onChange: null
        },
        loop: {
            active: !1
        },
        speed: {
            selected: 1,
            options: [
                .5,
                .75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        keyboard: {
            focused: !0,
            global: !1
        },
        tooltips: {
            controls: !1,
            seek: !0
        },
        captions: {
            active: !1,
            language: "auto",
            update: !1
        },
        fullscreen: {
            enabled: !0,
            fallback: !0,
            iosNative: !1
        },
        storage: {
            enabled: !0,
            key: "plyr"
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "captions",
            "settings",
            "pip",
            "airplay",
            "fullscreen"
        ],
        settings: [
            "captions",
            "quality",
            "speed"
        ],
        i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            pip: "PIP",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
            }
        },
        urls: {
            download: null,
            vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
            },
            youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
            },
            googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
            }
        },
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        events: [
            "ended",
            "progress",
            "stalled",
            "playing",
            "waiting",
            "canplay",
            "canplaythrough",
            "loadstart",
            "loadeddata",
            "loadedmetadata",
            "timeupdate",
            "volumechange",
            "play",
            "pause",
            "error",
            "seeking",
            "seeked",
            "emptied",
            "ratechange",
            "cuechange",
            "download",
            "enterfullscreen",
            "exitfullscreen",
            "captionsenabled",
            "captionsdisabled",
            "languagechange",
            "controlshidden",
            "controlsshown",
            "ready",
            "statechange",
            "qualitychange",
            "adsloaded",
            "adscontentpause",
            "adscontentresume",
            "adstarted",
            "adsmidpoint",
            "adscomplete",
            "adsallcomplete",
            "adsimpression",
            "adsclick"
        ],
        selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: {
                container: null,
                wrapper: ".plyr__controls"
            },
            labels: "[data-plyr]",
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                volume: ".plyr__volume--display"
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption"
        },
        classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            marker: "plyr__progress__marker",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: {
                time: "plyr__time"
            },
            menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
            },
            captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
            },
            fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
            },
            pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
            },
            airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
            },
            previewThumbnails: {
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
            }
        },
        attributes: {
            embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id",
                hash: "data-plyr-embed-hash"
            }
        },
        ads: {
            enabled: !1,
            publisherId: "",
            tagUrl: ""
        },
        previewThumbnails: {
            enabled: !1,
            src: ""
        },
        vimeo: {
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: !1,
            customControls: !0,
            referrerPolicy: null,
            premium: !1
        },
        youtube: {
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            customControls: !0,
            noCookie: !1
        },
        mediaMetadata: {
            title: "",
            artist: "",
            album: "",
            artwork: []
        },
        markers: {
            enabled: !1,
            points: []
        }
    }, Ie = "picture-in-picture", $e = "inline", _e = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo"
    }, Oe = "audio", je = "video";
    const qe = ()=>{};
    class De {
        constructor(e = !1){
            this.enabled = window.console && e, this.enabled && this.log("Debugging enabled");
        }
        get log() {
            return this.enabled ? Function.prototype.bind.call(console.log, console) : qe;
        }
        get warn() {
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : qe;
        }
        get error() {
            return this.enabled ? Function.prototype.bind.call(console.error, console) : qe;
        }
    }
    class He {
        constructor(t){
            e(this, "onChange", ()=>{
                if (!this.supported) return;
                const e = this.player.elements.buttons.fullscreen;
                S.element(e) && (e.pressed = this.active);
                const t = this.target === this.player.media ? this.target : this.player.elements.container;
                Z.call(this.player, t, this.active ? "enterfullscreen" : "exitfullscreen", !0);
            }), e(this, "toggleFallback", (e = !1)=>{
                if (e ? this.scrollPosition = {
                    x: window.scrollX ?? 0,
                    y: window.scrollY ?? 0
                } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = e ? "hidden" : "", R(this.target, this.player.config.classNames.fullscreen.fallback, e), M.isIos) {
                    let t = document.head.querySelector('meta[name="viewport"]');
                    const i = "viewport-fit=cover";
                    t || (t = document.createElement("meta"), t.setAttribute("name", "viewport"));
                    const s = S.string(t.content) && t.content.includes(i);
                    e ? (this.cleanupViewport = !s, s || (t.content += `,${i}`)) : this.cleanupViewport && (t.content = t.content.split(",").filter((e)=>e.trim() !== i).join(","));
                }
                this.onChange();
            }), e(this, "trapFocus", (e)=>{
                if (M.isIos || M.isIPadOS || !this.active || "Tab" !== e.key) return;
                const t = document.activeElement, i = U.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [s] = i, n = i[i.length - 1];
                t !== n || e.shiftKey ? t === s && e.shiftKey && (n.focus(), e.preventDefault()) : (s.focus(), e.preventDefault());
            }), e(this, "update", ()=>{
                if (this.supported) {
                    let e;
                    e = this.forceFallback ? "Fallback (forced)" : He.nativeSupported ? "Native" : "Fallback", this.player.debug.log(`${e} fullscreen enabled`);
                } else this.player.debug.log("Fullscreen not supported and fallback disabled");
                R(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
            }), e(this, "enter", ()=>{
                this.supported && (M.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !He.nativeSupported || this.forceFallback ? this.toggleFallback(!0) : this.prefix ? S.empty(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({
                    navigationUI: "hide"
                }));
            }), e(this, "exit", ()=>{
                if (this.supported) {
                    if (M.isIos && this.player.config.fullscreen.iosNative) this.player.isVimeo ? this.player.embed.exitFullscreen() : this.target.webkitEnterFullscreen(), ie(this.player.play());
                    else if (!He.nativeSupported || this.forceFallback) this.toggleFallback(!1);
                    else if (this.prefix) {
                        if (!S.empty(this.prefix)) {
                            const e = "moz" === this.prefix ? "Cancel" : "Exit";
                            document[`${this.prefix}${e}${this.property}`]();
                        }
                    } else (document.cancelFullScreen || document.exitFullscreen).call(document);
                }
            }), e(this, "toggle", ()=>{
                this.active ? this.exit() : this.enter();
            }), this.player = t, this.prefix = He.prefix, this.property = He.property, this.scrollPosition = {
                x: 0,
                y: 0
            }, this.forceFallback = "force" === t.config.fullscreen.fallback, this.player.elements.fullscreen = t.config.fullscreen.container && function(e, t) {
                const { prototype: i } = Element;
                return (i.closest || function() {
                    let e = this;
                    do {
                        if (V.matches(e, t)) return e;
                        e = e.parentElement || e.parentNode;
                    }while (null !== e && 1 === e.nodeType);
                    return null;
                }).call(e, t);
            }(this.player.elements.container, t.config.fullscreen.container), X.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, ()=>{
                this.onChange();
            }), X.call(this.player, this.player.elements.container, "dblclick", (e)=>{
                S.element(this.player.elements.controls) && this.player.elements.controls.contains(e.target) || this.player.listeners.proxy(e, this.toggle, "fullscreen");
            }), X.call(this, this.player.elements.container, "keydown", (e)=>this.trapFocus(e)), this.update();
        }
        static get nativeSupported() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        get useNative() {
            return He.nativeSupported && !this.forceFallback;
        }
        static get prefix() {
            if (S.function(document.exitFullscreen)) return "";
            let e = "";
            return [
                "webkit",
                "moz",
                "ms"
            ].some((t)=>!(!S.function(document[`${t}ExitFullscreen`]) && !S.function(document[`${t}CancelFullScreen`])) && (e = t, !0)), e;
        }
        static get property() {
            return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
        }
        get supported() {
            return [
                this.player.config.fullscreen.enabled,
                this.player.isVideo,
                He.nativeSupported || this.player.config.fullscreen.fallback,
                !this.player.isYouTube || He.nativeSupported || !M.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative
            ].every(Boolean);
        }
        get active() {
            if (!this.supported) return !1;
            if (!He.nativeSupported || this.forceFallback) return F(this.target, this.player.config.classNames.fullscreen.fallback);
            const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
            return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
        }
        get target() {
            return M.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen ?? this.player.elements.container;
        }
    }
    function Re(e, t = 1) {
        return new Promise((i, s)=>{
            const n = new Image, a = ()=>{
                delete n.onload, delete n.onerror, (n.naturalWidth >= t ? i : s)(n);
            };
            Object.assign(n, {
                onload: a,
                onerror: a,
                src: e
            });
        });
    }
    const Fe = {
        addStyleHook () {
            R(this.elements.container, this.config.selectors.container.replace(".", ""), !0), R(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        toggleNativeControls (e = !1) {
            e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
        },
        build () {
            if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void Fe.toggleNativeControls.call(this, !0);
            S.element(this.elements.controls) || (Pe.inject.call(this), this.listeners.controls()), Fe.toggleNativeControls.call(this), this.isHTML5 && xe.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, Pe.updateVolume.call(this), Pe.timeUpdate.call(this), Pe.durationUpdate.call(this), Fe.checkPlaying.call(this), R(this.elements.container, this.config.classNames.pip.supported, K.pip && this.isHTML5 && this.isVideo), R(this.elements.container, this.config.classNames.airplay.supported, K.airplay && this.isHTML5), R(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(()=>{
                Z.call(this, this.media, "ready");
            }, 0), Fe.setTitle.call(this), this.poster && Fe.setPoster.call(this, this.poster, !1).catch(()=>{}), this.config.duration && Pe.durationUpdate.call(this), this.config.mediaMetadata && Pe.setMediaMetadata.call(this);
        },
        setTitle () {
            let e = ve.get("play", this.config);
            if (S.string(this.config.title) && !S.empty(this.config.title) && (e += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach((t)=>{
                t.setAttribute("aria-label", e);
            }), this.isEmbed) {
                const e = B.call(this, "iframe");
                if (!S.element(e)) return;
                const t = S.empty(this.config.title) ? "video" : this.config.title, i = ve.get("frameTitle", this.config);
                e.setAttribute("title", i.replace("{title}", t));
            }
        },
        togglePoster (e) {
            R(this.elements.container, this.config.classNames.posterEnabled, e);
        },
        setPoster (e, t = !0) {
            return t && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e), this.elements.poster.removeAttribute("hidden"), te.call(this).then(()=>Re(e)).catch((t)=>{
                throw e === this.poster && Fe.togglePoster.call(this, !1), t;
            }).then(()=>{
                if (e !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
            }).then(()=>(Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${e}')`,
                    backgroundSize: ""
                }), Fe.togglePoster.call(this, !0), e)));
        },
        checkPlaying (e) {
            R(this.elements.container, this.config.classNames.playing, this.playing), R(this.elements.container, this.config.classNames.paused, this.paused), R(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach((e)=>{
                Object.assign(e, {
                    pressed: this.playing
                }), e.setAttribute("aria-label", ve.get(this.playing ? "pause" : "play", this.config));
            }), S.event(e) && "timeupdate" === e.type || Fe.toggleControls.call(this);
        },
        checkLoading (e) {
            this.loading = [
                "stalled",
                "waiting"
            ].includes(e.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(()=>{
                R(this.elements.container, this.config.classNames.loading, this.loading), Fe.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        toggleControls (e) {
            const { controls: t } = this.elements;
            if (t && this.config.hideControls) {
                const i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || i));
            }
        },
        migrateStyles () {
            Object.values({
                ...this.media.style
            }).filter((e)=>!S.empty(e) && S.string(e) && e.startsWith("--plyr")).forEach((e)=>{
                this.elements.container.style.setProperty(e, this.media.style.getPropertyValue(e)), this.media.style.removeProperty(e);
            }), S.empty(this.media.style) && this.media.removeAttribute("style");
        }
    };
    class Ve {
        constructor(t){
            e(this, "firstTouch", ()=>{
                const { player: e } = this, { elements: t } = e;
                e.touch = !0, R(t.container, e.config.classNames.isTouch, !0);
            }), e(this, "global", (e = !0)=>{
                const { player: t } = this;
                t.config.keyboard.global && Q.call(t, window, "keydown keyup", this.handleKey, e, !1), Q.call(t, document.body, "click", this.toggleMenu, e), G.call(t, document.body, "touchstart", this.firstTouch);
            }), e(this, "container", ()=>{
                const { player: e } = this, { config: t, elements: i, timers: s } = e;
                !t.keyboard.global && t.keyboard.focused && X.call(e, i.container, "keydown keyup", this.handleKey, !1), X.call(e, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (t)=>{
                    const { controls: n } = i;
                    n && "enterfullscreen" === t.type && (n.pressed = !1, n.hover = !1);
                    let a = 0;
                    [
                        "touchstart",
                        "touchmove",
                        "mousemove"
                    ].includes(t.type) && (Fe.toggleControls.call(e, !0), a = e.touch ? 3e3 : 2e3), clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), a);
                });
                const n = ()=>{
                    if (!e.isVimeo || e.config.vimeo.premium) return;
                    const t = i.wrapper, { active: s } = e.fullscreen, [n, a] = ce.call(e), l = ae(`aspect-ratio: ${n} / ${a}`);
                    if (!s) return void (l ? (t.style.width = null, t.style.height = null) : (t.style.maxWidth = null, t.style.margin = null));
                    const [r, o] = [
                        Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
                        Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
                    ], c = r / o > n / a;
                    l ? (t.style.width = c ? "auto" : "100%", t.style.height = c ? "100%" : "auto") : (t.style.maxWidth = c ? o / a * n + "px" : null, t.style.margin = c ? "0 auto" : null);
                }, a = ()=>{
                    clearTimeout(s.resized), s.resized = setTimeout(n, 50);
                };
                X.call(e, i.container, "enterfullscreen exitfullscreen", (t)=>{
                    const { target: s } = e.fullscreen;
                    if (s !== i.container) return;
                    if (!e.isEmbed && S.empty(e.config.ratio)) return;
                    n();
                    ("enterfullscreen" === t.type ? X : J).call(e, window, "resize", a);
                });
            }), e(this, "media", ()=>{
                const { player: e } = this, { elements: t } = e;
                if (X.call(e, e.media, "timeupdate seeking seeked", (t)=>Pe.timeUpdate.call(e, t)), X.call(e, e.media, "durationchange loadeddata loadedmetadata", (t)=>Pe.durationUpdate.call(e, t)), X.call(e, e.media, "ended", ()=>{
                    e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(), e.pause());
                }), X.call(e, e.media, "progress playing seeking seeked", (t)=>Pe.updateProgress.call(e, t)), X.call(e, e.media, "volumechange", (t)=>Pe.updateVolume.call(e, t)), X.call(e, e.media, "playing play pause ended emptied timeupdate", (t)=>Fe.checkPlaying.call(e, t)), X.call(e, e.media, "waiting canplay seeked playing", (t)=>Fe.checkLoading.call(e, t)), e.supported.ui && e.config.clickToPlay && !e.isAudio) {
                    const i = B.call(e, `.${e.config.classNames.video}`);
                    if (!S.element(i)) return;
                    X.call(e, t.container, "click", (s)=>{
                        ([
                            t.container,
                            i
                        ].includes(s.target) || i.contains(s.target)) && (e.touch && e.config.hideControls || (e.ended ? (this.proxy(s, e.restart, "restart"), this.proxy(s, ()=>{
                            ie(e.play());
                        }, "play")) : this.proxy(s, ()=>{
                            ie(e.togglePlay());
                        }, "play")));
                    });
                }
                e.supported.ui && e.config.disableContextMenu && X.call(e, t.wrapper, "contextmenu", (e)=>{
                    e.preventDefault();
                }, !1), X.call(e, e.media, "volumechange", ()=>{
                    e.storage.set({
                        volume: e.volume,
                        muted: e.muted
                    });
                }), X.call(e, e.media, "ratechange", ()=>{
                    Pe.updateSetting.call(e, "speed"), e.storage.set({
                        speed: e.speed
                    });
                }), X.call(e, e.media, "qualitychange", (t)=>{
                    Pe.updateSetting.call(e, "quality", null, t.detail.quality);
                }), X.call(e, e.media, "ready qualitychange", ()=>{
                    Pe.setDownloadUrl.call(e);
                });
                const i = e.config.events.concat([
                    "keyup",
                    "keydown"
                ]).join(" ");
                X.call(e, e.media, i, (i)=>{
                    let { detail: s = {} } = i;
                    "error" === i.type && (s = e.media.error), Z.call(e, t.container, i.type, !0, s);
                });
            }), e(this, "proxy", (e, t, i)=>{
                const { player: s } = this, n = s.config.listeners[i];
                let a = !0;
                S.function(n) && (a = n.call(s, e)), !1 !== a && S.function(t) && t.call(s, e);
            }), e(this, "bind", (e, t, i, s, n = !0)=>{
                const { player: a } = this, l = a.config.listeners[s], r = S.function(l);
                X.call(a, e, t, (e)=>this.proxy(e, i, s), n && !r);
            }), e(this, "controls", ()=>{
                const { player: e } = this, { elements: t } = e, i = M.isIE ? "change" : "input";
                if (t.buttons.play && Array.from(t.buttons.play).forEach((t)=>{
                    this.bind(t, "click", ()=>{
                        ie(e.togglePlay());
                    }, "play");
                }), this.bind(t.buttons.restart, "click", e.restart, "restart"), this.bind(t.buttons.rewind, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.rewind();
                }, "rewind"), this.bind(t.buttons.fastForward, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.forward();
                }, "fastForward"), this.bind(t.buttons.mute, "click", ()=>{
                    e.muted = !e.muted;
                }, "mute"), this.bind(t.buttons.captions, "click", ()=>e.toggleCaptions()), this.bind(t.buttons.download, "click", ()=>{
                    Z.call(e, e.media, "download");
                }, "download"), this.bind(t.buttons.fullscreen, "click", ()=>{
                    e.fullscreen.toggle();
                }, "fullscreen"), this.bind(t.buttons.pip, "click", ()=>{
                    e.pip = "toggle";
                }, "pip"), this.bind(t.buttons.airplay, "click", e.airplay, "airplay"), this.bind(t.buttons.settings, "click", (t)=>{
                    t.stopPropagation(), t.preventDefault(), Pe.toggleMenu.call(e, t);
                }, null, !1), this.bind(t.buttons.settings, "keyup", (t)=>{
                    [
                        " ",
                        "Enter"
                    ].includes(t.key) && ("Enter" !== t.key ? (t.preventDefault(), t.stopPropagation(), Pe.toggleMenu.call(e, t)) : Pe.focusFirstMenuItem.call(e, null, !0));
                }, null, !1), this.bind(t.settings.menu, "keydown", (t)=>{
                    "Escape" === t.key && Pe.toggleMenu.call(e, t);
                }), this.bind(t.inputs.seek, "mousedown mousemove", (e)=>{
                    const i = t.progress.getBoundingClientRect(), s = 100 / i.width * (e.pageX - i.left);
                    e.currentTarget.setAttribute("seek-value", s);
                }), this.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (t)=>{
                    const i = t.currentTarget, s = "play-on-seeked";
                    if (S.keyboardEvent(t) && ![
                        "ArrowLeft",
                        "ArrowRight"
                    ].includes(t.key)) return;
                    e.lastSeekTime = Date.now();
                    const n = i.hasAttribute(s), a = [
                        "mouseup",
                        "touchend",
                        "keyup"
                    ].includes(t.type);
                    n && a ? (i.removeAttribute(s), ie(e.play())) : !a && e.playing && (i.setAttribute(s, ""), e.pause());
                }), M.isIos) {
                    const t = U.call(e, 'input[type="range"]');
                    Array.from(t).forEach((e)=>this.bind(e, i, (e)=>P(e.target)));
                }
                this.bind(t.inputs.seek, i, (t)=>{
                    const i = t.currentTarget;
                    let s = i.getAttribute("seek-value");
                    S.empty(s) && (s = i.value), i.removeAttribute("seek-value"), e.currentTime = s / i.max * e.duration;
                }, "seek"), this.bind(t.progress, "mouseenter mouseleave mousemove", (t)=>Pe.updateSeekTooltip.call(e, t)), this.bind(t.progress, "mousemove touchmove", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startMove(t);
                }), this.bind(t.progress, "mouseleave touchend click", ()=>{
                    const { previewThumbnails: t } = e;
                    t && t.loaded && t.endMove(!1, !0);
                }), this.bind(t.progress, "mousedown touchstart", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startScrubbing(t);
                }), this.bind(t.progress, "mouseup touchend", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.endScrubbing(t);
                }), M.isWebKit && Array.from(U.call(e, 'input[type="range"]')).forEach((t)=>{
                    this.bind(t, "input", (t)=>Pe.updateRangeFill.call(e, t.target));
                }), e.config.toggleInvert && !S.element(t.display.duration) && this.bind(t.display.currentTime, "click", ()=>{
                    0 !== e.currentTime && (e.config.invertTime = !e.config.invertTime, Pe.timeUpdate.call(e));
                }), this.bind(t.inputs.volume, i, (t)=>{
                    e.volume = t.target.value;
                }, "volume"), this.bind(t.controls, "mouseenter mouseleave", (i)=>{
                    t.controls.hover = !e.touch && "mouseenter" === i.type;
                }), t.fullscreen && Array.from(t.fullscreen.children).filter((e)=>!e.contains(t.container)).forEach((i)=>{
                    this.bind(i, "mouseenter mouseleave", (i)=>{
                        t.controls && (t.controls.hover = !e.touch && "mouseenter" === i.type);
                    });
                }), this.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", (e)=>{
                    t.controls.pressed = [
                        "mousedown",
                        "touchstart"
                    ].includes(e.type);
                }), this.bind(t.controls, "focusin", ()=>{
                    const { config: i, timers: s } = e;
                    R(t.controls, i.classNames.noTransition, !0), Fe.toggleControls.call(e, !0), setTimeout(()=>{
                        R(t.controls, i.classNames.noTransition, !1);
                    }, 0);
                    const n = this.touch ? 3e3 : 4e3;
                    clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), n);
                }), this.bind(t.inputs.volume, "wheel", (t)=>{
                    const i = t.webkitDirectionInvertedFromDevice, [s, n] = [
                        t.deltaX,
                        -t.deltaY
                    ].map((e)=>i ? -e : e), a = Math.sign(Math.abs(s) > Math.abs(n) ? s : n);
                    e.increaseVolume(a / 50);
                    const { volume: l } = e.media;
                    (1 === a && l < 1 || -1 === a && l > 0) && t.preventDefault();
                }, "volume", !1);
            }), this.player = t, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this);
        }
        handleKey(e) {
            const { player: t } = this, { elements: i } = t, { key: s, type: n, altKey: a, ctrlKey: l, metaKey: r, shiftKey: o } = e, c = "keydown" === n, u = c && s === this.lastKey;
            if (a || l || r || o) return;
            if (!s) return;
            if (c) {
                const n = document.activeElement;
                if (S.element(n)) {
                    const { editable: s } = t.config.selectors, { seek: a } = i.inputs;
                    if (n !== a && V(n, s)) return;
                    if (" " === e.key && V(n, 'button, [role^="menuitem"]')) return;
                }
                switch([
                    " ",
                    "ArrowLeft",
                    "ArrowUp",
                    "ArrowRight",
                    "ArrowDown",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "c",
                    "f",
                    "k",
                    "l",
                    "m"
                ].includes(s) && (e.preventDefault(), e.stopPropagation()), s){
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        u || (h = parseInt(s, 10), t.currentTime = t.duration / 10 * h);
                        break;
                    case " ":
                    case "k":
                        u || ie(t.togglePlay());
                        break;
                    case "ArrowUp":
                        t.increaseVolume(.1);
                        break;
                    case "ArrowDown":
                        t.decreaseVolume(.1);
                        break;
                    case "m":
                        u || (t.muted = !t.muted);
                        break;
                    case "ArrowRight":
                        t.forward();
                        break;
                    case "ArrowLeft":
                        t.rewind();
                        break;
                    case "f":
                        t.fullscreen.toggle();
                        break;
                    case "c":
                        u || t.toggleCaptions();
                        break;
                    case "l":
                        t.loop = !t.loop;
                }
                "Escape" === s && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), this.lastKey = s;
            } else this.lastKey = null;
            var h;
        }
        toggleMenu(e) {
            Pe.toggleMenu.call(this.player, e);
        }
    }
    "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
    var Ue = function(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }(function(e, t) {
        e.exports = function() {
            var e = function() {}, t = {}, i = {}, s = {};
            function n(e, t) {
                e = e.push ? e : [
                    e
                ];
                var n, a, l, r = [], o = e.length, c = o;
                for(n = function(e, i) {
                    i.length && r.push(e), --c || t(r);
                }; o--;)a = e[o], (l = i[a]) ? n(a, l) : (s[a] = s[a] || []).push(n);
            }
            function a(e, t) {
                if (e) {
                    var n = s[e];
                    if (i[e] = t, n) for(; n.length;)n[0](e, t), n.splice(0, 1);
                }
            }
            function l(t, i) {
                t.call && (t = {
                    success: t
                }), i.length ? (t.error || e)(i) : (t.success || e)(t);
            }
            function r(t, i, s, n) {
                var a, l, o = document, c = s.async, u = (s.numRetries || 0) + 1, h = s.before || e, d = t.replace(/[\?|#].*$/, ""), m = t.replace(/^(css|img)!/, "");
                n = n || 0, /(^css!|\.css$)/.test(d) ? ((l = o.createElement("link")).rel = "stylesheet", l.href = m, (a = "hideFocus" in l) && l.relList && (a = 0, l.rel = "preload", l.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d) ? (l = o.createElement("img")).src = m : ((l = o.createElement("script")).src = t, l.async = void 0 === c || c), l.onload = l.onerror = l.onbeforeload = function(e) {
                    var o = e.type[0];
                    if (a) try {
                        l.sheet.cssText.length || (o = "e");
                    } catch (e) {
                        18 != e.code && (o = "e");
                    }
                    if ("e" == o) {
                        if ((n += 1) < u) return r(t, i, s, n);
                    } else if ("preload" == l.rel && "style" == l.as) return l.rel = "stylesheet";
                    i(t, o, e.defaultPrevented);
                }, !1 !== h(t, l) && o.head.appendChild(l);
            }
            function o(e, t, i) {
                var s, n, a = (e = e.push ? e : [
                    e
                ]).length, l = a, o = [];
                for(s = function(e, i, s) {
                    if ("e" == i && o.push(e), "b" == i) {
                        if (!s) return;
                        o.push(e);
                    }
                    --a || t(o);
                }, n = 0; n < l; n++)r(e[n], s, i);
            }
            function c(e, i, s) {
                var n, r;
                if (i && i.trim && (n = i), r = (n ? s : i) || {}, n) {
                    if (n in t) throw "LoadJS";
                    t[n] = !0;
                }
                function c(t, i) {
                    o(e, function(e) {
                        l(r, e), t && l({
                            success: t,
                            error: i
                        }, e), a(n, e);
                    }, r);
                }
                if (r.returnPromise) return new Promise(c);
                c();
            }
            return c.ready = function(e, t) {
                return n(e, function(e) {
                    l(t, e);
                }), c;
            }, c.done = function(e) {
                a(e, []);
            }, c.reset = function() {
                t = {}, i = {}, s = {};
            }, c.isDefined = function(e) {
                return e in t;
            }, c;
        }();
    });
    function Be(e) {
        return new Promise((t, i)=>{
            Ue(e, {
                success: t,
                error: i
            });
        });
    }
    function We(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    const ze = {
        setup () {
            const e = this;
            R(e.elements.wrapper, e.config.classNames.embed, !0), e.options.speed = e.config.speed.options, ue.call(e), S.object(window.Vimeo) ? ze.ready.call(e) : Be(e.config.urls.vimeo.sdk).then(()=>{
                ze.ready.call(e);
            }).catch((t)=>{
                e.debug.warn("Vimeo SDK (player.js) failed to load", t);
            });
        },
        ready () {
            const e = this, t = e.config.vimeo, { premium: i, referrerPolicy: s, ...n } = t;
            let a = e.media.getAttribute("src"), l = "";
            S.empty(a) ? (a = e.media.getAttribute(e.config.attributes.embed.id), l = e.media.getAttribute(e.config.attributes.embed.hash)) : l = function(e) {
                const t = e.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
                return t && 5 === t.length ? t[4] : null;
            }(a);
            const r = l ? {
                h: l
            } : {};
            i && Object.assign(n, {
                controls: !1,
                sidedock: !1
            });
            const o = Ne({
                loop: e.config.loop.active,
                autoplay: e.autoplay,
                muted: e.muted,
                gesture: "media",
                playsinline: e.config.playsinline,
                ...r,
                ...n
            }), c = (u = a, S.empty(u) ? null : S.number(Number(u)) ? u : u.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : u);
            var u;
            const h = $("iframe"), d = me(e.config.urls.vimeo.iframe, c, o);
            if (h.setAttribute("src", d), h.setAttribute("allowfullscreen", ""), h.setAttribute("allow", [
                "autoplay",
                "fullscreen",
                "picture-in-picture",
                "encrypted-media",
                "accelerometer",
                "gyroscope"
            ].join("; ")), S.empty(s) || h.setAttribute("referrerPolicy", s), i || !t.customControls) h.setAttribute("data-poster", e.poster), e.media = q(h, e.media);
            else {
                const t = $("div", {
                    class: e.config.classNames.embedContainer,
                    "data-poster": e.poster
                });
                t.appendChild(h), e.media = q(t, e.media);
            }
            t.customControls || Te(me(e.config.urls.vimeo.api, d)).then((t)=>{
                !S.empty(t) && t.thumbnail_url && Fe.setPoster.call(e, t.thumbnail_url).catch(()=>{});
            }), e.embed = new window.Vimeo.Player(h, {
                autopause: e.config.autopause,
                muted: e.muted
            }), e.media.paused = !0, e.media.currentTime = 0, e.supported.ui && e.embed.disableTextTrack(), e.media.play = ()=>(We.call(e, !0), e.embed.play()), e.media.pause = ()=>(We.call(e, !1), e.embed.pause()), e.media.stop = ()=>{
                e.pause(), e.currentTime = 0;
            };
            let { currentTime: m } = e.media;
            Object.defineProperty(e.media, "currentTime", {
                get: ()=>m,
                set (t) {
                    const { embed: i, media: s, paused: n, volume: a } = e, l = n && !i.hasPlayed;
                    s.seeking = !0, Z.call(e, s, "seeking"), Promise.resolve(l && i.setVolume(0)).then(()=>i.setCurrentTime(t)).then(()=>l && i.pause()).then(()=>l && i.setVolume(a)).catch(()=>{});
                }
            });
            let p = e.config.speed.selected;
            Object.defineProperty(e.media, "playbackRate", {
                get: ()=>p,
                set (t) {
                    e.embed.setPlaybackRate(t).then(()=>{
                        p = t, Z.call(e, e.media, "ratechange");
                    }).catch(()=>{
                        e.options.speed = [
                            1
                        ];
                    });
                }
            });
            let { volume: g } = e.config;
            Object.defineProperty(e.media, "volume", {
                get: ()=>g,
                set (t) {
                    e.embed.setVolume(t).then(()=>{
                        g = t, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let { muted: f } = e.config;
            Object.defineProperty(e.media, "muted", {
                get: ()=>f,
                set (t) {
                    const i = !!S.boolean(t) && t;
                    e.embed.setMuted(!!i || e.config.muted).then(()=>{
                        f = i, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let y, { loop: b } = e.config;
            Object.defineProperty(e.media, "loop", {
                get: ()=>b,
                set (t) {
                    const i = S.boolean(t) ? t : e.config.loop.active;
                    e.embed.setLoop(i).then(()=>{
                        b = i;
                    });
                }
            }), e.embed.getVideoUrl().then((t)=>{
                y = t, Pe.setDownloadUrl.call(e);
            }).catch((e)=>{
                this.debug.warn(e);
            }), Object.defineProperty(e.media, "currentSrc", {
                get: ()=>y
            }), Object.defineProperty(e.media, "ended", {
                get: ()=>e.currentTime === e.duration
            }), Promise.all([
                e.embed.getVideoWidth(),
                e.embed.getVideoHeight()
            ]).then((t)=>{
                const [i, s] = t;
                e.embed.ratio = he(i, s), ue.call(this);
            }), e.embed.setAutopause(e.config.autopause).then((t)=>{
                e.config.autopause = t;
            }), e.embed.getVideoTitle().then((t)=>{
                e.config.title = t, Fe.setTitle.call(this);
            }), e.embed.getCurrentTime().then((t)=>{
                m = t, Z.call(e, e.media, "timeupdate");
            }), e.embed.getDuration().then((t)=>{
                e.media.duration = t, Z.call(e, e.media, "durationchange");
            }), e.embed.getTextTracks().then((t)=>{
                e.media.textTracks = t, xe.setup.call(e);
            }), e.embed.on("cuechange", ({ cues: t = [] })=>{
                const i = t.map((e)=>(function(e) {
                        const t = document.createDocumentFragment(), i = document.createElement("div");
                        return t.appendChild(i), i.innerHTML = e, t.firstChild.innerText;
                    })(e.text));
                xe.updateCues.call(e, i);
            }), e.embed.on("loaded", ()=>{
                if (e.embed.getPaused().then((t)=>{
                    We.call(e, !t), t || Z.call(e, e.media, "playing");
                }), S.element(e.embed.element) && e.supported.ui) e.embed.element.setAttribute("tabindex", -1);
            }), e.embed.on("bufferstart", ()=>{
                Z.call(e, e.media, "waiting");
            }), e.embed.on("bufferend", ()=>{
                Z.call(e, e.media, "playing");
            }), e.embed.on("play", ()=>{
                We.call(e, !0), Z.call(e, e.media, "playing");
            }), e.embed.on("pause", ()=>{
                We.call(e, !1);
            }), e.embed.on("timeupdate", (t)=>{
                e.media.seeking = !1, m = t.seconds, Z.call(e, e.media, "timeupdate");
            }), e.embed.on("progress", (t)=>{
                e.media.buffered = t.percent, Z.call(e, e.media, "progress"), 1 === parseInt(t.percent, 10) && Z.call(e, e.media, "canplaythrough"), e.embed.getDuration().then((t)=>{
                    t !== e.media.duration && (e.media.duration = t, Z.call(e, e.media, "durationchange"));
                });
            }), e.embed.on("seeked", ()=>{
                e.media.seeking = !1, Z.call(e, e.media, "seeked");
            }), e.embed.on("ended", ()=>{
                e.media.paused = !0, Z.call(e, e.media, "ended");
            }), e.embed.on("error", (t)=>{
                e.media.error = t, Z.call(e, e.media, "error");
            }), t.customControls && setTimeout(()=>Fe.build.call(e), 0);
        }
    };
    function Ke(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    function Ye(e) {
        return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
    }
    const Qe = {
        setup () {
            if (R(this.elements.wrapper, this.config.classNames.embed, !0), S.object(window.YT) && S.function(window.YT.Player)) Qe.ready.call(this);
            else {
                const e = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = ()=>{
                    S.function(e) && e(), Qe.ready.call(this);
                }, Be(this.config.urls.youtube.sdk).catch((e)=>{
                    this.debug.warn("YouTube API failed to load", e);
                });
            }
        },
        getTitle (e) {
            Te(me(this.config.urls.youtube.api, e)).then((e)=>{
                if (S.object(e)) {
                    const { title: t, height: i, width: s } = e;
                    this.config.title = t, Fe.setTitle.call(this), this.embed.ratio = he(s, i);
                }
                ue.call(this);
            }).catch(()=>{
                ue.call(this);
            });
        },
        ready () {
            const e = this, t = e.config.youtube, i = e.media && e.media.getAttribute("id");
            if (!S.empty(i) && i.startsWith("youtube-")) return;
            let s = e.media.getAttribute("src");
            S.empty(s) && (s = e.media.getAttribute(this.config.attributes.embed.id));
            const n = (a = s, S.empty(a) ? null : a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a);
            var a;
            const l = $("div", {
                id: `${e.provider}-${Math.floor(1e4 * Math.random())}`,
                "data-poster": t.customControls ? e.poster : void 0
            });
            if (e.media = q(l, e.media), t.customControls) {
                const t = (e)=>`https://i.ytimg.com/vi/${n}/${e}default.jpg`;
                Re(t("maxres"), 121).catch(()=>Re(t("sd"), 121)).catch(()=>Re(t("hq"))).then((t)=>Fe.setPoster.call(e, t.src)).then((t)=>{
                    t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover");
                }).catch(()=>{});
            }
            e.embed = new window.YT.Player(e.media, {
                videoId: n,
                host: Ye(t),
                playerVars: x({}, {
                    autoplay: e.config.autoplay ? 1 : 0,
                    hl: e.config.hl,
                    controls: e.supported.ui && t.customControls ? 0 : 1,
                    disablekb: 1,
                    playsinline: e.config.playsinline && !e.config.fullscreen.iosNative ? 1 : 0,
                    cc_load_policy: e.captions.active ? 1 : 0,
                    cc_lang_pref: e.config.captions.language,
                    widget_referrer: window ? window.location.href : null
                }, t),
                events: {
                    onError (t) {
                        if (!e.media.error) {
                            const i = t.data, s = {
                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                150: "The owner of the requested video does not allow it to be played in embedded players."
                            }[i] || "An unknown error occurred";
                            e.media.error = {
                                code: i,
                                message: s
                            }, Z.call(e, e.media, "error");
                        }
                    },
                    onPlaybackRateChange (t) {
                        const i = t.target;
                        e.media.playbackRate = i.getPlaybackRate(), Z.call(e, e.media, "ratechange");
                    },
                    onReady (i) {
                        if (S.function(e.media.play)) return;
                        const s = i.target;
                        Qe.getTitle.call(e, n), e.media.play = ()=>{
                            Ke.call(e, !0), s.playVideo();
                        }, e.media.pause = ()=>{
                            Ke.call(e, !1), s.pauseVideo();
                        }, e.media.stop = ()=>{
                            s.stopVideo();
                        }, e.media.duration = s.getDuration(), e.media.paused = !0, e.media.currentTime = 0, Object.defineProperty(e.media, "currentTime", {
                            get: ()=>Number(s.getCurrentTime()),
                            set (t) {
                                e.paused && !e.embed.hasPlayed && e.embed.mute(), e.media.seeking = !0, Z.call(e, e.media, "seeking"), s.seekTo(t);
                            }
                        }), Object.defineProperty(e.media, "playbackRate", {
                            get: ()=>s.getPlaybackRate(),
                            set (e) {
                                s.setPlaybackRate(e);
                            }
                        });
                        let { volume: a } = e.config;
                        Object.defineProperty(e.media, "volume", {
                            get: ()=>a,
                            set (t) {
                                a = t, s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        });
                        let { muted: l } = e.config;
                        Object.defineProperty(e.media, "muted", {
                            get: ()=>l,
                            set (t) {
                                const i = S.boolean(t) ? t : l;
                                l = i, s[i ? "mute" : "unMute"](), s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        }), Object.defineProperty(e.media, "currentSrc", {
                            get: ()=>s.getVideoUrl()
                        }), Object.defineProperty(e.media, "ended", {
                            get: ()=>e.currentTime === e.duration
                        });
                        const r = s.getAvailablePlaybackRates();
                        e.options.speed = r.filter((t)=>e.config.speed.options.includes(t)), e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1), Z.call(e, e.media, "timeupdate"), Z.call(e, e.media, "durationchange"), clearInterval(e.timers.buffering), e.timers.buffering = setInterval(()=>{
                            e.media.buffered = s.getVideoLoadedFraction(), (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && Z.call(e, e.media, "progress"), e.media.lastBuffered = e.media.buffered, 1 === e.media.buffered && (clearInterval(e.timers.buffering), Z.call(e, e.media, "canplaythrough"));
                        }, 200), t.customControls && setTimeout(()=>Fe.build.call(e), 50);
                    },
                    onStateChange (i) {
                        const s = i.target;
                        clearInterval(e.timers.playing);
                        switch(e.media.seeking && [
                            1,
                            2
                        ].includes(i.data) && (e.media.seeking = !1, Z.call(e, e.media, "seeked")), i.data){
                            case -1:
                                Z.call(e, e.media, "timeupdate"), e.media.buffered = s.getVideoLoadedFraction(), Z.call(e, e.media, "progress");
                                break;
                            case 0:
                                Ke.call(e, !1), e.media.loop ? (s.stopVideo(), s.playVideo()) : Z.call(e, e.media, "ended");
                                break;
                            case 1:
                                t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed ? e.media.pause() : (Ke.call(e, !0), Z.call(e, e.media, "playing"), e.timers.playing = setInterval(()=>{
                                    Z.call(e, e.media, "timeupdate");
                                }, 50), e.media.duration !== s.getDuration() && (e.media.duration = s.getDuration(), Z.call(e, e.media, "durationchange")));
                                break;
                            case 2:
                                e.muted || e.embed.unMute(), Ke.call(e, !1);
                                break;
                            case 3:
                                Z.call(e, e.media, "waiting");
                        }
                        Z.call(e, e.elements.container, "statechange", !1, {
                            code: i.data
                        });
                    }
                }
            });
        }
    }, Xe = {
        setup () {
            this.media ? (R(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), R(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && R(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = $("div", {
                class: this.config.classNames.video
            }), L(this.media, this.elements.wrapper), this.elements.poster = $("div", {
                class: this.config.classNames.poster
            }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? de.setup.call(this) : this.isYouTube ? Qe.setup.call(this) : this.isVimeo && ze.setup.call(this)) : this.debug.warn("No media element found!");
        }
    };
    class Je {
        constructor(t){
            e(this, "load", ()=>{
                this.enabled && (S.object(window.google) && S.object(window.google.ima) ? this.ready() : Be(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    this.trigger("error", new Error("Google IMA SDK failed to load"));
                }));
            }), e(this, "ready", ()=>{
                var e;
                this.enabled || ((e = this).manager && e.manager.destroy(), e.elements.displayContainer && e.elements.displayContainer.destroy(), e.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(()=>{
                    this.clearSafetyTimer("onAdsManagerLoaded()");
                }), this.listeners(), this.setupIMA();
            }), e(this, "setupIMA", ()=>{
                this.elements.container = $("div", {
                    class: this.player.config.classNames.ads
                }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (e)=>this.onAdsManagerLoaded(e), !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e), !1), this.requestAds();
            }), e(this, "requestAds", ()=>{
                const { container: e } = this.player.elements;
                try {
                    const t = new google.ima.AdsRequest;
                    t.adTagUrl = this.tagUrl, t.linearAdSlotWidth = e.offsetWidth, t.linearAdSlotHeight = e.offsetHeight, t.nonLinearAdSlotWidth = e.offsetWidth, t.nonLinearAdSlotHeight = e.offsetHeight, t.forceNonLinearFullSlot = !1, t.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(t);
                } catch (e) {
                    this.onAdError(e);
                }
            }), e(this, "pollCountdown", (e = !1)=>{
                if (!e) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
                this.countdownTimer = setInterval(()=>{
                    const e = Ee(Math.max(this.manager.getRemainingTime(), 0)), t = `${ve.get("advertisement", this.player.config)} - ${e}`;
                    this.elements.container.setAttribute("data-badge-text", t);
                }, 100);
            }), e(this, "onAdsManagerLoaded", (e)=>{
                if (!this.enabled) return;
                const t = new google.ima.AdsRenderingSettings;
                t.restoreCustomPlaybackStateOnAdBreakComplete = !0, t.enablePreloading = !0, this.manager = e.getAdsManager(this.player, t), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e)), Object.keys(google.ima.AdEvent.Type).forEach((e)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[e], (e)=>this.onAdEvent(e));
                }), this.trigger("loaded");
            }), e(this, "addCuePoints", ()=>{
                S.empty(this.cuePoints) || this.cuePoints.forEach((e)=>{
                    if (0 !== e && -1 !== e && e < this.player.duration) {
                        const t = this.player.elements.progress;
                        if (S.element(t)) {
                            const i = 100 / this.player.duration * e, s = $("span", {
                                class: this.player.config.classNames.cues
                            });
                            s.style.left = `${i.toString()}%`, t.appendChild(s);
                        }
                    }
                });
            }), e(this, "onAdEvent", (e)=>{
                const { container: t } = this.player.elements, i = e.getAd(), s = e.getAdData();
                switch(((e)=>{
                    Z.call(this.player, this.player.media, `ads${e.replace(/_/g, "").toLowerCase()}`);
                })(e.type), e.type){
                    case google.ima.AdEvent.Type.LOADED:
                        this.trigger("loaded"), this.pollCountdown(!0), i.isLinear() || (i.width = t.offsetWidth, i.height = t.offsetHeight);
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        this.player.ended ? this.loadAds() : this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        this.pollCountdown(), this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        s.adError && this.player.debug.warn(`Non-fatal ad error: ${s.adError.getMessage()}`);
                }
            }), e(this, "onAdError", (e)=>{
                this.cancel(), this.player.debug.warn("Ads error", e);
            }), e(this, "listeners", ()=>{
                const { container: e } = this.player.elements;
                let t;
                this.player.on("canplay", ()=>{
                    this.addCuePoints();
                }), this.player.on("ended", ()=>{
                    this.loader.contentComplete();
                }), this.player.on("timeupdate", ()=>{
                    t = this.player.currentTime;
                }), this.player.on("seeked", ()=>{
                    const e = this.player.currentTime;
                    S.empty(this.cuePoints) || this.cuePoints.forEach((i, s)=>{
                        t < i && i < e && (this.manager.discardAdBreak(), this.cuePoints.splice(s, 1));
                    });
                }), window.addEventListener("resize", ()=>{
                    this.manager && this.manager.resize(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            }), e(this, "play", ()=>{
                const { container: e } = this.player.elements;
                this.managerPromise || this.resumeContent(), this.managerPromise.then(()=>{
                    this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
                    try {
                        this.initialized || (this.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = !0;
                    } catch (e) {
                        this.onAdError(e);
                    }
                }).catch(()=>{});
            }), e(this, "resumeContent", ()=>{
                this.elements.container.style.zIndex = "", this.playing = !1, ie(this.player.media.play());
            }), e(this, "pauseContent", ()=>{
                this.elements.container.style.zIndex = 3, this.playing = !0, this.player.media.pause();
            }), e(this, "cancel", ()=>{
                this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
            }), e(this, "loadAds", ()=>{
                this.managerPromise.then(()=>{
                    this.manager && this.manager.destroy(), this.managerPromise = new Promise((e)=>{
                        this.on("loaded", e), this.player.debug.log(this.manager);
                    }), this.initialized = !1, this.requestAds();
                }).catch(()=>{});
            }), e(this, "trigger", (e, ...t)=>{
                const i = this.events[e];
                S.array(i) && i.forEach((e)=>{
                    S.function(e) && e.apply(this, t);
                });
            }), e(this, "on", (e, t)=>(S.array(this.events[e]) || (this.events[e] = []), this.events[e].push(t), this)), e(this, "startSafetyTimer", (e, t)=>{
                this.player.debug.log(`Safety timer invoked from: ${t}`), this.safetyTimer = setTimeout(()=>{
                    this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
                }, e);
            }), e(this, "clearSafetyTimer", (e)=>{
                S.nullOrUndefined(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
            }), this.player = t, this.config = t.config.ads, this.playing = !1, this.initialized = !1, this.elements = {
                container: null,
                displayContainer: null
            }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((e, t)=>{
                this.on("loaded", e), this.on("error", t);
            }), this.load();
        }
        get enabled() {
            const { config: e } = this;
            return this.player.isHTML5 && this.player.isVideo && e.enabled && (!S.empty(e.publisherId) || S.url(e.tagUrl));
        }
        get tagUrl() {
            const { config: e } = this;
            if (S.url(e.tagUrl)) return e.tagUrl;
            return `https://go.aniview.com/api/adserver6/vast/?${Ne({
                AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                AV_CHANNELID: "5a0458dc28a06145e4519d21",
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: e.publisherId
            })}`;
        }
    }
    function Ge(e = 0, t = 0, i = 255) {
        return Math.min(Math.max(e, t), i);
    }
    const Ze = (e)=>{
        const t = [];
        return e.split(/\r\n\r\n|\n\n|\r\r/).forEach((e)=>{
            const i = {};
            e.split(/\r\n|\n|\r/).forEach((e)=>{
                if (S.number(i.startTime)) {
                    if (!S.empty(e.trim()) && S.empty(i.text)) {
                        const t = e.trim().split("#xywh=");
                        [i.text] = t, t[1] && ([i.x, i.y, i.w, i.h] = t[1].split(","));
                    }
                } else {
                    const t = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                    t && (i.startTime = 60 * Number(t[1] || 0) * 60 + 60 * Number(t[2]) + Number(t[3]) + Number(`0.${t[4]}`), i.endTime = 60 * Number(t[6] || 0) * 60 + 60 * Number(t[7]) + Number(t[8]) + Number(`0.${t[9]}`));
                }
            }), i.text && t.push(i);
        }), t;
    }, et = (e, t)=>{
        const i = {};
        return e > t.width / t.height ? (i.width = t.width, i.height = 1 / e * t.width) : (i.height = t.height, i.width = e * t.height), i;
    };
    class tt {
        constructor(t){
            e(this, "load", ()=>{
                this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(()=>{
                    this.enabled && (this.render(), this.determineContainerAutoSizing(), this.listeners(), this.loaded = !0);
                });
            }), e(this, "getThumbnails", ()=>new Promise((e)=>{
                    const { src: t } = this.player.config.previewThumbnails;
                    if (S.empty(t)) throw new Error("Missing previewThumbnails.src config attribute");
                    const i = ()=>{
                        this.thumbnails.sort((e, t)=>e.height - t.height), this.player.debug.log("Preview thumbnails", this.thumbnails), e();
                    };
                    if (S.function(t)) t((e)=>{
                        this.thumbnails = e, i();
                    });
                    else {
                        const e = (S.string(t) ? [
                            t
                        ] : t).map((e)=>this.getThumbnail(e));
                        Promise.all(e).then(i);
                    }
                })), e(this, "getThumbnail", (e)=>new Promise((t)=>{
                    Te(e).then((i)=>{
                        const s = {
                            frames: Ze(i),
                            height: null,
                            urlPrefix: ""
                        };
                        s.frames[0].text.startsWith("/") || s.frames[0].text.startsWith("http://") || s.frames[0].text.startsWith("https://") || (s.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                        const n = new Image;
                        n.onload = ()=>{
                            s.height = n.naturalHeight, s.width = n.naturalWidth, this.thumbnails.push(s), t();
                        }, n.src = s.urlPrefix + s.frames[0].text;
                    });
                })), e(this, "startMove", (e)=>{
                if (this.loaded && S.event(e) && [
                    "touchmove",
                    "mousemove"
                ].includes(e.type) && this.player.media.duration) {
                    if ("touchmove" === e.type) this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                    else {
                        var t, i;
                        const s = this.player.elements.progress.getBoundingClientRect(), n = 100 / s.width * (e.pageX - s.left);
                        this.seekTime = this.player.media.duration * (n / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = e.pageX, this.elements.thumb.time.innerText = Ee(this.seekTime);
                        const a = null === (t = this.player.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(this.seekTime));
                        a && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${a.label}<br>`);
                    }
                    this.showImageAtCurrentTime();
                }
            }), e(this, "endMove", ()=>{
                this.toggleThumbContainer(!1, !0);
            }), e(this, "startScrubbing", (e)=>{
                (S.nullOrUndefined(e.button) || !1 === e.button || 0 === e.button) && (this.mouseDown = !0, this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
            }), e(this, "endScrubbing", ()=>{
                this.mouseDown = !1, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(!1) : G.call(this.player, this.player.media, "timeupdate", ()=>{
                    this.mouseDown || this.toggleScrubbingContainer(!1);
                });
            }), e(this, "listeners", ()=>{
                this.player.on("play", ()=>{
                    this.toggleThumbContainer(!1, !0);
                }), this.player.on("seeked", ()=>{
                    this.toggleThumbContainer(!1);
                }), this.player.on("timeupdate", ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            }), e(this, "render", ()=>{
                this.elements.thumb.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                }), this.elements.thumb.imageContainer = $("div", {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                const e = $("div", {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = $("span", {}, "00:00"), e.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(e), S.element(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            }), e(this, "destroy", ()=>{
                this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
            }), e(this, "showImageAtCurrentTime", ()=>{
                this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
                const e = this.thumbnails[0].frames.findIndex((e)=>this.seekTime >= e.startTime && this.seekTime <= e.endTime), t = e >= 0;
                let i = 0;
                this.mouseDown || this.toggleThumbContainer(t), t && (this.thumbnails.forEach((t, s)=>{
                    this.loadedImages.includes(t.frames[e].text) && (i = s);
                }), e !== this.showingThumb && (this.showingThumb = e, this.loadImage(i)));
            }), e(this, "loadImage", (e = 0)=>{
                const t = this.showingThumb, i = this.thumbnails[e], { urlPrefix: s } = i, n = i.frames[t], a = i.frames[t].text, l = s + a;
                if (this.currentImageElement && this.currentImageElement.dataset.filename === a) this.showImage(this.currentImageElement, n, e, t, a, !1), this.currentImageElement.dataset.index = t, this.removeOldImages(this.currentImageElement);
                else {
                    this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
                    const i = new Image;
                    i.src = l, i.dataset.index = t, i.dataset.filename = a, this.showingThumbFilename = a, this.player.debug.log(`Loading image: ${l}`), i.onload = ()=>this.showImage(i, n, e, t, a, !0), this.loadingImage = i, this.removeOldImages(i);
                }
            }), e(this, "showImage", (e, t, i, s, n, a = !0)=>{
                this.player.debug.log(`Showing thumb: ${n}. num: ${s}. qual: ${i}. newimg: ${a}`), this.setImageSizeAndOffset(e, t), a && (this.currentImageContainer.appendChild(e), this.currentImageElement = e, this.loadedImages.includes(n) || this.loadedImages.push(n)), this.preloadNearby(s, !0).then(this.preloadNearby(s, !1)).then(this.getHigherQuality(i, e, t, n));
            }), e(this, "removeOldImages", (e)=>{
                Array.from(this.currentImageContainer.children).forEach((t)=>{
                    if ("img" !== t.tagName.toLowerCase()) return;
                    const i = this.usingSprites ? 500 : 1e3;
                    if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                        t.dataset.deleting = !0;
                        const { currentImageContainer: e } = this;
                        setTimeout(()=>{
                            e.removeChild(t), this.player.debug.log(`Removing thumb: ${t.dataset.filename}`);
                        }, i);
                    }
                });
            }), e(this, "preloadNearby", (e, t = !0)=>new Promise((i)=>{
                    setTimeout(()=>{
                        const s = this.thumbnails[0].frames[e].text;
                        if (this.showingThumbFilename === s) {
                            let n;
                            n = t ? this.thumbnails[0].frames.slice(e) : this.thumbnails[0].frames.slice(0, e).reverse();
                            let a = !1;
                            n.forEach((e)=>{
                                const t = e.text;
                                if (t !== s && !this.loadedImages.includes(t)) {
                                    a = !0, this.player.debug.log(`Preloading thumb filename: ${t}`);
                                    const { urlPrefix: e } = this.thumbnails[0], s = e + t, n = new Image;
                                    n.src = s, n.onload = ()=>{
                                        this.player.debug.log(`Preloaded thumb filename: ${t}`), this.loadedImages.includes(t) || this.loadedImages.push(t), i();
                                    };
                                }
                            }), a || i();
                        }
                    }, 300);
                })), e(this, "getHigherQuality", (e, t, i, s)=>{
                if (e < this.thumbnails.length - 1) {
                    let n = t.naturalHeight;
                    this.usingSprites && (n = i.h), n < this.thumbContainerHeight && setTimeout(()=>{
                        this.showingThumbFilename === s && (this.player.debug.log(`Showing higher quality thumb for: ${s}`), this.loadImage(e + 1));
                    }, 300);
                }
            }), e(this, "toggleThumbContainer", (e = !1, t = !1)=>{
                const i = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(i, e), !e && t && (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "toggleScrubbingContainer", (e = !1)=>{
                const t = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(t, e), e || (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "determineContainerAutoSizing", ()=>{
                (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
            }), e(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: e } = this.elements.thumb;
                if (this.sizeSpecifiedInCSS) {
                    if (e.clientHeight > 20 && e.clientWidth < 20) {
                        const t = Math.floor(e.clientHeight * this.thumbAspectRatio);
                        e.style.width = `${t}px`;
                    } else if (e.clientHeight < 20 && e.clientWidth > 20) {
                        const t = Math.floor(e.clientWidth / this.thumbAspectRatio);
                        e.style.height = `${t}px`;
                    }
                } else {
                    const t = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    e.style.height = `${this.thumbContainerHeight}px`, e.style.width = `${t}px`;
                }
                this.setThumbContainerPos();
            }), e(this, "setThumbContainerPos", ()=>{
                const e = this.player.elements.progress.getBoundingClientRect(), t = this.player.elements.container.getBoundingClientRect(), { container: i } = this.elements.thumb, s = t.left - e.left + 10, n = t.right - e.left - i.clientWidth - 10, a = this.mousePosX - e.left - i.clientWidth / 2, l = Ge(a, s, n);
                i.style.left = `${l}px`, i.style.setProperty("--preview-arrow-offset", a - l + "px");
            }), e(this, "setScrubbingContainerSize", ()=>{
                const { width: e, height: t } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${e}px`, this.elements.scrubbing.container.style.height = `${t}px`;
            }), e(this, "setImageSizeAndOffset", (e, t)=>{
                if (!this.usingSprites) return;
                const i = this.thumbContainerHeight / t.h;
                e.style.height = e.naturalHeight * i + "px", e.style.width = e.naturalWidth * i + "px", e.style.left = `-${t.x * i}px`, e.style.top = `-${t.y * i}px`;
            }), this.player = t, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = {
                thumb: {},
                scrubbing: {}
            }, this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes("w");
        }
        get thumbAspectRatio() {
            return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: e } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return e;
            }
            return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(e) {
            this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
        }
    }
    const it = {
        insertElements (e, t) {
            S.string(t) ? _(e, this.media, {
                src: t
            }) : S.array(t) && t.forEach((t)=>{
                _(e, this.media, t);
            });
        },
        change (e) {
            N(e, "sources.length") ? (de.cancelRequests.call(this), this.destroy.call(this, ()=>{
                this.options.quality = [], O(this.media), this.media = null, S.element(this.elements.container) && this.elements.container.removeAttribute("class");
                const { sources: t, type: i } = e, [{ provider: s = _e.html5, src: n }] = t, a = "html5" === s ? i : "div", l = "html5" === s ? {} : {
                    src: n
                };
                Object.assign(this, {
                    provider: s,
                    type: i,
                    supported: K.check(i, s, this.config.playsinline),
                    media: $(a, l)
                }), this.elements.container.appendChild(this.media), S.boolean(e.autoplay) && (this.config.autoplay = e.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), S.empty(e.poster) || (this.poster = e.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), Fe.addStyleHook.call(this), this.isHTML5 && it.insertElements.call(this, "source", t), this.config.title = e.title, Xe.setup.call(this), this.isHTML5 && Object.keys(e).includes("tracks") && it.insertElements.call(this, "track", e.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.isHTML5 && this.media.load(), S.empty(e.previewThumbnails) || (Object.assign(this.config.previewThumbnails, e.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))), this.fullscreen.update();
            }, !0)) : this.debug.warn("Invalid source format");
        }
    };
    class st {
        constructor(t, i){
            if (e(this, "play", ()=>S.function(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>ie(this.media.play())), this.media.play()) : null), e(this, "pause", ()=>this.playing && S.function(this.media.pause) ? this.media.pause() : null), e(this, "togglePlay", (e)=>(S.boolean(e) ? e : !this.playing) ? this.play() : this.pause()), e(this, "stop", ()=>{
                this.isHTML5 ? (this.pause(), this.restart()) : S.function(this.media.stop) && this.media.stop();
            }), e(this, "restart", ()=>{
                this.currentTime = 0;
            }), e(this, "rewind", (e)=>{
                this.currentTime -= S.number(e) ? e : this.config.seekTime;
            }), e(this, "forward", (e)=>{
                this.currentTime += S.number(e) ? e : this.config.seekTime;
            }), e(this, "increaseVolume", (e)=>{
                const t = this.media.muted ? 0 : this.volume;
                this.volume = t + (S.number(e) ? e : 0);
            }), e(this, "decreaseVolume", (e)=>{
                this.increaseVolume(-e);
            }), e(this, "airplay", ()=>{
                K.airplay && this.media.webkitShowPlaybackTargetPicker();
            }), e(this, "toggleControls", (e)=>{
                if (this.supported.ui && !this.isAudio) {
                    const t = F(this.elements.container, this.config.classNames.hideControls), i = void 0 === e ? void 0 : !e, s = R(this.elements.container, this.config.classNames.hideControls, i);
                    if (s && S.array(this.config.controls) && this.config.controls.includes("settings") && !S.empty(this.config.settings) && Pe.toggleMenu.call(this, !1), s !== t) {
                        const e = s ? "controlshidden" : "controlsshown";
                        Z.call(this, this.media, e);
                    }
                    return !s;
                }
                return !1;
            }), e(this, "on", (e, t)=>{
                X.call(this, this.elements.container, e, t);
            }), e(this, "once", (e, t)=>{
                G.call(this, this.elements.container, e, t);
            }), e(this, "off", (e, t)=>{
                J(this.elements.container, e, t);
            }), e(this, "destroy", (e, t = !1)=>{
                if (!this.ready) return;
                const i = ()=>{
                    document.body.style.overflow = "", this.embed = null, t ? (Object.keys(this.elements).length && (O(this.elements.buttons.play), O(this.elements.captions), O(this.elements.controls), O(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), S.function(e) && e()) : (ee.call(this), de.cancelRequests.call(this), q(this.elements.original, this.elements.container), Z.call(this, this.elements.original, "destroyed", !0), S.function(e) && e.call(this.elements.original), this.ready = !1, setTimeout(()=>{
                        this.elements = null, this.media = null;
                    }, 200));
                };
                this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (Fe.toggleNativeControls.call(this, !0), i()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && S.function(this.embed.destroy) && this.embed.destroy(), i()) : this.isVimeo && (null !== this.embed && this.embed.unload().then(i), setTimeout(i, 200));
            }), e(this, "supports", (e)=>K.mime.call(this, e)), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = K.touch, this.media = t, S.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || S.nodeList(this.media) || S.array(this.media)) && (this.media = this.media[0]), this.config = x({}, Le, st.defaults, i || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute("data-plyr-config"));
                } catch (e) {
                    return {};
                }
            })()), this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            }, this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap
            }, this.fullscreen = {
                active: !1
            }, this.options = {
                speed: [],
                quality: []
            }, this.debug = new De(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", K), S.nullOrUndefined(this.media) || !S.element(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
            if (this.media.plyr) return void this.debug.warn("Target already setup");
            if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
            if (!K.check().api) return void this.debug.error("Setup failed: no support");
            const s = this.media.cloneNode(!0);
            s.autoplay = !1, this.elements.original = s;
            const n = this.media.tagName.toLowerCase();
            let a = null, l = null;
            switch(n){
                case "div":
                    if (a = this.media.querySelector("iframe"), S.element(a)) {
                        if (l = Me(a.getAttribute("src")), this.provider = function(e) {
                            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? _e.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? _e.vimeo : null;
                        }(l.toString()), this.elements.container = this.media, this.media = a, this.elements.container.className = "", l.search.length) {
                            const e = [
                                "1",
                                "true"
                            ];
                            e.includes(l.searchParams.get("autoplay")) && (this.config.autoplay = !0), e.includes(l.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = e.includes(l.searchParams.get("playsinline")), this.config.youtube.hl = l.searchParams.get("hl")) : this.config.playsinline = !0;
                        }
                    } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
                    if (S.empty(this.provider) || !Object.values(_e).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                    this.type = je;
                    break;
                case "video":
                case "audio":
                    this.type = n, this.provider = _e.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                    break;
                default:
                    return void this.debug.error("Setup failed: unsupported type");
            }
            this.supported = K.check(this.type, this.provider), this.supported.api ? (this.eventListeners = [], this.listeners = new Ve(this), this.storage = new we(this), this.media.plyr = this, S.element(this.elements.container) || (this.elements.container = $("div"), L(this.media, this.elements.container)), Fe.migrateStyles.call(this), Fe.addStyleHook.call(this), Xe.setup.call(this), this.config.debug && X.call(this, this.elements.container, this.config.events.join(" "), (e)=>{
                this.debug.log(`event: ${e.type}`);
            }), this.fullscreen = new He(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new Je(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", ()=>ie(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))) : this.debug.error("Setup failed: no support");
        }
        get isHTML5() {
            return this.provider === _e.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === _e.youtube;
        }
        get isVimeo() {
            return this.provider === _e.vimeo;
        }
        get isVideo() {
            return this.type === je;
        }
        get isAudio() {
            return this.type === Oe;
        }
        get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        get paused() {
            return Boolean(this.media.paused);
        }
        get stopped() {
            return Boolean(this.paused && 0 === this.currentTime);
        }
        get ended() {
            return Boolean(this.media.ended);
        }
        set currentTime(e) {
            if (!this.duration) return;
            const t = S.number(e) && e > 0;
            this.media.currentTime = t ? Math.min(e, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        get currentTime() {
            return Number(this.media.currentTime);
        }
        get buffered() {
            const { buffered: e } = this.media;
            return S.number(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
        }
        get seeking() {
            return Boolean(this.media.seeking);
        }
        get duration() {
            const e = parseFloat(this.config.duration), t = (this.media || {}).duration, i = S.number(t) && t !== 1 / 0 ? t : 0;
            return e || i;
        }
        set volume(e) {
            let t = e;
            S.string(t) && (t = Number(t)), S.number(t) || (t = this.storage.get("volume")), S.number(t) || ({ volume: t } = this.config), t > 1 && (t = 1), t < 0 && (t = 0), this.config.volume = t, this.media.volume = t, !S.empty(e) && this.muted && t > 0 && (this.muted = !1);
        }
        get volume() {
            return Number(this.media.volume);
        }
        set muted(e) {
            let t = e;
            S.boolean(t) || (t = this.storage.get("muted")), S.boolean(t) || (t = this.config.muted), this.config.muted = t, this.media.muted = t;
        }
        get muted() {
            return Boolean(this.media.muted);
        }
        get hasAudio() {
            return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        set speed(e) {
            let t = null;
            S.number(e) && (t = e), S.number(t) || (t = this.storage.get("speed")), S.number(t) || (t = this.config.speed.selected);
            const { minimumSpeed: i, maximumSpeed: s } = this;
            t = Ge(t, i, s), this.config.speed.selected = t, setTimeout(()=>{
                this.media && (this.media.playbackRate = t);
            }, 0);
        }
        get speed() {
            return Number(this.media.playbackRate);
        }
        get minimumSpeed() {
            return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? .5 : .0625;
        }
        get maximumSpeed() {
            return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
        }
        set quality(e) {
            const t = this.config.quality, i = this.options.quality;
            if (!i.length) return;
            let s = [
                !S.empty(e) && Number(e),
                this.storage.get("quality"),
                t.selected,
                t.default
            ].find(S.number), n = !0;
            if (!i.includes(s)) {
                const e = ne(i, s);
                this.debug.warn(`Unsupported quality option: ${s}, using ${e} instead`), s = e, n = !1;
            }
            t.selected = s, this.media.quality = s, n && this.storage.set({
                quality: s
            });
        }
        get quality() {
            return this.media.quality;
        }
        set loop(e) {
            const t = S.boolean(e) ? e : this.config.loop.active;
            this.config.loop.active = t, this.media.loop = t;
        }
        get loop() {
            return Boolean(this.media.loop);
        }
        set source(e) {
            it.change.call(this, e);
        }
        get source() {
            return this.media.currentSrc;
        }
        get download() {
            const { download: e } = this.config.urls;
            return S.url(e) ? e : this.source;
        }
        set download(e) {
            S.url(e) && (this.config.urls.download = e, Pe.setDownloadUrl.call(this));
        }
        set poster(e) {
            this.isVideo ? Fe.setPoster.call(this, e, !1).catch(()=>{}) : this.debug.warn("Poster can only be set for video");
        }
        get poster() {
            return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
        }
        get ratio() {
            if (!this.isVideo) return null;
            const e = oe(ce.call(this));
            return S.array(e) ? e.join(":") : e;
        }
        set ratio(e) {
            this.isVideo ? S.string(e) && re(e) ? (this.config.ratio = oe(e), ue.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`) : this.debug.warn("Aspect ratio can only be set for video");
        }
        set autoplay(e) {
            this.config.autoplay = S.boolean(e) ? e : this.config.autoplay;
        }
        get autoplay() {
            return Boolean(this.config.autoplay);
        }
        toggleCaptions(e) {
            xe.toggle.call(this, e, !1);
        }
        set currentTrack(e) {
            xe.set.call(this, e, !1), xe.setup.call(this);
        }
        get currentTrack() {
            const { toggled: e, currentTrack: t } = this.captions;
            return e ? t : -1;
        }
        set language(e) {
            xe.setLanguage.call(this, e, !1);
        }
        get language() {
            return (xe.getCurrentTrack.call(this) || {}).language;
        }
        set pip(e) {
            if (!K.pip) return;
            const t = S.boolean(e) ? e : !this.pip;
            S.function(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? Ie : $e), S.function(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
        }
        get pip() {
            return K.pip ? S.empty(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Ie : null;
        }
        setPreviewThumbnails(e) {
            this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this));
        }
        static supported(e, t) {
            return K.check(e, t);
        }
        static loadSprite(e, t) {
            return ke(e, t);
        }
        static setup(e, t = {}) {
            let i = null;
            return S.string(e) ? i = Array.from(document.querySelectorAll(e)) : S.nodeList(e) ? i = Array.from(e) : S.array(e) && (i = e.filter(S.element)), S.empty(i) ? null : i.map((e)=>new st(e, t));
        }
    }
    var nt;
    return st.defaults = (nt = Le, JSON.parse(JSON.stringify(nt))), st;
});

});

parcelRequire.register("9lDzm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $6ce4c4e3ca2e49fe$var$_default = ()=>`
<div class="video__player-thumbnail"></div>
<div class="video-play-button" data-video-button-play="" data-plyr="play" aria-pressed="false" aria-label="Play, Макс Корж - Передел (Official audio)">
  <div class="video-play-button__info">
    <p class="text color-black text_default-500-bold ">Play video</p>
  </div>
</div>
<div class="plyr__controls">
    <button type="button" class="plyr__control" data-plyr="restart">
        <svg role="presentation"><use xlink:href="#plyr-restart"></use></svg>
        <span class="plyr__tooltip" role="tooltip">Restart</span>
    </button>
    <button type="button" class="plyr__control" data-plyr="rewind">
        <svg role="presentation"><use xlink:href="#plyr-rewind"></use></svg>
        <span class="plyr__tooltip" role="tooltip">Rewind {seektime} secs</span>
    </button>
    <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
    </button>
    <button type="button" class="plyr__control" data-plyr="fast-forward">
        <svg role="presentation"><use xlink:href="#plyr-fast-forward"></use></svg>
        <span class="plyr__tooltip" role="tooltip">Forward {seektime} secs</span>
    </button>
    <div class="plyr__progress" style="width: 100%; padding-right: 2rem">
        <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
        <span role="tooltip" class="plyr__tooltip">00:00</span>
    </div>
    <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
    <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
    <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
    </button>
    <div class="plyr__volume">
        <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
    </div>
    <button type="button" class="plyr__control" data-plyr="captions">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-captions-on"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-captions-off"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Disable captions</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Enable captions</span>
    </button>
    <button type="button" class="plyr__control" data-plyr="fullscreen">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span>
    </button>
</div>`;
module.exports.default = $6ce4c4e3ca2e49fe$var$_default;

});

parcelRequire.register("6IDQ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $4e45c17e9b7f7a3a$var$classes = {
    noScroll: "no-scroll"
};
const $4e45c17e9b7f7a3a$var$elements = {
    body: null
};
const $4e45c17e9b7f7a3a$var$scroll = ()=>{
    $4e45c17e9b7f7a3a$var$elements.body = document.body;
    return {
        enabledScroll: ()=>$4e45c17e9b7f7a3a$var$elements.body.classList.remove($4e45c17e9b7f7a3a$var$classes.noScroll),
        disabledScroll: ()=>$4e45c17e9b7f7a3a$var$elements.body.classList.add($4e45c17e9b7f7a3a$var$classes.noScroll)
    };
};
var $4e45c17e9b7f7a3a$var$_default = $4e45c17e9b7f7a3a$var$scroll;
module.exports.default = $4e45c17e9b7f7a3a$var$_default;

});

parcelRequire.register("be7LT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $82c707c4c2db11c7$var$selectors = {
    layout: "body"
};
const $82c707c4c2db11c7$var$classes = {
    overlay: "overlay"
};
const $82c707c4c2db11c7$var$elements = {
    layout: null
};
const $82c707c4c2db11c7$var$overlay = ()=>{
    $82c707c4c2db11c7$var$elements.layout = document.querySelector($82c707c4c2db11c7$var$selectors.layout);
    return {
        showOverlay: function() {
            let overlayInitiator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            window.overlayInitiator = overlayInitiator;
            $82c707c4c2db11c7$var$elements.layout?.classList.add($82c707c4c2db11c7$var$classes.overlay);
        },
        hideOverlay: ()=>{
            window.overlayInitiator = "";
            $82c707c4c2db11c7$var$elements.layout?.classList.remove($82c707c4c2db11c7$var$classes.overlay);
        }
    };
};
var $82c707c4c2db11c7$var$_default = $82c707c4c2db11c7$var$overlay;
module.exports.default = $82c707c4c2db11c7$var$_default;

});

parcelRequire.register("lXZdh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ffde975269d7596e$var$_blazy = $ffde975269d7596e$var$_interopRequireDefault((parcelRequire("8vmNV")));
function $ffde975269d7596e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ffde975269d7596e$var$lazyLoad = ()=>{
    new $ffde975269d7596e$var$_blazy.default({
        selector: ".lazy",
        successClass: "is-loaded",
        offset: 300,
        success: function(element) {
            element.parentElement?.classList.add("is-loaded");
        },
        error: function() {
            for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++)p[_key] = arguments[_key];
            console.log("error", p);
        }
    });
};
var $ffde975269d7596e$var$_default = $ffde975269d7596e$var$lazyLoad;
module.exports.default = $ffde975269d7596e$var$_default;

});
parcelRequire.register("8vmNV", function(module, exports) {
(function(root, blazy) {
    if (typeof define === "function" && define.amd) // AMD. Register bLazy as an anonymous module
    define(blazy);
    else // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = blazy();
})(module.exports, function() {
    "use strict";
    //private vars
    var _source, _viewport, _isRetina, _supportClosest, _attrSrc = "src", _attrSrcset = "srcset";
    // constructor
    return function Blazy(options) {
        //IE7- fallback for missing querySelectorAll support
        if (!document.querySelectorAll) {
            var s = document.createStyleSheet();
            document.querySelectorAll = function(r, c, i, j, a) {
                a = document.all, c = [], r = r.replace(/\[for\b/gi, "[htmlFor").split(",");
                for(i = r.length; i--;){
                    s.addRule(r[i], "k:v");
                    for(j = a.length; j--;)a[j].currentStyle.k && c.push(a[j]);
                    s.removeRule(0);
                }
                return c;
            };
        }
        //options and helper vars
        var scope = this;
        var util = scope._util = {};
        util.elements = [];
        util.destroyed = true;
        scope.options = options || {};
        scope.options.error = scope.options.error || false;
        scope.options.offset = scope.options.offset || 100;
        scope.options.root = scope.options.root || document;
        scope.options.success = scope.options.success || false;
        scope.options.selector = scope.options.selector || ".b-lazy";
        scope.options.separator = scope.options.separator || "|";
        scope.options.containerClass = scope.options.container;
        scope.options.container = scope.options.containerClass ? document.querySelectorAll(scope.options.containerClass) : false;
        scope.options.errorClass = scope.options.errorClass || "b-error";
        scope.options.breakpoints = scope.options.breakpoints || false;
        scope.options.loadInvisible = scope.options.loadInvisible || false;
        scope.options.successClass = scope.options.successClass || "b-loaded";
        scope.options.validateDelay = scope.options.validateDelay || 25;
        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
        scope.options.srcset = scope.options.srcset || "data-srcset";
        scope.options.src = _source = scope.options.src || "data-src";
        _supportClosest = Element.prototype.closest;
        _isRetina = window.devicePixelRatio > 1;
        _viewport = {};
        _viewport.top = 0 - scope.options.offset;
        _viewport.left = 0 - scope.options.offset;
        /* public functions
         ************************************/ scope.revalidate = function() {
            initialize(scope);
        };
        scope.load = function(elements, force) {
            var opt = this.options;
            if (elements && elements.length === undefined) loadElement(elements, force, opt);
            else each(elements, function(element) {
                loadElement(element, force, opt);
            });
        };
        scope.destroy = function() {
            var util = scope._util;
            if (scope.options.container) each(scope.options.container, function(object) {
                unbindEvent(object, "scroll", util.validateT);
            });
            unbindEvent(window, "scroll", util.validateT);
            unbindEvent(window, "resize", util.validateT);
            unbindEvent(window, "resize", util.saveViewportOffsetT);
            util.count = 0;
            util.elements.length = 0;
            util.destroyed = true;
        };
        //throttle, ensures that we don't call the functions too often
        util.validateT = throttle(function() {
            validate(scope);
        }, scope.options.validateDelay, scope);
        util.saveViewportOffsetT = throttle(function() {
            saveViewportOffset(scope.options.offset);
        }, scope.options.saveViewportOffsetDelay, scope);
        saveViewportOffset(scope.options.offset);
        //handle multi-served image src (obsolete)
        each(scope.options.breakpoints, function(object) {
            if (object.width >= window.screen.width) {
                _source = object.src;
                return false;
            }
        });
        // start lazy load
        setTimeout(function() {
            initialize(scope);
        }); // "dom ready" fix
    };
    /* Private helper functions
     ************************************/ function initialize(self) {
        var util = self._util;
        // First we create an array of elements to lazy load
        util.elements = toArray(self.options);
        util.count = util.elements.length;
        // Then we bind resize and scroll events if not already binded
        if (util.destroyed) {
            util.destroyed = false;
            if (self.options.container) each(self.options.container, function(object) {
                bindEvent(object, "scroll", util.validateT);
            });
            bindEvent(window, "resize", util.saveViewportOffsetT);
            bindEvent(window, "resize", util.validateT);
            bindEvent(window, "scroll", util.validateT);
        }
        // And finally, we start to lazy load.
        validate(self);
    }
    function validate(self) {
        var util = self._util;
        for(var i = 0; i < util.count; i++){
            var element = util.elements[i];
            if (elementInView(element, self.options) || hasClass(element, self.options.successClass)) {
                self.load(element);
                util.elements.splice(i, 1);
                util.count--;
                i--;
            }
        }
        if (util.count === 0) self.destroy();
    }
    function elementInView(ele, options) {
        var rect = ele.getBoundingClientRect();
        if (options.container && _supportClosest) {
            // Is element inside a container?
            var elementContainer = ele.closest(options.containerClass);
            if (elementContainer) {
                var containerRect = elementContainer.getBoundingClientRect();
                // Is container in view?
                if (inView(containerRect, _viewport)) {
                    var top = containerRect.top - options.offset;
                    var right = containerRect.right + options.offset;
                    var bottom = containerRect.bottom + options.offset;
                    var left = containerRect.left - options.offset;
                    var containerRectWithOffset = {
                        top: top > _viewport.top ? top : _viewport.top,
                        right: right < _viewport.right ? right : _viewport.right,
                        bottom: bottom < _viewport.bottom ? bottom : _viewport.bottom,
                        left: left > _viewport.left ? left : _viewport.left
                    };
                    // Is element in view of container?
                    return inView(rect, containerRectWithOffset);
                } else return false;
            }
        }
        return inView(rect, _viewport);
    }
    function inView(rect, viewport) {
        // Intersection
        return rect.right >= viewport.left && rect.bottom >= viewport.top && rect.left <= viewport.right && rect.top <= viewport.bottom;
    }
    function loadElement(ele, force, options) {
        // if element is visible, not loaded or forced
        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || ele.offsetWidth > 0 && ele.offsetHeight > 0)) {
            var dataSrc = getAttr(ele, _source) || getAttr(ele, options.src); // fallback to default 'data-src'
            if (dataSrc) {
                var dataSrcSplitted = dataSrc.split(options.separator);
                var src = dataSrcSplitted[_isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
                var srcset = getAttr(ele, options.srcset);
                var isImage = equal(ele, "img");
                var parent = ele.parentNode;
                var isPicture = parent && equal(parent, "picture");
                // Image or background image
                if (isImage || ele.src === undefined) {
                    var img = new Image();
                    // using EventListener instead of onerror and onload
                    // due to bug introduced in chrome v50 
                    // (https://productforums.google.com/forum/#!topic/chrome/p51Lk7vnP2o)
                    var onErrorHandler = function() {
                        if (options.error) options.error(ele, "invalid");
                        addClass(ele, options.errorClass);
                        unbindEvent(img, "error", onErrorHandler);
                        unbindEvent(img, "load", onLoadHandler);
                    };
                    var onLoadHandler = function() {
                        // Is element an image
                        if (isImage) {
                            if (!isPicture) handleSources(ele, src, srcset);
                        } else ele.style.backgroundImage = 'url("' + src + '")';
                        itemLoaded(ele, options);
                        unbindEvent(img, "load", onLoadHandler);
                        unbindEvent(img, "error", onErrorHandler);
                    };
                    // Picture element
                    if (isPicture) {
                        img = ele; // Image tag inside picture element wont get preloaded
                        each(parent.getElementsByTagName("source"), function(source) {
                            handleSource(source, _attrSrcset, options.srcset);
                        });
                    }
                    bindEvent(img, "error", onErrorHandler);
                    bindEvent(img, "load", onLoadHandler);
                    handleSources(img, src, srcset); // Preload
                } else {
                    ele.src = src;
                    itemLoaded(ele, options);
                }
            } else // video with child source
            if (equal(ele, "video")) {
                each(ele.getElementsByTagName("source"), function(source) {
                    handleSource(source, _attrSrc, options.src);
                });
                ele.load();
                itemLoaded(ele, options);
            } else {
                if (options.error) options.error(ele, "missing");
                addClass(ele, options.errorClass);
            }
        }
    }
    function itemLoaded(ele, options) {
        addClass(ele, options.successClass);
        if (options.success) options.success(ele);
        // cleanup markup, remove data source attributes
        removeAttr(ele, options.src);
        removeAttr(ele, options.srcset);
        each(options.breakpoints, function(object) {
            removeAttr(ele, object.src);
        });
    }
    function handleSource(ele, attr, dataAttr) {
        var dataSrc = getAttr(ele, dataAttr);
        if (dataSrc) {
            setAttr(ele, attr, dataSrc);
            removeAttr(ele, dataAttr);
        }
    }
    function handleSources(ele, src, srcset) {
        if (srcset) setAttr(ele, _attrSrcset, srcset); //srcset
        ele.src = src; //src 
    }
    function setAttr(ele, attr, value) {
        ele.setAttribute(attr, value);
    }
    function getAttr(ele, attr) {
        return ele.getAttribute(attr);
    }
    function removeAttr(ele, attr) {
        ele.removeAttribute(attr);
    }
    function equal(ele, str) {
        return ele.nodeName.toLowerCase() === str;
    }
    function hasClass(ele, className) {
        return (" " + ele.className + " ").indexOf(" " + className + " ") !== -1;
    }
    function addClass(ele, className) {
        if (!hasClass(ele, className)) ele.className += " " + className;
    }
    function toArray(options) {
        var array = [];
        var nodelist = options.root.querySelectorAll(options.selector);
        for(var i = nodelist.length; i--; array.unshift(nodelist[i]));
        return array;
    }
    function saveViewportOffset(offset) {
        _viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
        _viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
    }
    function bindEvent(ele, type, fn) {
        if (ele.attachEvent) ele.attachEvent && ele.attachEvent("on" + type, fn);
        else ele.addEventListener(type, fn, {
            capture: false,
            passive: true
        });
    }
    function unbindEvent(ele, type, fn) {
        if (ele.detachEvent) ele.detachEvent && ele.detachEvent("on" + type, fn);
        else ele.removeEventListener(type, fn, {
            capture: false,
            passive: true
        });
    }
    function each(object, fn) {
        if (object && fn) {
            var l = object.length;
            for(var i = 0; i < l && fn(object[i], i) !== false; i++);
        }
    }
    function throttle(fn, minDelay, scope) {
        var lastCall = 0;
        return function() {
            var now = +new Date();
            if (now - lastCall < minDelay) return;
            lastCall = now;
            fn.apply(scope, arguments);
        };
    }
});

});


"use strict";

"use strict";
"use strict";
"use strict";



"use strict";



"use strict";



"use strict";



"use strict";



"use strict";



"use strict";
"use strict";





"use strict";



"use strict";





"use strict";
"use strict";



"use strict";

var $8b7f4f349a2e83d2$var$_swiper = $8b7f4f349a2e83d2$var$_interopRequireWildcard((parcelRequire("e1ad9")));

function $8b7f4f349a2e83d2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8b7f4f349a2e83d2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8b7f4f349a2e83d2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8b7f4f349a2e83d2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $8b7f4f349a2e83d2$var$selectors = {
    header: "[data-header]",
    menuTrigger: "[data-header-trigger]",
    accordion: "[data-header-accordion]",
    accordionHeader: "[data-header-accordion-header]",
    tab: "[data-header-tab]",
    tabHeader: "[data-header-tab-header]",
    tabPane: "[data-header-tab-pane]",
    active: "active",
    fixed: "fixed"
};
const $8b7f4f349a2e83d2$var$setActiveTab = (tab, activeIndex, tabs, panes)=>{
    const isActive = tab.classList.contains($8b7f4f349a2e83d2$var$selectors.active);
    tabs.forEach((tab)=>tab.classList.remove($8b7f4f349a2e83d2$var$selectors.active));
    panes.forEach((pane, index)=>pane.classList[index === activeIndex ? "add" : "remove"]($8b7f4f349a2e83d2$var$selectors.active));
    panes[0].querySelector(".swiper").swiper.update();
    !isActive && tab.classList.toggle($8b7f4f349a2e83d2$var$selectors.active);
};
const $8b7f4f349a2e83d2$var$initHeader = (header)=>{
    const triggers = header.querySelectorAll($8b7f4f349a2e83d2$var$selectors.menuTrigger);
    const accordions = header.querySelectorAll($8b7f4f349a2e83d2$var$selectors.accordion);
    accordions?.forEach((accordion)=>{
        const header = accordion.querySelector($8b7f4f349a2e83d2$var$selectors.accordionHeader);
        const sliders = accordion.querySelectorAll(".swiper");
        const tabs = accordion.querySelectorAll($8b7f4f349a2e83d2$var$selectors.tab);
        const panes = accordion.querySelectorAll($8b7f4f349a2e83d2$var$selectors.tabPane);
        header?.addEventListener("click", ()=>{
            const isActive = accordion.classList.contains($8b7f4f349a2e83d2$var$selectors.active);
            accordions.forEach((accordion)=>accordion.classList.remove($8b7f4f349a2e83d2$var$selectors.active));
            !isActive && accordion.classList.toggle($8b7f4f349a2e83d2$var$selectors.active);
        });
        tabs?.forEach((tab, activeIndex)=>{
            const header = tab.querySelector($8b7f4f349a2e83d2$var$selectors.tabHeader);
            header.addEventListener("click", ()=>$8b7f4f349a2e83d2$var$setActiveTab(tab, activeIndex, tabs, panes));
        });
        sliders?.forEach((slider)=>{
            new $8b7f4f349a2e83d2$var$_swiper.default(slider, {
                modules: [
                    $8b7f4f349a2e83d2$var$_swiper.Scrollbar,
                    $8b7f4f349a2e83d2$var$_swiper.Navigation
                ],
                slidesPerView: 3,
                spaceBetween: 8,
                scrollbar: {
                    el: slider.parentElement.querySelector(".swiper-scrollbar"),
                    draggable: true
                },
                navigation: {
                    prevEl: slider.parentElement.querySelector(".prev"),
                    nextEl: slider.parentElement.querySelector(".next")
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 7
                    }
                }
            });
        });
        if (tabs.length && window.matchMedia("(min-width: 1024px)").matches) $8b7f4f349a2e83d2$var$setActiveTab(tabs[0], 0, tabs, panes);
    });
    triggers?.forEach((trigger)=>trigger.addEventListener("click", ()=>{
            header.classList.toggle($8b7f4f349a2e83d2$var$selectors.active);
            document.body.classList.toggle($8b7f4f349a2e83d2$var$selectors.fixed);
        }));
};
document.addEventListener("DOMContentLoaded", async function() {
    const header = document.querySelector($8b7f4f349a2e83d2$var$selectors.header);
    if (!header) return;
    $8b7f4f349a2e83d2$var$initHeader(header);
}, {
    once: true
});


"use strict";

const $0d1e26c14e57e167$var$selectors = {
    footer: "[data-footer]",
    accordion: "[data-footer-accordion]",
    accordionHeader: "[data-footer-accordion-header]",
    active: "active"
};
const $0d1e26c14e57e167$var$initFooter = (footer)=>{
    const accordions = footer.querySelectorAll($0d1e26c14e57e167$var$selectors.accordion);
    accordions?.forEach((accordion, activeIndex)=>{
        const header = accordion.querySelector($0d1e26c14e57e167$var$selectors.accordionHeader);
        header.addEventListener("click", ()=>{
            const isActive = accordion.classList.contains($0d1e26c14e57e167$var$selectors.active);
            accordions.forEach((accordion, index)=>accordion.classList[isActive ? "remove" : activeIndex === index ? "add" : "remove"]($0d1e26c14e57e167$var$selectors.active));
        });
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const footer = document.querySelector($0d1e26c14e57e167$var$selectors.footer);
    if (!footer) return;
    $0d1e26c14e57e167$var$initFooter(footer);
}, {
    once: true
});




"use strict";
"use strict";



"use strict";


const $d6d4dce834d3e2f9$var$selectors = {
    researchModule: "[data-hrm]",
    researchModuleTrigger: "[data-hrm-trigger]",
    researchModuleValues: "[data-hrm-values]",
    researchModuleValuesParameter: "[data-hrm-values-parameter]",
    researchModuleValuesContainer: "[data-hrm-values-container]",
    researchModuleAccordion: "[data-hrm-accordion]",
    researchModuleTabs: "[data-hrm-tabs]",
    researchModuleTabsHeader: "data-hrm-tabs-header",
    researchModuleTabsPane: "data-hrm-tabs-pane",
    input: "input",
    active: "active",
    itemSelected: "item-selected",
    loading: "loading"
};
const $d6d4dce834d3e2f9$var$checkAvailableFilters = function(panes) {
    let activeIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    const form = document.querySelector("[data-hrm] form");
    const formValues = new FormData(form);
    const params = [
        ...formValues.entries()
    ].reduce((res, _ref)=>{
        let [name, value] = _ref;
        return [
            ...res,
            `${name}=${value}`
        ];
    }, []).join("&");
    formValues.append("params", params);
    formValues.append("action", "home_filter");
    formValues.append("nonce", window["ajax_settings"].nonce);
    //if (!params) return
    panes[activeIndex].classList.add($d6d4dce834d3e2f9$var$selectors.loading);
    const url = window["ajax_settings"].url;
    fetch(url, {
        method: "POST",
        credentials: "same-origin",
        body: formValues
    }).then((res)=>{
        return res.json();
    }).then((res)=>{
        //console.log('res', res)
        const inputs = document.querySelectorAll('input[type="checkbox"]');
        inputs.forEach((input)=>{
            const isAvailable = res[input.name].includes(input.value);
            if (isAvailable) input.removeAttribute("disabled");
            else input.setAttribute("disabled", "");
        });
    }).finally(()=>{
        panes[activeIndex].classList.remove($d6d4dce834d3e2f9$var$selectors.loading);
    });
};
const $d6d4dce834d3e2f9$var$checkSelectedValues = (item)=>{
    const values = item.querySelector($d6d4dce834d3e2f9$var$selectors.researchModuleValuesContainer)?.dataset.hrmValuesContainer;
    item.classList[!!values ? "add" : "remove"]($d6d4dce834d3e2f9$var$selectors.itemSelected);
};
const $d6d4dce834d3e2f9$var$handleAccordionClick = (accordions, activeIndex)=>{
    accordions.forEach((accordion, index)=>{
        const isActive = accordion.getAttribute("data-hrm-accordion");
        accordion.setAttribute("data-hrm-accordion", activeIndex === index ? !isActive ? $d6d4dce834d3e2f9$var$selectors.active : "" : "");
        $d6d4dce834d3e2f9$var$checkSelectedValues(accordion);
    });
    $d6d4dce834d3e2f9$var$checkAvailableFilters(accordions, activeIndex);
};
const $d6d4dce834d3e2f9$var$initAccordions = (accordions)=>{
    accordions?.forEach((accordion, activeIndex)=>{
        const accordionHeader = accordion.firstElementChild;
        accordionHeader.addEventListener("click", ()=>$d6d4dce834d3e2f9$var$handleAccordionClick(accordions, activeIndex));
    });
};
const $d6d4dce834d3e2f9$var$initCheckboxes = (checkboxes)=>{
    let checkboxesChecked = [];
    checkboxes.forEach((input)=>{
        input.addEventListener("change", (e)=>{
            const value = e.target.dataset.label;
            const valueContainers = document.querySelectorAll(`[data-hrm-values="${e.target.dataset.parameter}"] ${$d6d4dce834d3e2f9$var$selectors.researchModuleValuesContainer}`);
            valueContainers.forEach((container)=>{
                const selectedValues = container.dataset.hrmValuesContainer.split(", ");
                if (e.target.checked) {
                    container.setAttribute("data-hrm-values-container", [
                        ...selectedValues,
                        value
                    ].filter((i)=>!!i).join(", "));
                    container.innerText = [
                        ...selectedValues,
                        value
                    ].filter((i)=>!!i).join(", ");
                } else {
                    container.setAttribute("data-hrm-values-container", selectedValues.filter((i)=>!!i && i !== value).join(", "));
                    container.innerText = selectedValues.filter((i)=>!!i && i !== value).join(", ");
                }
            });
            // check selected checkboxes
            if (e.target.checked) checkboxesChecked.push(e.target);
            else checkboxesChecked = checkboxesChecked.filter((el)=>el !== e.target);
            if (!checkboxesChecked.length) {
                const panes = document.querySelectorAll(`.hrm__form-panes > [${$d6d4dce834d3e2f9$var$selectors.researchModuleTabsPane}]`);
                let activeIndex = 0;
                panes.forEach((pane, index)=>{
                    if (pane.classList.contains($d6d4dce834d3e2f9$var$selectors.active)) activeIndex = index;
                });
                $d6d4dce834d3e2f9$var$checkAvailableFilters(panes, activeIndex);
            }
        });
    });
};
const $d6d4dce834d3e2f9$var$handleTabClick = (headers, panes, activeIndex)=>{
    headers.forEach((header, index)=>{
        header.classList[index === activeIndex ? "add" : "remove"]($d6d4dce834d3e2f9$var$selectors.active);
        $d6d4dce834d3e2f9$var$checkSelectedValues(header);
    });
    panes.forEach((pane, index)=>pane.classList[index === activeIndex ? "add" : "remove"]($d6d4dce834d3e2f9$var$selectors.active));
    let parentActiveIndex = 0;
    const parentPanes = document.querySelectorAll(`.hrm__form-panes > [${$d6d4dce834d3e2f9$var$selectors.researchModuleTabsPane}]`);
    parentPanes.forEach((pane, index)=>{
        if (pane.classList.contains($d6d4dce834d3e2f9$var$selectors.active)) parentActiveIndex = index;
    });
    $d6d4dce834d3e2f9$var$checkAvailableFilters(parentPanes, parentActiveIndex);
};
const $d6d4dce834d3e2f9$var$initTabs = (tabs)=>{
    const headers = tabs.querySelectorAll(`[${$d6d4dce834d3e2f9$var$selectors.researchModuleTabsHeader}="${tabs.dataset.hrmTabs}"]`);
    const panes = tabs.querySelectorAll(`[${$d6d4dce834d3e2f9$var$selectors.researchModuleTabsPane}="${tabs.dataset.hrmTabs}"]`);
    headers.forEach((header, activeIndex)=>{
        header.addEventListener("click", ()=>$d6d4dce834d3e2f9$var$handleTabClick(headers, panes, activeIndex));
    });
    $d6d4dce834d3e2f9$var$handleTabClick(headers, panes, 0);
};
const $d6d4dce834d3e2f9$var$initResearchModule = (researchModule)=>{
    const accordions = researchModule.querySelectorAll($d6d4dce834d3e2f9$var$selectors.researchModuleAccordion);
    const tabs = researchModule.querySelectorAll($d6d4dce834d3e2f9$var$selectors.researchModuleTabs);
    const checkboxes = researchModule.querySelectorAll($d6d4dce834d3e2f9$var$selectors.input);
    tabs.forEach($d6d4dce834d3e2f9$var$initTabs);
    $d6d4dce834d3e2f9$var$initAccordions(accordions);
    $d6d4dce834d3e2f9$var$initCheckboxes(checkboxes);
};
const $d6d4dce834d3e2f9$var$initResearchModuleTriggers = (researchModule, triggers)=>{
    triggers.forEach((trigger)=>trigger.addEventListener("click", ()=>{
            researchModule.classList.toggle($d6d4dce834d3e2f9$var$selectors.active);
            document.body.classList.toggle("no-scroll");
        }));
};
document.addEventListener("DOMContentLoaded", async function() {
    const researchModule = document.querySelector($d6d4dce834d3e2f9$var$selectors.researchModule);
    const triggers = document.querySelectorAll($d6d4dce834d3e2f9$var$selectors.researchModuleTrigger);
    if (!researchModule || !triggers) return;
    $d6d4dce834d3e2f9$var$initResearchModule(researchModule);
    $d6d4dce834d3e2f9$var$initResearchModuleTriggers(researchModule, triggers);
}, {
    once: true
});


"use strict";



"use strict";



"use strict";

var $f9731a07c70c2eb1$var$_swiper = $f9731a07c70c2eb1$var$_interopRequireWildcard((parcelRequire("e1ad9")));

function $f9731a07c70c2eb1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f9731a07c70c2eb1$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f9731a07c70c2eb1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f9731a07c70c2eb1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $f9731a07c70c2eb1$var$selectors = {
    container: "[data-infs]"
};
const $f9731a07c70c2eb1$var$initInfosessionsSlider = (container)=>{
    new $f9731a07c70c2eb1$var$_swiper.default(container.querySelector(".swiper"), {
        modules: [
            $f9731a07c70c2eb1$var$_swiper.Navigation,
            $f9731a07c70c2eb1$var$_swiper.Scrollbar,
            $f9731a07c70c2eb1$var$_swiper.Pagination
        ],
        slidesPerView: "auto",
        spaceBetween: 16,
        scrollbar: {
            el: container.querySelector(".swiper-scrollbar"),
            draggable: true
        },
        navigation: {
            prevEl: container.querySelector(".prev"),
            nextEl: container.querySelector(".next")
        },
        pagination: {
            el: container.querySelector(".swiper-pagination")
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 8
            }
        }
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll($f9731a07c70c2eb1$var$selectors.container);
    containers?.forEach($f9731a07c70c2eb1$var$initInfosessionsSlider);
}, {
    once: true
});


"use strict";

const $027e691579cc8976$var$selectors = {
    researchModule: "[data-fyt]",
    researchModuleTrigger: "[data-fyt-trigger]",
    clearButton: "[data-fyt-clear]",
    submitButton: ".fyt__form-submit",
    researchModuleValues: "[data-fyt-values]",
    researchModuleValuesParameter: "[data-fyt-values-parameter]",
    researchModuleValuesContainer: "[data-fyt-values-container]",
    researchModuleAccordion: "[data-fyt-accordion]",
    researchModuleTabs: "[data-fyt-tabs]",
    researchModuleTabsHeader: "data-fyt-tabs-header",
    researchModuleTabsPane: "data-fyt-tabs-pane",
    researchModuleResult: ".fyt__result",
    input: "input",
    active: "active",
    itemSelected: "item-selected",
    loading: "loading",
    pagination: ".pagination"
};
let $027e691579cc8976$var$checkboxesSnapshot = null;
let $027e691579cc8976$var$prevResultWasPagination = false;
const $027e691579cc8976$var$form = document.querySelector($027e691579cc8976$var$selectors.researchModule);
const $027e691579cc8976$var$sendRequest = (panes, activeIndex, paged, isPaginationRequest)=>{
    const formValues = new FormData($027e691579cc8976$var$form);
    let params = null;
    if (isPaginationRequest && $027e691579cc8976$var$checkboxesSnapshot) {
        if ($027e691579cc8976$var$checkboxesSnapshot) params = $027e691579cc8976$var$checkboxesSnapshot;
        else {
            params = [
                ...formValues.entries()
            ].reduce((res, _ref)=>{
                let [name, value] = _ref;
                return [
                    ...res,
                    `${name}=${value}`
                ];
            }, []).join("&");
            $027e691579cc8976$var$checkboxesSnapshot = params;
        }
        $027e691579cc8976$var$prevResultWasPagination = true;
        window.scrollTo(0, 0);
    } else if ($027e691579cc8976$var$prevResultWasPagination) {
        params = $027e691579cc8976$var$checkboxesSnapshot;
        $027e691579cc8976$var$prevResultWasPagination = false;
    } else {
        params = [
            ...formValues.entries()
        ].reduce((res, _ref2)=>{
            let [name, value] = _ref2;
            return [
                ...res,
                `${name}=${value}`
            ];
        }, []).join("&");
        $027e691579cc8976$var$checkboxesSnapshot = params;
    }
    const resultContainer = document.querySelector($027e691579cc8976$var$selectors.researchModuleResult);
    formValues.append("params", params);
    formValues.append("action", "home_filter");
    formValues.append("nonce", window["ajax_settings"].nonce);
    paged && formValues.append("paged", paged);
    //if (!params) return
    if (panes && activeIndex) panes[activeIndex].classList.add($027e691579cc8976$var$selectors.loading);
    $027e691579cc8976$var$form.classList.add("loading");
    resultContainer.classList.add("loading");
    const url = window["ajax_settings"].url;
    fetch(url, {
        method: "POST",
        credentials: "same-origin",
        body: formValues
    }).then((res)=>{
        return res.json();
    }).then((res)=>{
        if (!res["is_filter_query"]) {
            const inputs = document.querySelectorAll('input[type="checkbox"]');
            inputs.forEach((input)=>{
                let isAvailable = null;
                if (input.name === "bike") isAvailable = res[input.name]?.includes(!!input.value);
                else isAvailable = res[input.name]?.includes(input.value);
                if (isAvailable) input.removeAttribute("disabled");
                else input.setAttribute("disabled", "");
            });
        } else {
            const inputs = document.querySelectorAll('input[type="checkbox"]');
            inputs.forEach((input)=>{
                input.removeAttribute("disabled");
            });
        }
        resultContainer.innerHTML = res["grid_markup"] + res["pagination_markup"];
    }).finally(()=>{
        if (panes && activeIndex) panes[activeIndex].classList.remove($027e691579cc8976$var$selectors.loading);
        $027e691579cc8976$var$form.classList.remove("loading");
        resultContainer.classList.remove("loading");
    });
};
const $027e691579cc8976$var$handleAccordionClick = (accordions, activeIndex)=>{
    accordions.forEach((accordion, index)=>{
        const isActive = accordion.getAttribute("data-fyt-accordion");
        accordion.setAttribute("data-fyt-accordion", activeIndex === index ? !isActive ? $027e691579cc8976$var$selectors.active : "" : "");
    });
    $027e691579cc8976$var$sendRequest(accordions, activeIndex);
};
const $027e691579cc8976$var$initAccordions = (accordions)=>{
    accordions?.forEach((accordion, activeIndex)=>{
        const accordionHeader = accordion.firstElementChild;
        accordionHeader.addEventListener("click", ()=>$027e691579cc8976$var$handleAccordionClick(accordions, activeIndex));
    });
};
const $027e691579cc8976$var$initCheckboxes = (checkboxes)=>checkboxes.forEach((input)=>{
        input.addEventListener("change", (e)=>{
            const value = e.target.dataset.label;
            const valueContainers = document.querySelectorAll(`[data-fyt-values="${e.target.dataset.parameter}"] ${$027e691579cc8976$var$selectors.researchModuleValuesContainer}`);
            valueContainers.forEach((container)=>{
                const selectedValues = container.dataset.fytValuesContainer.split(", ");
                if (e.target.checked) {
                    container.setAttribute("data-fyt-values-container", [
                        ...selectedValues,
                        value
                    ].filter((i)=>!!i).join(", "));
                    container.innerText = [
                        ...selectedValues,
                        value
                    ].filter((i)=>!!i).join(", ");
                } else {
                    container.setAttribute("data-fyt-values-container", selectedValues.filter((i)=>!!i && i !== value).join(", "));
                    container.innerText = selectedValues.filter((i)=>!!i && i !== value).join(", ");
                }
            });
        });
    });
const $027e691579cc8976$var$handleTabClick = (headers, panes, activeIndex)=>{
    const isActive = headers[activeIndex].classList.contains($027e691579cc8976$var$selectors.active);
    headers.forEach((header, index)=>{
        header.classList[index === activeIndex && !isActive ? "add" : "remove"]($027e691579cc8976$var$selectors.active);
    });
    panes.forEach((pane, index)=>pane.classList[index === activeIndex && !isActive ? "add" : "remove"]($027e691579cc8976$var$selectors.active));
//sendRequest(panes, activeIndex)
};
const $027e691579cc8976$var$initTabs = (tabs)=>{
    const headers = tabs.querySelectorAll(`[${$027e691579cc8976$var$selectors.researchModuleTabsHeader}="${tabs.dataset.fytTabs}"]`);
    const panes = tabs.querySelectorAll(`[${$027e691579cc8976$var$selectors.researchModuleTabsPane}="${tabs.dataset.fytTabs}"]`);
    headers.forEach((header, activeIndex)=>{
        header.addEventListener("click", ()=>$027e691579cc8976$var$handleTabClick(headers, panes, activeIndex));
    });
// handleTabClick(headers, panes, 0)
};
const $027e691579cc8976$var$closeActiveItems = ()=>{
    const researchModule = document.querySelector($027e691579cc8976$var$selectors.researchModule);
    researchModule?.classList.remove("active");
    researchModule?.querySelectorAll(".active").forEach(function(element) {
        element.classList.remove("active");
    });
};
const $027e691579cc8976$var$checkURLParams = ()=>{
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    for (let [key, value] of params.entries()){
        const checkbox = document.querySelector(`input[type="checkbox"][name="${key}"][value="${value}"]`);
        if (checkbox) checkbox.checked = true;
    }
};
const $027e691579cc8976$var$clearURLParams = ()=>{
    const url = new URL(window.location.href);
    url.search = "";
    window.history.replaceState({}, "", url.toString());
};
const $027e691579cc8976$var$clearCheckboxesSnapshot = ()=>{
    $027e691579cc8976$var$checkboxesSnapshot = null;
};
const $027e691579cc8976$var$initClearButtons = (clearButtons, checkboxes)=>{
    clearButtons?.forEach((button)=>button.addEventListener("click", ()=>{
            const valuesContainers = document.querySelectorAll($027e691579cc8976$var$selectors.researchModuleValuesContainer);
            if ($027e691579cc8976$var$form.hasAttribute("data-search-country")) {
                const value = $027e691579cc8976$var$form.getAttribute("data-search-country");
                checkboxes.forEach((checkbox)=>{
                    if (checkbox.value === value) checkbox.checked = true;
                    else checkbox.checked = false;
                });
            } else checkboxes.forEach((checkbox)=>checkbox.checked = false);
            valuesContainers.forEach((container)=>container.setAttribute("data-fyt-values-container", ""));
            $027e691579cc8976$var$clearURLParams();
            $027e691579cc8976$var$clearCheckboxesSnapshot();
            $027e691579cc8976$var$closeActiveItems();
            $027e691579cc8976$var$sendRequest(null, null, 1);
        }));
};
const $027e691579cc8976$var$initSubmitButtons = (submitButtons)=>{
    submitButtons?.forEach((button)=>button.addEventListener("click", (e)=>{
            e.preventDefault();
            $027e691579cc8976$var$closeActiveItems();
            document.body.classList.remove("no-scroll");
            $027e691579cc8976$var$sendRequest();
        }));
};
const $027e691579cc8976$var$initPagination = ()=>{
    const resultContainer = document.querySelector($027e691579cc8976$var$selectors.researchModuleResult);
    resultContainer?.addEventListener("click", function(e) {
        //e.preventDefault();
        let paged = null;
        const link = e.target.closest(".pagination a");
        if (link) {
            e.preventDefault();
            paged = link.dataset.paged;
            const isPaginationRequest = true;
            $027e691579cc8976$var$sendRequest(null, null, paged, isPaginationRequest);
        }
    });
};
const $027e691579cc8976$var$checkIsCountrySearch = ()=>{
    if ($027e691579cc8976$var$form.hasAttribute("data-search-country")) {
        const value = $027e691579cc8976$var$form.getAttribute("data-search-country");
        const inputs = document.querySelectorAll('input[type="checkbox"][name="country"]');
        inputs.forEach((input)=>{
            if (input.value === value) input.checked = true;
        });
        $027e691579cc8976$var$form.classList.add("fyt--country-search");
    }
};
const $027e691579cc8976$var$initLoadFirstResults = ()=>{
    $027e691579cc8976$var$checkURLParams();
    $027e691579cc8976$var$checkIsCountrySearch();
    $027e691579cc8976$var$sendRequest(null, null, 1);
};
const $027e691579cc8976$var$initResearchModule = (researchModule)=>{
    const accordions = researchModule.querySelectorAll($027e691579cc8976$var$selectors.researchModuleAccordion);
    const tabs = researchModule.querySelectorAll($027e691579cc8976$var$selectors.researchModuleTabs);
    const checkboxes = researchModule.querySelectorAll($027e691579cc8976$var$selectors.input);
    const clearButtons = researchModule.querySelectorAll($027e691579cc8976$var$selectors.clearButton);
    const submitButtons = researchModule.querySelectorAll($027e691579cc8976$var$selectors.submitButton);
    tabs.forEach($027e691579cc8976$var$initTabs);
    $027e691579cc8976$var$initAccordions(accordions);
    $027e691579cc8976$var$initCheckboxes(checkboxes);
    $027e691579cc8976$var$initClearButtons(clearButtons, checkboxes);
    $027e691579cc8976$var$initSubmitButtons(submitButtons);
    $027e691579cc8976$var$initLoadFirstResults();
    $027e691579cc8976$var$initPagination();
};
const $027e691579cc8976$var$initResearchModuleTriggers = (researchModule, triggers)=>{
    triggers.forEach((trigger)=>trigger.addEventListener("click", ()=>{
            researchModule.classList.toggle($027e691579cc8976$var$selectors.active);
            document.body.classList.toggle("no-scroll");
        }));
};
document.addEventListener("DOMContentLoaded", async function() {
    const researchModule = document.querySelector($027e691579cc8976$var$selectors.researchModule);
    const triggers = document.querySelectorAll($027e691579cc8976$var$selectors.researchModuleTrigger);
    if (!researchModule || !triggers) return;
    $027e691579cc8976$var$initResearchModule(researchModule);
    $027e691579cc8976$var$initResearchModuleTriggers(researchModule, triggers);
}, {
    once: true
});


"use strict";


var $8ca840a8e07cb784$var$_swiper = $8ca840a8e07cb784$var$_interopRequireWildcard((parcelRequire("e1ad9")));
function $8ca840a8e07cb784$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8ca840a8e07cb784$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8ca840a8e07cb784$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8ca840a8e07cb784$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $8ca840a8e07cb784$var$initFormulaSlider = (container)=>{
    new $8ca840a8e07cb784$var$_swiper.default(container.querySelector(".swiper"), {
        modules: [
            $8ca840a8e07cb784$var$_swiper.Navigation,
            $8ca840a8e07cb784$var$_swiper.Scrollbar
        ],
        enabled: false,
        slidesPerView: "auto",
        scrollbar: {
            el: container.querySelector(".swiper-scrollbar"),
            draggable: true
        },
        navigation: {
            prevEl: container.querySelector(".prev"),
            nextEl: container.querySelector(".next")
        },
        breakpoints: {
            1024: {
                enabled: true,
                spaceBetween: 8,
                slidesPerView: 4
            }
        }
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll(".fs");
    containers?.forEach($8ca840a8e07cb784$var$initFormulaSlider);
}, {
    once: true
});


"use strict";

var $2c73c3bd1c1a5724$var$_swiper = $2c73c3bd1c1a5724$var$_interopRequireWildcard((parcelRequire("e1ad9")));

function $2c73c3bd1c1a5724$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2c73c3bd1c1a5724$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2c73c3bd1c1a5724$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2c73c3bd1c1a5724$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $2c73c3bd1c1a5724$var$selectors = {
    container: "[data-cs]",
    swiper: "[data-cs-swiper]",
    swiperSlide: "[data-cs-swiper-slide]"
};
const $2c73c3bd1c1a5724$var$initContentSlider = (container)=>{
    const slides = container.querySelectorAll($2c73c3bd1c1a5724$var$selectors.swiperSlide);
    new $2c73c3bd1c1a5724$var$_swiper.default(container.querySelector($2c73c3bd1c1a5724$var$selectors.swiper), {
        modules: [
            $2c73c3bd1c1a5724$var$_swiper.Navigation,
            $2c73c3bd1c1a5724$var$_swiper.Pagination
        ],
        slidesPerView: 1,
        spaceBetween: 8,
        navigation: {
            prevEl: container.querySelector(".prev"),
            nextEl: container.querySelector(".next")
        },
        pagination: {
            el: container.querySelector(".swiper-pagination")
        },
        breakpoints: {
            1024: {
                slidesPerView: slides?.length >= 4 ? 4 : slides?.length
            }
        }
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll($2c73c3bd1c1a5724$var$selectors.container);
    containers?.forEach($2c73c3bd1c1a5724$var$initContentSlider);
}, {
    once: true
});


"use strict";

var $28a6cc6f39f10fba$var$_swiper = $28a6cc6f39f10fba$var$_interopRequireWildcard((parcelRequire("e1ad9")));

function $28a6cc6f39f10fba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($28a6cc6f39f10fba$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $28a6cc6f39f10fba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $28a6cc6f39f10fba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $28a6cc6f39f10fba$var$initFormulaSlider = (container)=>{
    new $28a6cc6f39f10fba$var$_swiper.default(container.querySelector(".swiper"), {
        modules: [
            $28a6cc6f39f10fba$var$_swiper.Navigation,
            $28a6cc6f39f10fba$var$_swiper.Scrollbar
        ],
        enabled: false,
        slidesPerView: "auto",
        scrollbar: {
            el: container.querySelector(".swiper-scrollbar"),
            draggable: true
        },
        navigation: {
            prevEl: container.querySelector(".prev"),
            nextEl: container.querySelector(".next")
        },
        breakpoints: {
            1024: {
                enabled: container.classList.contains("ds_columns-4"),
                spaceBetween: container.classList.contains("ds_columns-4") ? 8 : 0,
                slidesPerView: container.classList.contains("ds_columns-4") ? 4 : "auto"
            }
        }
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll(".ds");
    containers?.forEach($28a6cc6f39f10fba$var$initFormulaSlider);
}, {
    once: true
});


"use strict";

var $3f2b04564a0dd862$var$_swiper = $3f2b04564a0dd862$var$_interopRequireWildcard((parcelRequire("e1ad9")));

function $3f2b04564a0dd862$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3f2b04564a0dd862$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3f2b04564a0dd862$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3f2b04564a0dd862$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $3f2b04564a0dd862$var$selectors = {
    container: "[data-ts]",
    tab: "[data-ts-tab]",
    pane: "[data-ts-pane]",
    hidden: "hidden",
    active: "active"
};
const $3f2b04564a0dd862$var$setActiveTab = (activeIndex, tab, tabs, panes, swiper)=>{
    tabs?.forEach((tab, index)=>tab.classList[activeIndex === index ? "add" : "remove"]($3f2b04564a0dd862$var$selectors.active));
    panes?.forEach((pane)=>{
        const isHidden = tab.dataset.tsTab !== pane.dataset.tsPane;
        pane.classList[isHidden ? "add" : "remove"]($3f2b04564a0dd862$var$selectors.hidden);
    });
    swiper.update();
};
const $3f2b04564a0dd862$var$initTravelSlider = (container)=>{
    const slides = container.querySelectorAll(".swiper-slide");
    const tabs = container.querySelectorAll($3f2b04564a0dd862$var$selectors.tab);
    const panes = container.querySelectorAll($3f2b04564a0dd862$var$selectors.pane);
    const swiper = new $3f2b04564a0dd862$var$_swiper.default(container.querySelector(".swiper"), {
        modules: [
            $3f2b04564a0dd862$var$_swiper.Navigation,
            $3f2b04564a0dd862$var$_swiper.Scrollbar,
            $3f2b04564a0dd862$var$_swiper.Pagination
        ],
        slidesPerView: "auto",
        spaceBetween: 8,
        scrollbar: {
            el: container.querySelector(".swiper-scrollbar"),
            draggable: true
        },
        navigation: {
            prevEl: container.querySelector(".prev"),
            nextEl: container.querySelector(".next")
        },
        pagination: {
            el: container.querySelector(".swiper-pagination")
        },
        breakpoints: {
            1024: {
                enabled: true,
                slidesPerView: slides.length <= 3 ? 3 : 4
            }
        }
    });
    if (tabs?.length) {
        tabs?.forEach((tab, activeIndex)=>{
            tab.addEventListener("click", ()=>$3f2b04564a0dd862$var$setActiveTab(activeIndex, tab, tabs, panes, swiper));
        });
        $3f2b04564a0dd862$var$setActiveTab(0, tabs[0], tabs, panes, swiper);
    }
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll($3f2b04564a0dd862$var$selectors.container);
    containers?.forEach($3f2b04564a0dd862$var$initTravelSlider);
}, {
    once: true
});


"use strict";



"use strict";



"use strict";



"use strict";



"use strict";


var $c174184459a5cfcc$var$_swiper = $c174184459a5cfcc$var$_interopRequireWildcard((parcelRequire("e1ad9")));
function $c174184459a5cfcc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c174184459a5cfcc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c174184459a5cfcc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c174184459a5cfcc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $c174184459a5cfcc$var$selectors = {
    container: "[data-map]",
    mapInteractive: "[data-map-interactive]",
    mapInteractiveItem: "[data-map-interactive-code]",
    mapImages: "[data-map-images]",
    region: "[data-map-region]",
    countries: "[data-map-countries]",
    country: "[data-map-country-code]",
    active: "active",
    hidden: "hidden"
};
const $c174184459a5cfcc$var$initMap = (container)=>{
    const interactiveItems = container.querySelectorAll($c174184459a5cfcc$var$selectors.mapInteractiveItem);
    const countries = [
        ...container.querySelectorAll($c174184459a5cfcc$var$selectors.country)
    ].reduce((acc, cur)=>[
            ...acc,
            {
                code: cur.dataset.mapCountryCode,
                region: cur.dataset.mapCountryRegion,
                node: cur
            }
        ], []);
    const tabs = [
        ...container.querySelectorAll($c174184459a5cfcc$var$selectors.region)
    ].reduce((acc, cur)=>[
            ...acc,
            {
                region: cur.dataset.mapRegion,
                node: cur
            }
        ], []);
    const imagesSwiper = new $c174184459a5cfcc$var$_swiper.default(container.querySelector($c174184459a5cfcc$var$selectors.mapImages), {
        enabled: true,
        slidesPerView: 1,
        spaceBetween: 8,
        on: {
            slideChangeTransitionEnd: (_ref)=>{
                let { activeIndex: activeIndex } = _ref;
                return tabs[activeIndex].node.click();
            }
        },
        breakpoints: {
            1024: {
                enabled: false
            }
        }
    });
    const countriesSwiper = new $c174184459a5cfcc$var$_swiper.default(container.querySelector($c174184459a5cfcc$var$selectors.countries), {
        modules: [
            $c174184459a5cfcc$var$_swiper.Scrollbar
        ],
        slidesPerView: 2,
        spaceBetween: 8,
        scrollbar: {
            el: container.querySelector("[data-map-countries-scrollbar]"),
            draggable: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 6
            }
        }
    });
    interactiveItems?.forEach((item)=>item.addEventListener("click", ()=>{
            const code = item.dataset.mapInteractiveCode;
            countries.find((country)=>country.code.toLowerCase() === code.toLowerCase())?.node.firstElementChild.click();
        }));
    tabs?.forEach((tab, activeIndex)=>tab.node.addEventListener("click", ()=>{
            const region = tab.node.dataset.mapRegion;
            const isActive = tab.node.classList.contains($c174184459a5cfcc$var$selectors.active);
            if (activeIndex === 0) {
                tabs.forEach((tab)=>tab.node.classList.remove($c174184459a5cfcc$var$selectors.active));
                countries.forEach((country)=>country.node.classList.remove($c174184459a5cfcc$var$selectors.hidden));
            } else {
                tabs.forEach((tab)=>tab.node.classList[region.includes(tab.region) ? !isActive ? "add" : "remove" : "remove"]($c174184459a5cfcc$var$selectors.active));
                countries.forEach((country)=>country.node.classList[!region.includes(country.region) ? !isActive ? "add" : "remove" : "remove"]($c174184459a5cfcc$var$selectors.hidden));
                const isTabActive = tabs.some((_ref2)=>{
                    let { node: node } = _ref2;
                    return node.classList.contains($c174184459a5cfcc$var$selectors.active);
                });
                imagesSwiper.slideTo(isTabActive ? activeIndex : 0, 300, false);
            }
            countriesSwiper.update();
        }));
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll($c174184459a5cfcc$var$selectors.container);
    containers?.forEach($c174184459a5cfcc$var$initMap);
}, {
    once: true
});


"use strict";



"use strict";
const $d4d06657c043713f$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $d4d06657c043713f$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $d4d06657c043713f$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($d4d06657c043713f$var$e(t) ? t : $d4d06657c043713f$var$i(t.parentElement, n));
}, $d4d06657c043713f$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $d4d06657c043713f$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $d4d06657c043713f$var$o = (t, e, i)=>{
    $d4d06657c043713f$var$s(e).forEach((e)=>{
        t && t.classList.toggle(e, i || !1);
    });
};
class $d4d06657c043713f$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $d4d06657c043713f$var$r = {
    passive: !1
};
class $d4d06657c043713f$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $d4d06657c043713f$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $d4d06657c043713f$var$r), this.element.addEventListener("touchmove", this.onMove, $d4d06657c043713f$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $d4d06657c043713f$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $d4d06657c043713f$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $d4d06657c043713f$var$a(t)) : [
            new $d4d06657c043713f$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $d4d06657c043713f$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $d4d06657c043713f$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $d4d06657c043713f$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $d4d06657c043713f$var$r), this.element.removeEventListener("touchmove", this.onMove, $d4d06657c043713f$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $d4d06657c043713f$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $d4d06657c043713f$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $d4d06657c043713f$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $d4d06657c043713f$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $d4d06657c043713f$var$d(i) ? Object.assign(t[e], $d4d06657c043713f$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $d4d06657c043713f$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $d4d06657c043713f$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $d4d06657c043713f$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $d4d06657c043713f$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $d4d06657c043713f$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $d4d06657c043713f$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($d4d06657c043713f$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.22"
}), Object.defineProperty($d4d06657c043713f$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $d4d06657c043713f$var$m extends $d4d06657c043713f$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
        this.emit("attachPlugins");
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $d4d06657c043713f$var$g;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($d4d06657c043713f$var$g || ($d4d06657c043713f$var$g = {}));
const $d4d06657c043713f$var$b = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $d4d06657c043713f$var$v = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $d4d06657c043713f$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $d4d06657c043713f$var$v
}, $d4d06657c043713f$var$w = '<div class="f-spinner"><svg viewBox="0 0 50 50"><circle cx="25" cy="25" r="20"></circle><circle cx="25" cy="25" r="20"></circle></svg></div>', $d4d06657c043713f$var$x = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $d4d06657c043713f$var$E = (t, e)=>{
    t && $d4d06657c043713f$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $d4d06657c043713f$var$S = (t, e)=>{
    t && $d4d06657c043713f$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $d4d06657c043713f$var$P = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $d4d06657c043713f$var$C = 1e5, $d4d06657c043713f$var$M = 1e3, $d4d06657c043713f$var$T = "mousemove", $d4d06657c043713f$var$O = "drag", $d4d06657c043713f$var$A = "content";
let $d4d06657c043713f$var$z = null, $d4d06657c043713f$var$L = null;
class $d4d06657c043713f$export$b704d075ddd20210 extends $d4d06657c043713f$var$m {
    get isTouchDevice() {
        return null === $d4d06657c043713f$var$L && ($d4d06657c043713f$var$L = window.matchMedia("(hover: none)").matches), $d4d06657c043713f$var$L;
    }
    get isMobile() {
        return null === $d4d06657c043713f$var$z && ($d4d06657c043713f$var$z = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $d4d06657c043713f$var$z;
    }
    get panMode() {
        return this.options.panMode !== $d4d06657c043713f$var$T || this.isTouchDevice ? $d4d06657c043713f$var$O : $d4d06657c043713f$var$T;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return "auto" === t ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $d4d06657c043713f$var$b){
            const e = "e" == t || "f" === t ? .001 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$g.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $d4d06657c043713f$var$P)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $d4d06657c043713f$var$P)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$b704d075ddd20210.Plugins), i)), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $d4d06657c043713f$var$n($d4d06657c043713f$var$w);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($d4d06657c043713f$var$A);
        let i = this.option($d4d06657c043713f$var$A) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $d4d06657c043713f$var$S(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        this.spinner && (this.spinner.remove(), this.spinner = null), this.option("spinner") && this.container.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), this.state === $d4d06657c043713f$var$g.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $d4d06657c043713f$var$g.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $d4d06657c043713f$var$g.Error, this.emit("error"));
    }
    attachObserver() {
        var t;
        const e = ()=>Math.abs(this.containerRect.width - this.container.getBoundingClientRect().width) > .1 || Math.abs(this.containerRect.height - this.container.getBoundingClientRect().height) > .1;
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $d4d06657c043713f$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($d4d06657c043713f$var$T, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($d4d06657c043713f$var$T, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        const t = this.friction;
        this.setTargetForce();
        const e = this.option("maxVelocity");
        for (const i of $d4d06657c043713f$var$b)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $d4d06657c043713f$var$b)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < .001 && (u = 0), Math.abs(p) < .001 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), m = new DOMPoint(0, 0 + h).matrixTransform(d), g = Math.abs(f.x - u.x), b = Math.abs(f.y - u.y), v = Math.abs(m.x - p.x), y = Math.abs(m.y - p.y);
            r = Math.max(g, v), l = Math.max(b, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $d4d06657c043713f$var$T || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $d4d06657c043713f$var$b)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $d4d06657c043713f$var$g.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i && i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $d4d06657c043713f$var$x(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        const r = this.content.getBoundingClientRect();
        if (this.dragStart.time && !this.canZoomOut() && (Math.abs(r.x - this.dragStart.x) > 2 || Math.abs(r.y - this.dragStart.y) > 2)) return;
        this.dragStart.time = 0;
        const l = (e)=>{
            this.option("zoom") && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, c = this.option("click", t), h = this.option("dblClick", t);
        h ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && c && l(c)) : (this.emit("dblClick", t), t.defaultPrevented || l(h)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && c && l(c));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $d4d06657c043713f$var$T && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable]") || o.closest("[data-selectable]") || o.closest("[data-draggable]") || o.closest("[data-clickable]") || o.closest("[data-panzoom-change]") || o.closest("[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $d4d06657c043713f$var$t(this.targetScale) <= $d4d06657c043713f$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $d4d06657c043713f$var$h(s[0], s[1]), r = $d4d06657c043713f$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $d4d06657c043713f$var$c(s[0], s[1]), p = $d4d06657c043713f$var$c(n[0], n[1]);
        let f = u ? p / u : 1, m = r.clientX - a.clientX, g = r.clientY - a.clientY;
        this.dragOffset.x += m, this.dragOffset.y += g, this.dragOffset.time = Date.now() - this.dragStart.time;
        let b = $d4d06657c043713f$var$t(this.targetScale) === $d4d06657c043713f$var$t(this.minScale) && this.option("lockAxis");
        if (b && !this.lockedAxis) {
            if ("xy" === b || "y" === b || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, m = 0, g = 0;
            } else this.lockedAxis = b;
        }
        if ($d4d06657c043713f$var$i(e.target, this.content) && (b = "x", this.dragOffset.y = 0), b && "xy" !== b && this.lockedAxis !== b && $d4d06657c043713f$var$t(this.targetScale) === $d4d06657c043713f$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const v = this.checkBounds(m, g);
        this.option("rubberband") ? ("x" !== this.isInfinite && (v.xDiff > 0 && m < 0 || v.xDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * v.xDiff))), "y" !== this.isInfinite && (v.yDiff > 0 && g < 0 || v.yDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * v.yDiff)))) : (v.xDiff && (m = 0), v.yDiff && (g = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $d4d06657c043713f$var$t(y) === $d4d06657c043713f$var$t(w) && (m = 0), "x" === this.lockedAxis && $d4d06657c043713f$var$t(y) === $d4d06657c043713f$var$t(w) && (g = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: m,
            panY: g,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $d4d06657c043713f$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $d4d06657c043713f$var$g.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $d4d06657c043713f$var$b)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $d4d06657c043713f$var$E(this.container, "is-scaling"), $d4d06657c043713f$var$E(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const m = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $d4d06657c043713f$var$t(m) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $d4d06657c043713f$var$t(m) === this.minScale) && (d = p = 0);
        const g = this.dragOffset.x, v = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(g) < y && Math.abs(v) < y && (h = d = 0, u = p = 0), (m < this.minScale - 1e-5 || m > this.maxScale + 1e-5 || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, g, v);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $d4d06657c043713f$var$T) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $d4d06657c043713f$var$P);
        for (const n of $d4d06657c043713f$var$b){
            const s = "e" == n || "f" === n ? $d4d06657c043713f$var$M : $d4d06657c043713f$var$C;
            o[n] = $d4d06657c043713f$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: m } = this.calculateContentDim();
        s.width = f, s.height = m, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $d4d06657c043713f$var$g.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        let f = this.option("width") || "auto", m = this.option("height") || "auto";
        "auto" === f && (f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o)), "auto" === m && (m = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o));
        let b = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (b = b.parentElement || b);
        const v = b.getAttribute("style") || "";
        b.style.setProperty("transform", "none", "important"), a && (b.style.width = "", b.style.height = ""), b.offsetHeight;
        const y = o.getBoundingClientRect();
        let w = y.width * n, x = y.height * n, E = 0, S = 0;
        a && (Math.abs(f - w) > 1 || Math.abs(m - x) > 1) && ({ width: w, height: x, top: E, left: S } = ((t, e, i, n)=>{
            const s = i / n;
            return s > t / e ? (i = t, n = t / s) : (i = e * s, n = e), {
                width: i,
                height: n,
                top: .5 * (e - n),
                left: .5 * (t - i)
            };
        })(w, x, f, m)), this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: y.top - r.top + E,
            bottom: r.bottom - y.bottom + E,
            left: y.left - r.left + S,
            right: r.right - y.right + S,
            fitWidth: w,
            fitHeight: x,
            width: w,
            height: x,
            fullWidth: f,
            fullHeight: m
        }), b.style.cssText = v, a && (b.style.width = `${w}px`, b.style.height = `${x}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($d4d06657c043713f$var$t(this.targetScale) < $d4d06657c043713f$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $d4d06657c043713f$var$g.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    getBounds() {
        const e = this.option("bounds");
        if ("auto" !== e) return e;
        const { contentWidth: i, contentHeight: n } = this.calculateContentDim(this.target);
        let s = 0, o = 0, a = 0, r = 0;
        const l = this.option("infinite");
        if (!0 === l || this.lockedAxis && l === this.lockedAxis) s = -1 / 0, a = 1 / 0, o = -1 / 0, r = 1 / 0;
        else {
            let { containerRect: e, contentRect: l } = this, c = $d4d06657c043713f$var$t(this.contentRect.fitWidth * this.targetScale, $d4d06657c043713f$var$M), h = $d4d06657c043713f$var$t(this.contentRect.fitHeight * this.targetScale, $d4d06657c043713f$var$M), { innerWidth: d, innerHeight: u } = e;
            if (this.containerRect.width === c && (d = e.width), this.containerRect.width === h && (u = e.height), i > d) {
                a = .5 * (i - d), s = -1 * a;
                let t = .5 * (l.right - l.left);
                s += t, a += t;
            }
            if (this.contentRect.fitWidth > d && i < d && (s -= .5 * (this.contentRect.fitWidth - d), a -= .5 * (this.contentRect.fitWidth - d)), n > u) {
                r = .5 * (n - u), o = -1 * r;
                let t = .5 * (l.bottom - l.top);
                o += t, r += t;
            }
            this.contentRect.fitHeight > u && n < u && (s -= .5 * (this.contentRect.fitHeight - u), a -= .5 * (this.contentRect.fitHeight - u));
        }
        return {
            x: {
                min: s,
                max: a
            },
            y: {
                min: o,
                max: r
            }
        };
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, fullScale: a, targetScale: r, coverScale: l, maxScale: c, minScale: h } = e;
        let d = {
            toggleMax: r - h < .5 * (c - h) ? c : h,
            toggleCover: r - h < .5 * (l - h) ? l : h,
            toggleZoom: r - h < .5 * (a - h) ? a : h
        }[e.option("click") || ""] || h, u = e.canZoomIn(), p = e.canZoomOut(), f = n === $d4d06657c043713f$var$O && !!this.option("touch"), m = p && f;
        f && ($d4d06657c043713f$var$t(r) < $d4d06657c043713f$var$t(h) && !this.panOnlyZoomed && (m = !0), ($d4d06657c043713f$var$t(s.width, 1) > $d4d06657c043713f$var$t(s.fitWidth, 1) || $d4d06657c043713f$var$t(s.height, 1) > $d4d06657c043713f$var$t(s.fitHeight, 1)) && (m = !0)), $d4d06657c043713f$var$t(s.width * r, 1) < $d4d06657c043713f$var$t(s.fitWidth, 1) && (m = !1), n === $d4d06657c043713f$var$T && (m = !1);
        let g = u && $d4d06657c043713f$var$t(d) > $d4d06657c043713f$var$t(r), b = !g && !m && p && $d4d06657c043713f$var$t(d) < $d4d06657c043713f$var$t(r);
        $d4d06657c043713f$var$o(i, this.cn("canZoomIn"), g), $d4d06657c043713f$var$o(i, this.cn("canZoomOut"), b), $d4d06657c043713f$var$o(i, this.cn("isDraggable"), m);
        for (const t of i.querySelectorAll('[data-panzoom-action="zoomIn"]'))u ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        for (const t of i.querySelectorAll('[data-panzoom-action="zoomOut"]'))p ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        for (const t of i.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            u || p ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
            const e = t.querySelector("g");
            e && (e.style.display = u ? "" : "none");
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $d4d06657c043713f$var$g.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        if (this.state === $d4d06657c043713f$var$g.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: u } = this, p = u.e, f = u.f, m = this.getMatrix(this.target);
        let v = (new DOMMatrix).translate(p, f).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            v = v.scale(n);
        }
        v = v.translate(-o, -a).translate(-p, -f).multiply(m), s && (v = v.rotate(s)), l && (v = v.scale(-1, 1)), c && (v = v.scale(1, -1));
        for (const e of $d4d06657c043713f$var$b)"e" !== e && "f" !== e && (v[e] > this.minScale + 1e-5 || v[e] < this.minScale - 1e-5) ? this.target[e] = v[e] : this.target[e] = $d4d06657c043713f$var$t(v[e], $d4d06657c043713f$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $d4d06657c043713f$var$T || !1 === d) && !h && this.clampTargetBounds(), this.isResting || (this.state = $d4d06657c043713f$var$g.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $d4d06657c043713f$var$g.Init || this.state === $d4d06657c043713f$var$g.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $d4d06657c043713f$var$b)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $d4d06657c043713f$var$E(this.container, "is-scaling"), $d4d06657c043713f$var$E(this.container, "is-animating"), this.isTicking = !1, this.state = $d4d06657c043713f$var$g.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $d4d06657c043713f$var$S(this.container, "is-animating"), this.isScaling && $d4d06657c043713f$var$S(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $d4d06657c043713f$var$T || !e) return;
        if ($d4d06657c043713f$var$t(this.targetScale) <= $d4d06657c043713f$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let m = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        m += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: m - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $d4d06657c043713f$var$g.Destroy || this.state === $d4d06657c043713f$var$g.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $d4d06657c043713f$var$t(l) < $d4d06657c043713f$var$t(r) && $d4d06657c043713f$var$t(o) <= $d4d06657c043713f$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $d4d06657c043713f$var$t(l) > $d4d06657c043713f$var$t(a) && $d4d06657c043713f$var$t(o) >= $d4d06657c043713f$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $d4d06657c043713f$var$t(l) !== $d4d06657c043713f$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($d4d06657c043713f$var$t(this.contentRect.width, 1) < $d4d06657c043713f$var$t(this.contentRect.fitWidth, 1) || $d4d06657c043713f$var$t(this.targetScale) < $d4d06657c043713f$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $d4d06657c043713f$var$t(this.targetScale) > $d4d06657c043713f$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.targetScale - this.minScale < .5 * (this.fullScale - this.minScale) ? "full" : "fit", t);
    }
    toggleMax(t) {
        this.zoomTo(this.targetScale - this.minScale < .5 * (this.maxScale - this.minScale) ? "max" : "fit", t);
    }
    toggleCover(t) {
        this.zoomTo(this.targetScale - this.minScale < .5 * (this.coverScale - this.minScale) ? "cover" : "fit", t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = "auto", originX: i = "auto", originY: n = "auto", event: s } = {}) {
        if (this.isContentLoading || this.state === $d4d06657c043713f$var$g.Destroy) return;
        const { targetScale: o } = this;
        this.stop();
        let a = 1;
        if (this.panMode === $d4d06657c043713f$var$T && (s = this.pmme || s), s || "auto" === i || "auto" === n) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        const r = this.fullScale, l = this.maxScale;
        let c = this.coverScale;
        "number" == typeof t ? a = t / o : ("next" === t && (r - c < .2 && (c = r), t = o < r - 1e-5 ? "full" : o < l - 1e-5 ? "max" : "fit"), a = "full" === t ? r / o || 1 : "cover" === t ? c / o || 1 : "max" === t ? l / o || 1 : 1 / o || 1), e = "auto" === e ? a > 1 ? .15 : .25 : e, this.applyChange({
            scale: a,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $d4d06657c043713f$var$T && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $d4d06657c043713f$var$g.Init && this.state !== $d4d06657c043713f$var$g.Destroy) {
            this.stop("current");
            for (const t of $d4d06657c043713f$var$b)this.target[t] = $d4d06657c043713f$var$P[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $d4d06657c043713f$var$g.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $d4d06657c043713f$var$g.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($d4d06657c043713f$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$y
}), Object.defineProperty($d4d06657c043713f$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $d4d06657c043713f$var$k = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $d4d06657c043713f$var$I = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $d4d06657c043713f$var$D = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $d4d06657c043713f$var$F;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($d4d06657c043713f$var$F || ($d4d06657c043713f$var$F = {}));
const $d4d06657c043713f$var$j = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $d4d06657c043713f$var$H = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $d4d06657c043713f$var$B extends $d4d06657c043713f$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $d4d06657c043713f$var$N = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $d4d06657c043713f$var$_ extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        return t || (t = document.createElement("ul"), $d4d06657c043713f$var$S(t, this.cn("list")), t.setAttribute("role", "tablist"), this.instance.container.appendChild(t), $d4d06657c043713f$var$S(this.instance.container, this.cn("hasDots")), this.list = t), t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($d4d06657c043713f$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $d4d06657c043713f$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$d4d06657c043713f$var$E(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $d4d06657c043713f$var$S(t, this.cn("isPrev")), $d4d06657c043713f$var$S(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $d4d06657c043713f$var$S(i, this.cn("isNext")), $d4d06657c043713f$var$S(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $d4d06657c043713f$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $d4d06657c043713f$var$E(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($d4d06657c043713f$var$_, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$N
});
const $d4d06657c043713f$var$W = "disabled", $d4d06657c043713f$var$$ = "next", $d4d06657c043713f$var$X = "prev";
class $d4d06657c043713f$var$Y extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($d4d06657c043713f$var$W), s.removeAttribute($d4d06657c043713f$var$W), t.isInfinite || (i <= 0 && n.setAttribute($d4d06657c043713f$var$W, ""), i >= e - 1 && s.setAttribute($d4d06657c043713f$var$W, "")));
    }
    createButton(t) {
        const e = this.instance, i = document.createElement("button");
        i.setAttribute("tabindex", "0"), i.setAttribute("title", e.localize(`{{${t.toUpperCase()}}}`)), $d4d06657c043713f$var$S(i, this.cn("button") + " " + this.cn(t === $d4d06657c043713f$var$$ ? "isNext" : "isPrev"));
        const n = e.isRTL ? t === $d4d06657c043713f$var$$ ? $d4d06657c043713f$var$X : $d4d06657c043713f$var$$ : t;
        var s;
        return i.innerHTML = e.localize(this.option(`${n}Tpl`)), i.dataset[`carousel${s = t, s ? s.match("^[a-z]") ? s.charAt(0).toUpperCase() + s.substring(1) : s : ""}`] = "true", i;
    }
    build() {
        let t = this.container;
        t || (this.container = t = document.createElement("div"), $d4d06657c043713f$var$S(t, this.cn("container")), this.instance.container.appendChild(t)), this.next || (this.next = t.appendChild(this.createButton($d4d06657c043713f$var$$))), this.prev || (this.prev = t.appendChild(this.createButton($d4d06657c043713f$var$X)));
    }
    cleanup() {
        this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove(), this.prev = null, this.next = null, this.container = null;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($d4d06657c043713f$var$Y, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $d4d06657c043713f$var$q extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        this.nav && this.target && (this.nav.options.initialSlide = this.target.options.initialPage, this.nav.on("ready", this.onNavReady), this.nav.state === $d4d06657c043713f$var$F.Ready && this.onNavReady(this.nav), this.target.on("ready", this.onTargetReady), this.target.state === $d4d06657c043713f$var$F.Ready && this.onTargetReady(this.target));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        const { target: t, nav: e } = this;
        if (!t || !e) return;
        if (e.state !== $d4d06657c043713f$var$F.Ready || t.state !== $d4d06657c043713f$var$F.Ready) return;
        const i = t.pages[t.page].slides[0].index, n = e.getPageForSlide(i);
        this.markSelectedSlide(i), e.slideTo(n);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $d4d06657c043713f$var$F.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($d4d06657c043713f$var$q, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $d4d06657c043713f$var$V = {
    Navigation: $d4d06657c043713f$var$Y,
    Dots: $d4d06657c043713f$var$_,
    Sync: $d4d06657c043713f$var$q
};
class $d4d06657c043713f$export$144901db2ea8e967 extends $d4d06657c043713f$var$m {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $d4d06657c043713f$var$F.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this;
        return n.length >= 2 && e + s[0].dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$F.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$d4d06657c043713f$var$x(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $d4d06657c043713f$var$k(this.slideNext.bind(this), 150), this.slidePrev = $d4d06657c043713f$var$k(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        const t = $d4d06657c043713f$var$u({}, $d4d06657c043713f$export$144901db2ea8e967.defaults, this.userOptions);
        let e = "";
        const i = t.breakpoints;
        if (i && $d4d06657c043713f$var$d(i)) for (const [n, s] of Object.entries(i))window.matchMedia(n).matches && $d4d06657c043713f$var$d(s) && (e += n, $d4d06657c043713f$var$u(t, s));
        e === this.bp && this.state !== $d4d06657c043713f$var$F.Init || (this.bp = e, this.state === $d4d06657c043713f$var$F.Ready && (t.initialSlide = this.pages[this.page].slides[0].index), this.state !== $d4d06657c043713f$var$F.Init && this.destroy(), super.setOptions(t), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $d4d06657c043713f$var$F.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$144901db2ea8e967.Plugins), this.userPlugins)), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $d4d06657c043713f$var$F.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $d4d06657c043713f$var$S(t, this.cn("container")), $d4d06657c043713f$var$o(t, e.isLTR, !this.isRTL), $d4d06657c043713f$var$o(t, e.isRTL, this.isRTL), $d4d06657c043713f$var$o(t, e.isVertical, !this.isHorizontal), $d4d06657c043713f$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $d4d06657c043713f$var$S(i, e.viewport), i.append(...$d4d06657c043713f$var$I(t, `.${e.slide}`)), t.prepend(i));
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $d4d06657c043713f$var$S(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (t) {
            this.slides = [], [
                ...$d4d06657c043713f$var$I(t, `.${this.cn("slide")}`)
            ].forEach((t)=>{
                if ($d4d06657c043713f$var$x(t)) {
                    const e = $d4d06657c043713f$var$j({
                        el: t,
                        isDom: !0,
                        index: this.slides.length
                    });
                    this.slides.push(e), this.emit("initSlide", e, this.slides.length);
                }
            });
            for (let t of this.option("slides", [])){
                const e = $d4d06657c043713f$var$j(t);
                e.index = this.slides.length, this.slides.push(e), this.emit("initSlide", e, this.slides.length);
            }
            this.emit("initSlides");
        }
    }
    setInitialPage() {
        let t = 0;
        const e = this.option("initialSlide");
        t = "number" == typeof e ? this.getPageForSlide(e) : parseInt(this.option("initialPage", 0) + "", 10) || 0, this.page = t;
    }
    setInitialPosition() {
        if (!this.track || !this.pages.length) return;
        const t = this.isHorizontal;
        let e = this.page;
        this.pages[e] || (this.page = e = 0);
        const i = this.pages[e].pos * (this.isRTL && t ? 1 : -1), n = t ? `${i}px` : "0", s = t ? "0" : `${i}px`;
        this.track.style.transform = `translate3d(${n}, ${s}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $d4d06657c043713f$export$b704d075ddd20210(this.viewport, $d4d06657c043713f$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        ("number" != typeof n || e <= i) && (n = 1 / 0);
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim > i || a === n) && (t.push($d4d06657c043713f$var$H()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n } = this, s = this.option("center"), o = this.option("fill"), a = o && s && i > n && !this.isInfinite;
        if (e.forEach((t, e)=>{
            t.index = e, t.pos = t.slides[0].pos, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            a && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : a && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : s && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e, s)=>{
            o && !this.isInfinite && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $d4d06657c043713f$var$t(e.pos, 1e3), e.dim = $d4d06657c043713f$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), this.isInfinite) return e;
        const r = [];
        let l;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            l && e.pos === l.pos ? (l.dim += e.dim, l.slides = [
                ...l.slides,
                ...e.slides
            ]) : (e.index = r.length, l = e, r.push(e));
        }), r;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = r && !r.parentNode;
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $d4d06657c043713f$var$S(r, this.cn("slide") + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r);
            const t = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            o = r.getBoundingClientRect()[s] * t;
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $d4d06657c043713f$var$t(o, 1e3),
            gap: $d4d06657c043713f$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, m = 0;
        d ? m = -1 * d.current[this.axis] : c[l] && (m = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (m *= -1);
        for (const i of h)i.el ? ("top" === e ? (i.el.style.right = "", i.el.style.left = "") : i.el.style.top = "", i.index !== u ? i.el.style[e] = 0 === p ? "" : `${$d4d06657c043713f$var$t(p, 1e3)}px` : i.el.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            m -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($d4d06657c043713f$var$t(i.pos) < $d4d06657c043713f$var$t(a) && $d4d06657c043713f$var$t(i.pos + i.dim + i.gap) < $d4d06657c043713f$var$t(m) && $d4d06657c043713f$var$t(m) > $d4d06657c043713f$var$t(r - a) && (i.el.style[e] = `${$d4d06657c043713f$var$t(p + f, 1e3)}px`), $d4d06657c043713f$var$t(i.pos + i.gap) >= $d4d06657c043713f$var$t(r - a) && $d4d06657c043713f$var$t(i.pos) > $d4d06657c043713f$var$t(m + a) && $d4d06657c043713f$var$t(m) < $d4d06657c043713f$var$t(a) && (i.el.style[e] = `-${$d4d06657c043713f$var$t(f, 1e3)}px`));
        }
        let g, b, v = [
            ...this.inTransition
        ];
        if (v.length > 1 && (g = c[v[0]], b = c[v[1]]), g && b) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && g.slides.indexOf(n) < 0 && (n.el.style[e] = `${$d4d06657c043713f$var$t(i + (g.pos - b.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $d4d06657c043713f$var$S(n, this.cn("slide")), $d4d06657c043713f$var$S(n, t.class), $d4d06657c043713f$var$S(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = t.el;
        if (!i || !i.parentNode) return;
        if ($d4d06657c043713f$var$E(i, this.cn("isSelected")), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), $d4d06657c043713f$var$E(i, this.cn("isSelected")), void (i.style.left = "");
        this.emit("removeSlide", t);
        const n = new CustomEvent("animationend");
        i.dispatchEvent(n), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        if (!e) return !1;
        const { pages: i, panzoom: n } = this;
        t = parseInt((t || 0).toString()) || 0;
        const s = this.getPageFromIndex(t);
        if (!n || !i[s] || i.length < 2 || Math.abs(i[this.page].slides[0].dim - this.viewportDim) > 1) return !1;
        const o = t > this.page ? 1 : -1, a = this.pages[s].pos * (this.isRTL ? 1 : -1);
        if (this.page === s && Math.abs(a - n.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const r = n.isResting;
        $d4d06657c043713f$var$S(this.container, this.cn("inTransition"));
        const l = this.pages[this.page].slides[0], c = this.pages[s].slides[0];
        this.inTransition.add(c.index), this.createSlideEl(c);
        let h = l.el, d = c.el;
        r || "slide" === e || (e = "fadeFast", h = null);
        const u = this.isRTL ? "next" : "prev", p = this.isRTL ? "prev" : "next";
        return h && (this.inTransition.add(l.index), l.transition = e, h.addEventListener("animationend", this.onAnimationEnd), h.classList.add(`f-${e}Out`, `to-${o > 0 ? p : u}`)), d && (c.transition = e, d.addEventListener("animationend", this.onAnimationEnd), d.classList.add(`f-${e}In`, `from-${o > 0 ? u : p}`)), n.panTo({
            x: this.isHorizontal ? a : 0,
            y: this.isHorizontal ? 0 : a,
            friction: 0
        }), this.onChange(s), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn("isSelected");
        if (e) for (const i of this.slides)i.el && (i.el.dataset.index = `${i.index}`, this.pages[this.page].slides.includes(i) ? (i.el.classList.contains(e) || ($d4d06657c043713f$var$S(i.el, e), this.emit("selectSlide", i)), i.el.removeAttribute(t)) : (i.el.classList.contains(e) && ($d4d06657c043713f$var$E(i.el, e), this.emit("unselectSlide", i)), i.el.setAttribute(t, "true")));
    }
    flipInfiniteTrack() {
        const t = this.panzoom;
        if (!t || !this.isInfinite) return;
        const e = "x" === this.option("axis") ? "e" : "f", { viewportDim: i, contentDim: n } = this;
        let s = t.current[e], o = t.target[e] - s, a = 0, r = .5 * i, l = n;
        this.isRTL && this.isHorizontal ? (s < -r && (a = -1, s += l), s > l - r && (a = 1, s -= l)) : (s > r && (a = 1, s -= l), s < -l + r && (a = -1, s += l)), a && (t.current[e] = s, t.target[e] = s + o);
    }
    lazyLoadSlide(t) {
        const e = this, i = t && t.el;
        if (!i) return;
        const s = new Set, o = "f-fadeIn";
        i.querySelectorAll("[data-lazy-srcset]").forEach((t)=>{
            t instanceof HTMLImageElement && s.add(t);
        });
        let a = Array.from(i.querySelectorAll("[data-lazy-src]"));
        i.dataset.lazySrc && a.push(i), a.map((t)=>{
            t instanceof HTMLImageElement ? s.add(t) : $d4d06657c043713f$var$x(t) && (t.style.backgroundImage = `url('${t.dataset.lazySrc || ""}')`, delete t.dataset.lazySrc);
        });
        const r = (t, i, n)=>{
            n && (n.remove(), n = null), i.complete && (i.classList.add(o), setTimeout(()=>{
                i.classList.remove(o);
            }, 350), i.style.display = ""), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (e.updateMetrics(), e.setViewportHeight()), this.emit("load", t);
        };
        for (const e of s){
            let i = null;
            e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.style.display = "none", e.addEventListener("error", ()=>{
                r(t, e, i);
            }), e.addEventListener("load", ()=>{
                r(t, e, i);
            }), setTimeout(()=>{
                e.parentNode && t.el && (e.complete ? r(t, e, i) : (i = $d4d06657c043713f$var$n($d4d06657c043713f$var$w), e.parentNode.insertBefore(i, e)));
            }, 300);
        }
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        const u = this.option("dragFree");
        let p = this.page, f = o && a ? 1 : -1;
        const m = t.target[r] * f, g = t.current[r] * f;
        let { pageIndex: b } = this.getPageFromPosition(m), { pageIndex: v } = this.getPageFromPosition(g);
        u ? this.onChange(b) : (Math.abs(d) > 5 ? (l[p].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (p = v), p = o && a ? d < 0 ? p - 1 : p + 1 : d < 0 ? p + 1 : p - 1) : p = 0 === n && 0 === s ? p : v, this.slideTo(p, {
            transition: !1,
            friction: t.option("decelFriction")
        }));
    }
    onClick(t) {
        const e = t.target, i = e && $d4d06657c043713f$var$x(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $d4d06657c043713f$var$F.Init, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $d4d06657c043713f$var$F.Destroy) return;
        const { axis: n, isHorizontal: s, isRTL: o, pages: a, panzoom: r } = this, l = a.length, c = o && s ? 1 : -1;
        if (!r || !l) return;
        if (this.transitionTo(t, i)) return;
        const h = this.getPageFromIndex(t);
        let d = a[h].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = r.target[n] * c;
            if (2 === l) d += e * Math.floor(parseFloat(t + "") / 2);
            else {
                const t = i;
                d = [
                    d,
                    d - e,
                    d + e
                ].reduce(function(e, i) {
                    return Math.abs(i - t) < Math.abs(e - t) ? i : e;
                });
            }
        }
        d *= c, Math.abs(r.target[n] - d) < .1 || (r.panTo({
            x: s ? d : 0,
            y: s ? 0 : d,
            friction: e
        }), this.onChange(h));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition(this.panzoom.current[this.isHorizontal ? "e" : "f"]);
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $d4d06657c043713f$var$E(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener("animationend", this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    prependSlide(t) {
        var e, i;
        let n = Array.isArray(t) ? t : [
            t
        ];
        for (const t of n.reverse())this.slides.unshift($d4d06657c043713f$var$j(t));
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        const s = (null === (e = this.pages[this.page]) || void 0 === e ? void 0 : e.pos) || 0;
        this.page += n.length, this.updateMetrics();
        const o = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0;
        if (this.panzoom) {
            const t = this.isRTL ? s - o : o - s;
            this.panzoom.target.e -= t, this.panzoom.current.e -= t, this.panzoom.requestTick();
        }
    }
    appendSlide(t) {
        let e = Array.isArray(t) ? t : [
            t
        ];
        for (const t of e){
            const e = $d4d06657c043713f$var$j(t);
            e.index = this.slides.length, this.slides.push(e), this.emit("initSlide", e, this.slides.length);
        }
        this.updateMetrics();
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e, this.removeSlideEl(this.slides[t], !0), this.slides.splice(t, 1);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        this.updateMetrics(), this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, isHorizontal: s } = this;
        if (!n) return;
        const o = s ? "width" : "height", a = s ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[a], $d4d06657c043713f$var$t(i.getBoundingClientRect()[o], 1e3)), n = getComputedStyle(i), r = "padding", l = s ? "Right" : "Bottom";
            e -= parseFloat(n[r + (s ? "Left" : "Top")]) + parseFloat(n[r + l]), this.viewportDim = e;
        }
        let r, l = this.pages.length, c = 0;
        for (const [e, i] of this.slides.entries()){
            let n = 0, s = 0;
            !i.el && r ? (n = r.dim, s = r.gap) : ({ dim: n, gap: s } = this.getSlideMetrics(i), r = i), n = $d4d06657c043713f$var$t(n, 1e3), s = $d4d06657c043713f$var$t(s, 1e3), i.dim = n, i.gap = s, i.pos = c, c += n, (this.isInfinite || e < this.slides.length - 1) && (c += s);
        }
        const h = this.contentDim;
        c = $d4d06657c043713f$var$t(c, 1e3), this.contentDim = c, e && (e.contentRect[o] = c, e.contentRect["e" === this.axis ? "fullWidth" : "fullHeight"] = c), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $d4d06657c043713f$var$F.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), e && l === this.pages.length && Math.abs(c - h) > .5 && (e.target[this.axis] = -1 * this.pages[this.page].pos, e.current[this.axis] = -1 * this.pages[this.page].pos, e.stop()), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1) {
        void 0 === e && (e = this.page);
        const n = this, s = n.panzoom, o = n.pages[e] || 0;
        if (!o || !s) return 0;
        let a = -1 * s.current.e, r = n.contentDim;
        var l = [
            $d4d06657c043713f$var$t((a - o.pos) / (1 * o.dim), 1e3),
            $d4d06657c043713f$var$t((a + r - o.pos) / (1 * o.dim), 1e3),
            $d4d06657c043713f$var$t((a - r - o.pos) / (1 * o.dim), 1e3)
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? l : Math.max(-1, Math.min(1, l));
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { contentDim: n, viewportDim: s, pages: o, page: a } = this;
        n = n + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
        let r = 0;
        r = this.panzoom ? -1 * this.panzoom.current[this.axis] : o[a] && o[a].pos || 0, this.isInfinite && (r -= Math.floor(r / n) * n), this.isRTL && this.isHorizontal && (r *= -1);
        const l = r - s * t, c = r + s * (t + 1), h = this.isInfinite ? [
            -1,
            0,
            1
        ] : [
            0
        ];
        for (const t of this.slides)for (const e of h){
            const s = t.pos + e * n, o = t.pos + t.dim + t.gap + e * n;
            s < c && o > l && i.add(t);
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i } = this, n = this.pages.length, s = this.slides.length, o = this.slides[s - 1];
        let a = 0, r = 0, l = 0;
        const c = this.option("center");
        c && (t += .5 * e), this.isInfinite || (t = Math.max(this.slides[0].pos, Math.min(t, o.pos)));
        const h = i + o.gap;
        l = Math.floor(t / h) || 0, t -= l * h;
        let d = o, u = this.slides.find((e)=>{
            const i = t + (d && !c ? .5 * d.dim : 0);
            return d = e, e.pos <= i && e.pos + e.dim + e.gap > i;
        });
        return u || (u = o), r = this.getPageForSlide(u.index), a = r + l * n, {
            page: a,
            pageIndex: r
        };
    }
    destroy() {
        if ([
            $d4d06657c043713f$var$F.Destroy
        ].includes(this.state)) return;
        this.state = $d4d06657c043713f$var$F.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes);
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$export$b704d075ddd20210
}), Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$D
}), Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$V
});
const $d4d06657c043713f$var$U = function(t) {
    const e = window.pageYOffset, i = window.pageYOffset + window.innerHeight;
    if (!$d4d06657c043713f$var$x(t)) return 0;
    const n = t.getBoundingClientRect(), s = n.y + window.pageYOffset, o = n.y + n.height + window.pageYOffset;
    if (e > o || i < s) return 0;
    if (e < s && i > o) return 100;
    if (s < e && o > i) return 100;
    let a = n.height;
    s < e && (a -= window.pageYOffset - s), o > i && (a -= o - i);
    const r = a / window.innerHeight * 100;
    return Math.round(r);
}, $d4d06657c043713f$var$G = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $d4d06657c043713f$var$K;
const $d4d06657c043713f$var$J = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $d4d06657c043713f$var$Q = (t)=>{
    if (t && $d4d06657c043713f$var$G) {
        void 0 === $d4d06657c043713f$var$K && document.createElement("div").focus({
            get preventScroll () {
                return $d4d06657c043713f$var$K = !0, !1;
            }
        });
        try {
            if ($d4d06657c043713f$var$K) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.pageXOffset || document.body.scrollTop, i = window.pageYOffset || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $d4d06657c043713f$var$tt = {
    dragToClose: !0,
    hideScrollbar: !0,
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    contentClick: "toggleZoom",
    contentDblClick: !1,
    backdropClick: "close",
    animated: !0,
    idle: 3500,
    showClass: "f-zoomInUp",
    hideClass: "f-fadeOut",
    commonCaption: !1,
    parentEl: null,
    startIndex: 0,
    l10n: Object.assign(Object.assign({}, $d4d06657c043713f$var$v), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    defaultType: "image",
    defaultDisplay: "block",
    autoFocus: !0,
    trapFocus: !0,
    placeFocusBack: !0,
    closeButton: "auto",
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    Fullscreen: {
        autoStart: !1
    },
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    wheel: "zoom"
};
var $d4d06657c043713f$var$et, $d4d06657c043713f$var$it;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($d4d06657c043713f$var$et || ($d4d06657c043713f$var$et = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($d4d06657c043713f$var$it || ($d4d06657c043713f$var$it = {}));
const $d4d06657c043713f$var$nt = ()=>{
    queueMicrotask(()=>{
        (()=>{
            const { slug: t, index: e } = $d4d06657c043713f$var$st.parseURL(), i = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
            if (i && !1 !== i.option("Hash")) {
                const n = i.carousel;
                if (t && n) {
                    for (let e of n.slides)if (e.slug && e.slug === t) return n.slideTo(e.index);
                    if (t === i.option("slug")) return n.slideTo(e - 1);
                    const s = i.getSlide(), o = s && s.triggerEl && s.triggerEl.dataset;
                    if (o && o.fancybox === t) return n.slideTo(e - 1);
                }
                $d4d06657c043713f$var$st.hasSilentClose = !0, i.close();
            }
            $d4d06657c043713f$var$st.startFromUrl();
        })();
    });
};
class $d4d06657c043713f$var$st extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "origHash", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onChange() {
        const t = this.instance, e = t.carousel;
        this.timer && clearTimeout(this.timer);
        const i = t.getSlide();
        if (!e || !i) return;
        const n = t.isOpeningSlide(i), s = new URL(document.URL).hash;
        let o, a = i.slug || void 0, r = i.triggerEl || void 0;
        o = a || this.instance.option("slug"), !o && r && r.dataset && (o = r.dataset.fancybox);
        let l = "";
        o && "true" !== o && (l = "#" + o + (!a && e.slides.length > 1 ? "-" + (i.index + 1) : "")), n && (this.origHash = s !== l ? s : ""), l && s !== l && (this.timer = setTimeout(()=>{
            try {
                t.state === $d4d06657c043713f$var$et.Ready && window.history[n ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + l);
            } catch (t) {}
        }, 300));
    }
    onClose() {
        if (this.timer && clearTimeout(this.timer), !0 !== $d4d06657c043713f$var$st.hasSilentClose) try {
            window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash || ""));
        } catch (t) {}
    }
    attach() {
        const t = this.instance;
        t.on("Carousel.ready", this.onChange), t.on("Carousel.change", this.onChange), t.on("close", this.onClose);
    }
    detach() {
        const t = this.instance;
        t.off("Carousel.ready", this.onChange), t.off("Carousel.change", this.onChange), t.off("close", this.onClose);
    }
    static parseURL() {
        const t = window.location.hash.slice(1), e = t.split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
        return {
            hash: t,
            slug: e.join("-"),
            index: n
        };
    }
    static startFromUrl() {
        if ($d4d06657c043713f$var$st.hasSilentClose = !1, $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance() || !1 === $d4d06657c043713f$export$cb45b08d97cdc4fd.defaults.Hash) return;
        const { hash: t, slug: e, index: i } = $d4d06657c043713f$var$st.parseURL();
        if (!e) return;
        let n = document.querySelector(`[data-slug="${t}"]`);
        if (n && n.dispatchEvent(new CustomEvent("click", {
            bubbles: !0,
            cancelable: !0
        })), $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) return;
        const s = document.querySelectorAll(`[data-fancybox="${e}"]`);
        s.length && (n = s[i - 1], n && n.dispatchEvent(new CustomEvent("click", {
            bubbles: !0,
            cancelable: !0
        })));
    }
    static destroy() {
        window.removeEventListener("hashchange", $d4d06657c043713f$var$nt, !1);
    }
}
function $d4d06657c043713f$var$ot() {
    window.addEventListener("hashchange", $d4d06657c043713f$var$nt, !1), setTimeout(()=>{
        $d4d06657c043713f$var$st.startFromUrl();
    }, 500);
}
Object.defineProperty($d4d06657c043713f$var$st, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
}), Object.defineProperty($d4d06657c043713f$var$st, "hasSilentClose", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: !1
}), $d4d06657c043713f$var$G && (/complete|interactive|loaded/.test(document.readyState) ? $d4d06657c043713f$var$ot() : document.addEventListener("DOMContentLoaded", $d4d06657c043713f$var$ot));
class $d4d06657c043713f$var$at extends $d4d06657c043713f$var$B {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a } = n, r = n.thumbElSrc;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $d4d06657c043713f$var$g.Init || a.state === $d4d06657c043713f$var$g.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $d4d06657c043713f$var$et.CustomClosing, i.classList.remove("is-zooming-in"), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${window.pageYOffset}px`,
            left: `${window.pageXOffset}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            var n;
            const s = t.contentEl, o = t.imageEl, a = t.thumbElSrc;
            if (i.isClosing() || !s || !o) return;
            s.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected")) {
                null === (n = t.el) || void 0 === n || n.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const e = document.createElement("div");
                $d4d06657c043713f$var$S(e, "fancybox-protected"), s.appendChild(e);
            }
            if (a && r) {
                const n = e.contentRect, o = Math.max(n.fullWidth, n.fullHeight);
                let c = null;
                !r.opacity && o > 1200 && (c = document.createElement("img"), $d4d06657c043713f$var$S(c, "fancybox-ghost"), c.src = a, s.appendChild(c));
                const h = ()=>{
                    c && ($d4d06657c043713f$var$S(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = a, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    t.state = $d4d06657c043713f$var$it.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{
                        i.hideLoading(t);
                    }), c && setTimeout(()=>{
                        h();
                    }, o > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $d4d06657c043713f$var$n(l)), !l || !$d4d06657c043713f$var$x(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset);
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            l.classList.add("fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $d4d06657c043713f$export$b704d075ddd20210(r, $d4d06657c043713f$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: a.optionFor(t, "width", "auto"),
                height: a.optionFor(t, "height", "auto"),
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $d4d06657c043713f$var$it.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                $d4d06657c043713f$var$E(s, "is-zooming-in"), t.scale < .99 || t.scale > 1.01 || (a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const m = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, g = this.optionFor(t, "initialSize");
            $d4d06657c043713f$var$S(s, "is-zooming-in"), n.hideLoading(t), "full" === g ? o.zoomToFull(m) : "cover" === g ? o.zoomToCover(m) : "max" === g ? o.zoomToMax(m) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        var e;
        const { el: i, imageEl: n, thumbEl: s, panzoom: o } = t;
        if (!i || !n || !s || !o || $d4d06657c043713f$var$U(s) < 3 || !this.optionFor(t, "zoom") || this.instance.state === $d4d06657c043713f$var$et.Destroy) return !1;
        if (1 !== ((null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1)) return !1;
        let { top: a, left: r, width: l, height: c } = s.getBoundingClientRect(), { top: h, left: d, fitWidth: u, fitHeight: p } = o.contentRect;
        if (!(l && c && u && p)) return !1;
        const f = o.container.getBoundingClientRect();
        d += f.left, h += f.top;
        const m = -1 * (d + .5 * u - (r + .5 * l)), g = -1 * (h + .5 * p - (a + .5 * c)), b = l / u;
        let v = this.option("zoomOpacity") || !1;
        return "auto" === v && (v = Math.abs(l / c - u / p) > .1), {
            x: m,
            y: g,
            scale: b,
            opacity: v
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($d4d06657c043713f$var$at, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $d4d06657c043713f$var$rt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i.toString();
        "t" === t ? s.set("start", parseInt(e).toString()) : s.set(t, e);
    }
    let o = s.toString(), a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $d4d06657c043713f$var$lt = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $d4d06657c043713f$var$ct = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo",
    "video"
];
class $d4d06657c043713f$var$ht extends $d4d06657c043713f$var$B {
    onInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onRemoveSlide(t, e, i) {
        i.xhr && (i.xhr.abort(), i.xhr = null);
        const n = i.iframeEl;
        n && (n.onload = n.onerror = null, n.src = "//about:blank", i.iframeEl = null);
        const s = i.contentEl, o = i.placeholderEl;
        if ("inline" === i.type && s && o) s.classList.remove("fancybox__content"), "none" !== s.style.display && (s.style.display = "none"), o.parentNode && o.parentNode.insertBefore(s, o), o.remove(), i.contentEl = void 0, i.placeholderEl = void 0;
        else for(; i.el && i.el.firstChild;)i.el.removeChild(i.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $d4d06657c043713f$var$it.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if ("html5video" === i.type) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        "vimeo" === i.type ? o = {
            method: "pause",
            value: "true"
        } : "youtube" === i.type && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.setAspectRatio(t), this.resizeIframe(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $d4d06657c043713f$var$et.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($d4d06657c043713f$var$x(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const e = t.iframeEl, i = null == e ? void 0 : e.parentElement;
        if (!e || !i) return;
        let n = t.autoSize, s = t.width || 0, o = t.height || 0;
        s && o && (n = !1);
        const a = i && i.style;
        if (!1 !== t.preload && !1 !== n && a) try {
            const t = window.getComputedStyle(i), n = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), r = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = e.contentWindow;
            if (l) {
                const t = l.document, e = t.getElementsByTagName("html")[0], i = t.body;
                a.width = "", i.style.overflow = "hidden", s = s || e.scrollWidth + n, a.width = `${s}px`, i.style.overflow = "", a.flex = "0 0 auto", a.height = `${i.scrollHeight}px`, o = e.scrollHeight + r;
            }
        } catch (t) {}
        if (s || o) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            s && (t.width = `${s}px`), o && (t.height = `${o}px`), Object.assign(a, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if ("html5video" === t.type) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if ("youtube" !== t.type && "vimeo" !== t.type) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = "youtube" === t.type ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                "youtube" === t.type && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = "html", t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, "youtube"), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $d4d06657c043713f$var$rt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = "youtube";
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $d4d06657c043713f$var$rt(e, this.optionFor(t, "vimeo")), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = "vimeo";
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $d4d06657c043713f$var$ct.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = "html5video", t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = "image" : e.match(/\.(pdf)((\?|#).*)?$/i) ? i = "pdf" : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = "map") : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = "map")), i = i || this.instance.option("defaultType"), t.type = i, "image" === i && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case "html":
                    this.instance.setContent(t, e);
                    break;
                case "html5video":
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case "map":
                case "youtube":
                case "vimeo":
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        var e;
        const i = t.width || 0, n = t.height || 0;
        if (i && n) return;
        const s = t.contentEl, o = this.optionFor(t, "videoRatio"), a = null === (e = t.el) || void 0 === e ? void 0 : e.getBoundingClientRect();
        if (!(s && a && o && 1 !== o && t.type && [
            "video",
            "youtube",
            "vimeo",
            "html5video"
        ].includes(t.type))) return;
        const r = a.width, l = a.height;
        s.style.aspectRatio = o + "", s.style.width = r / l > o ? "auto" : "", s.style.height = r / l > o ? "" : "auto";
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlide", t.onInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlide", t.onInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($d4d06657c043713f$var$ht, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$lt
});
const $d4d06657c043713f$var$dt = "play", $d4d06657c043713f$var$ut = "pause", $d4d06657c043713f$var$pt = "ready";
class $d4d06657c043713f$var$ft extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$pt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $d4d06657c043713f$var$pt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        var t;
        (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) || (this.removeProgressBar(), this.pause());
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $d4d06657c043713f$var$S(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $d4d06657c043713f$var$dt, $d4d06657c043713f$var$S(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $d4d06657c043713f$var$pt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $d4d06657c043713f$var$pt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $d4d06657c043713f$var$E(i, "has-autoplay"), e !== $d4d06657c043713f$var$pt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $d4d06657c043713f$var$dt && (t.state = $d4d06657c043713f$var$ut, t.clear(), t.emit($d4d06657c043713f$var$ut));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $d4d06657c043713f$var$dt) {
                if (t.state === $d4d06657c043713f$var$ut && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $d4d06657c043713f$var$dt || this.state === $d4d06657c043713f$var$ut ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($d4d06657c043713f$var$ft, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $d4d06657c043713f$var$mt extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $d4d06657c043713f$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $d4d06657c043713f$var$it.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $d4d06657c043713f$var$it.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $d4d06657c043713f$var$ft
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        e && i && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref;
        if (!i) return;
        const n = e.panzoom;
        n && n.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($d4d06657c043713f$var$mt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $d4d06657c043713f$var$gt = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $d4d06657c043713f$var$bt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden", t[t.Disabled = 3] = "Disabled";
}($d4d06657c043713f$var$bt || ($d4d06657c043713f$var$bt = {}));
let $d4d06657c043713f$var$vt = class extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "shouldCenter", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$bt.Init
        });
    }
    formatThumb(t, e) {
        return this.instance.localize(e, [
            [
                "%i",
                t.index
            ],
            [
                "%d",
                t.index + 1
            ],
            [
                "%s",
                t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            ]
        ]);
    }
    getSlides() {
        const t = [], e = this.option("thumbTpl") || "";
        if (e) for (const i of this.instance.slides || []){
            let n = "";
            i.type && (n = `for-${i.type}`, i.type && [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(i.type) && (n += " for-video")), t.push({
                html: this.formatThumb(i, e),
                customClass: n
            });
        }
        return t;
    }
    onInitSlide(t, e) {
        const i = e.el;
        i && (e.thumbSrc = i.dataset.thumbSrc || e.thumbSrc || "", e.thumbClipWidth = parseFloat(i.dataset.thumbClipWidth || "") || e.thumbClipWidth || 0, e.thumbHeight = parseFloat(i.dataset.thumbHeight || "") || e.thumbHeight || 0);
    }
    onInitSlides() {
        this.state === $d4d06657c043713f$var$bt.Init && this.build();
    }
    onRefreshM() {
        this.refreshModern();
    }
    onChangeM() {
        "modern" === this.type && (this.shouldCenter = !0, this.centerModern());
    }
    onClickModern(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, i = e.page, n = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return parseInt(e.dataset.carouselIndex || "", 10) || 0;
            }
            return -1;
        }, s = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? n(i) : -1;
        };
        let o = n(t.target);
        o < 0 && (o = s(t.clientX + this.thumbGap, t.clientY), o === i && (o = i - 1)), o < 0 && (o = s(t.clientX - this.thumbGap, t.clientY), o === i && (o = i + 1)), o < 0 && (o = ((e)=>{
            let n = s(t.clientX - e, t.clientY), a = s(t.clientX + e, t.clientY);
            return o < 0 && n === i && (o = i + 1), o < 0 && a === i && (o = i - 1), o;
        })(this.thumbExtraGap)), o === i ? this.centerModern() : o > -1 && o < e.pages.length && e.slideTo(o);
    }
    onTransformM() {
        if ("modern" !== this.type) return;
        const { instance: t, container: e, track: i } = this, n = t.panzoom;
        if (!(e && i && n && this.panzoom)) return;
        $d4d06657c043713f$var$o(e, this.cn("isResting"), n.state !== $d4d06657c043713f$var$g.Init && n.isResting);
        const s = this.thumbGap, a = this.thumbExtraGap, r = this.thumbClipWidth;
        let l = 0, c = 0, h = 0;
        for (const e of t.slides){
            let i = e.index, n = e.thumbSlideEl;
            if (!n) continue;
            $d4d06657c043713f$var$o(n, this.cn("isSelected"), i === t.page), c = 1 - Math.abs(t.getProgress(i)), n.style.setProperty("--progress", c ? c + "" : "");
            const d = .5 * ((e.thumbWidth || 0) - r);
            l += s, l += d, c && (l -= c * (d + a)), n.style.setProperty("--shift", l - s + ""), l += d, c && (l -= c * (d + a)), l -= s, 0 === i && (h = a * c);
        }
        i && (i.style.setProperty("--left", h + ""), i.style.setProperty("--width", l + h + s + a * c + "")), this.shouldCenter && this.centerModern();
    }
    buildClassic() {
        const { container: t, track: e } = this, i = this.getSlides();
        if (!t || !e || !i) return;
        const n = new this.instance.constructor(t, $d4d06657c043713f$var$u({
            track: e,
            infinite: !1,
            center: !0,
            fill: !0,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, this.option("Carousel") || {}, {
            Sync: {
                target: this.instance
            },
            slides: i
        }));
        this.carousel = n, this.track = e, n.on("ready", ()=>{
            this.emit("ready");
        }), n.on("createSlide", (t, e)=>{
            this.emit("createSlide", e, e.el);
        });
    }
    buildModern() {
        if ("modern" !== this.type) return;
        const { container: t, track: e, instance: i } = this, s = this.option("thumbTpl") || "";
        if (!t || !e || !s) return;
        t.addEventListener("keydown", ()=>{
            $d4d06657c043713f$var$E(t, "is-using-mouse");
        }), $d4d06657c043713f$var$S(t, "is-horizontal"), this.updateModern();
        for (const t of i.slides || []){
            const i = document.createElement("div");
            if ($d4d06657c043713f$var$S(i, this.cn("slide")), t.type) {
                let e = `for-${t.type}`;
                [
                    "video",
                    "youtube",
                    "vimeo",
                    "html5video"
                ].includes(t.type) && (e += " for-video"), $d4d06657c043713f$var$S(i, e);
            }
            i.appendChild($d4d06657c043713f$var$n(this.formatThumb(t, s))), this.emit("createSlide", t, i), t.thumbSlideEl = i, e.appendChild(i), this.resizeModernSlide(t);
        }
        const o = new i.constructor.Panzoom(t, {
            content: e,
            lockAxis: "x",
            zoom: !1,
            panOnlyZoomed: !1,
            bounds: ()=>{
                let t = 0, e = 0, n = i.slides[0], s = i.slides[i.slides.length - 1], o = i.slides[i.page];
                return n && s && o && (e = -1 * this.getModernThumbPos(0), 0 !== i.page && (e += .5 * (n.thumbWidth || 0)), t = -1 * this.getModernThumbPos(i.slides.length - 1), i.page !== i.slides.length - 1 && (t += (s.thumbWidth || 0) - (o.thumbWidth || 0) - .5 * (s.thumbWidth || 0))), {
                    x: {
                        min: t,
                        max: e
                    },
                    y: {
                        min: 0,
                        max: 0
                    }
                };
            }
        });
        o.on("touchStart", (t, e)=>{
            this.shouldCenter = !1, $d4d06657c043713f$var$S(this.container, "is-using-mouse");
        }), o.on("click", (t, e)=>this.onClickModern(e)), o.on("ready", ()=>{
            this.centerModern(), this.emit("ready");
        }), o.on([
            "afterTransform",
            "refresh"
        ], (t)=>{
            this.lazyLoadModern();
        }), this.panzoom = o, this.refreshModern();
    }
    updateModern() {
        if ("modern" !== this.type) return;
        const { container: t } = this;
        t && (this.thumbGap = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-gap")) || 0, this.thumbExtraGap = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-extra-gap")) || 0, this.thumbWidth = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-width")) || 40, this.thumbClipWidth = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-clip-width")) || 40, this.thumbHeight = parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-height")) || 40);
    }
    refreshModern() {
        var t;
        if ("modern" === this.type) {
            this.updateModern();
            for (const t of this.instance.slides || [])this.resizeModernSlide(t);
            this.onTransformM(), null === (t = this.panzoom) || void 0 === t || t.updateMetrics(!0), this.centerModern(0);
        }
    }
    centerModern(e) {
        const i = this.instance, { container: n, panzoom: s } = this;
        if (!n || !s || s.state === $d4d06657c043713f$var$g.Init) return;
        const o = i.page;
        let a = this.getModernThumbPos(o), r = a;
        for(let t = i.page - 3; t < i.page + 3; t++){
            if (t < 0 || t > i.pages.length - 1 || t === i.page) continue;
            const e = 1 - Math.abs(i.getProgress(t));
            e > 0 && e < 1 && (r += e * (this.getModernThumbPos(t) - a));
        }
        let l = 100;
        void 0 === e && (e = .2, i.inTransition.size > 0 && (e = .12), Math.abs(-1 * s.current.e - r) > s.containerRect.width && (e = .5, l = 0)), s.options.maxVelocity = l, s.applyChange({
            panX: $d4d06657c043713f$var$t(-1 * r - s.target.e, 1e3),
            friction: null === i.prevPage ? 0 : e
        });
    }
    lazyLoadModern() {
        const { instance: t, panzoom: e } = this;
        if (!e) return;
        const i = -1 * e.current.e || 0;
        let s = this.getModernThumbPos(t.page);
        if (e.state !== $d4d06657c043713f$var$g.Init || 0 === s) for (const s of t.slides || []){
            const t = s.thumbSlideEl;
            if (!t) continue;
            const o = t.querySelector("img[data-lazy-src]"), a = s.index, r = this.getModernThumbPos(a), l = i - .5 * e.containerRect.innerWidth, c = l + e.containerRect.innerWidth;
            if (!o || r < l || r > c) continue;
            let h = o.dataset.lazySrc;
            if (!h || !h.length) continue;
            if (delete o.dataset.lazySrc, o.src = h, o.complete) continue;
            $d4d06657c043713f$var$S(t, this.cn("isLoading"));
            const d = $d4d06657c043713f$var$n($d4d06657c043713f$var$w);
            t.appendChild(d), o.addEventListener("load", ()=>{
                t.offsetParent && (t.classList.remove(this.cn("isLoading")), d.remove());
            }, !1);
        }
    }
    resizeModernSlide(t) {
        if ("modern" !== this.type) return;
        if (!t.thumbSlideEl) return;
        const e = t.thumbClipWidth && t.thumbHeight ? Math.round(this.thumbHeight * (t.thumbClipWidth / t.thumbHeight)) : this.thumbWidth;
        t.thumbWidth = e;
    }
    getModernThumbPos(e) {
        const i = this.instance.slides[e], n = this.panzoom;
        if (!n || !n.contentRect.fitWidth) return 0;
        let s = n.containerRect.innerWidth, o = n.contentRect.width;
        2 === this.instance.slides.length && (e -= 1, o = 2 * this.thumbClipWidth);
        let a = e * (this.thumbClipWidth + this.thumbGap) + this.thumbExtraGap + .5 * (i.thumbWidth || 0);
        return a -= o > s ? .5 * s : .5 * o, $d4d06657c043713f$var$t(a || 0, 1);
    }
    build() {
        const t = this.instance, e = t.container, i = this.option("minCount") || 0;
        if (i) {
            let e = 0;
            for (const i of t.slides || [])i.thumbSrc && e++;
            if (e < i) return this.cleanup(), void (this.state = $d4d06657c043713f$var$bt.Disabled);
        }
        const n = this.option("type");
        if ([
            "modern",
            "classic"
        ].indexOf(n) < 0) return void (this.state = $d4d06657c043713f$var$bt.Disabled);
        this.type = n;
        const s = document.createElement("div");
        $d4d06657c043713f$var$S(s, this.cn("container")), $d4d06657c043713f$var$S(s, `is-${n}`);
        const o = this.option("parentEl");
        o ? o.appendChild(s) : e.after(s), this.container = s, $d4d06657c043713f$var$S(e, this.cn("hasThumbs"));
        const a = document.createElement("div");
        $d4d06657c043713f$var$S(a, this.cn("track")), s.appendChild(a), this.track = a, "classic" === n ? this.buildClassic() : this.buildModern(), this.state = $d4d06657c043713f$var$bt.Ready;
    }
    cleanup() {
        this.carousel && this.carousel.destroy(), this.carousel = null, this.panzoom && this.panzoom.destroy(), this.panzoom = null, this.container && this.container.remove(), this.container = null, this.track = null, this.state = $d4d06657c043713f$var$bt.Init, $d4d06657c043713f$var$E(this.instance.container, this.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $d4d06657c043713f$var$F.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on("Panzoom.afterTransform", t.onTransformM), e.on("Panzoom.refresh", t.onRefreshM), e.on("change", t.onChangeM);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off("Panzoom.afterTransform", t.onTransformM), e.off("Panzoom.refresh", t.onRefreshM), e.off("change", t.onChangeM), t.cleanup();
    }
};
Object.defineProperty($d4d06657c043713f$var$vt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$gt
});
const $d4d06657c043713f$var$yt = Object.assign(Object.assign({}, $d4d06657c043713f$var$gt), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $d4d06657c043713f$var$wt = "is-masked", $d4d06657c043713f$var$xt = "aria-hidden";
class $d4d06657c043713f$var$Et extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && t.state !== $d4d06657c043713f$var$bt.Disabled;
    }
    get isHidden() {
        return this.hidden;
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $d4d06657c043713f$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $d4d06657c043713f$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: (t, e)=>{
                e.stopPropagation();
            }
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $d4d06657c043713f$var$vt
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $d4d06657c043713f$var$bt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        t && t.state !== $d4d06657c043713f$var$bt.Disabled && (t.state !== $d4d06657c043713f$var$bt.Hidden ? this.hidden ? this.show() : this.hide() : t.build());
    }
    show() {
        const t = this.ref, e = t && t.state !== $d4d06657c043713f$var$bt.Disabled && t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($d4d06657c043713f$var$xt), e.classList.remove($d4d06657c043713f$var$wt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($d4d06657c043713f$var$wt), e.setAttribute($d4d06657c043713f$var$xt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || t.state === $d4d06657c043713f$var$bt.Disabled) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $d4d06657c043713f$var$et.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($d4d06657c043713f$var$Et, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$yt
});
const $d4d06657c043713f$var$St = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $d4d06657c043713f$var$Pt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($d4d06657c043713f$var$Pt || ($d4d06657c043713f$var$Pt = {}));
const $d4d06657c043713f$var$Ct = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $d4d06657c043713f$var$Mt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
};
class $d4d06657c043713f$var$Tt extends $d4d06657c043713f$var$B {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$Pt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $d4d06657c043713f$var$S(i, "fancybox__toolbar__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $d4d06657c043713f$var$S(r, "is-absolute"), this.state = $d4d06657c043713f$var$Pt.Ready, this.onRefresh();
        } else this.state = $d4d06657c043713f$var$Pt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $d4d06657c043713f$var$x(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $d4d06657c043713f$var$it.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t, i = document.createElement("div");
        return $d4d06657c043713f$var$S(i, "fancybox__toolbar"), e.prepend(i), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $d4d06657c043713f$var$S(t, "has-toolbar"), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !e.fsAPI) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $d4d06657c043713f$var$St[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $d4d06657c043713f$var$St[t]) {
            const e = $d4d06657c043713f$var$St[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $d4d06657c043713f$var$S(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($d4d06657c043713f$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $d4d06657c043713f$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($d4d06657c043713f$var$Mt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $d4d06657c043713f$var$Pt.Disabled;
        const e = this.instance.container;
        e && $d4d06657c043713f$var$E(e, "has-toolbar");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on("reveal", t.onChange), e.on("Carousel.change", t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off("reveal", t.onChange), e.off("Carousel.change", t.onChange), t.removeContainer();
    }
}
Object.defineProperty($d4d06657c043713f$var$Tt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Ct
});
const $d4d06657c043713f$var$Ot = {
    Hash: $d4d06657c043713f$var$st,
    Html: $d4d06657c043713f$var$ht,
    Images: $d4d06657c043713f$var$at,
    Slideshow: $d4d06657c043713f$var$mt,
    Thumbs: $d4d06657c043713f$var$Et,
    Toolbar: $d4d06657c043713f$var$Tt
}, $d4d06657c043713f$var$At = "with-fancybox", $d4d06657c043713f$var$zt = "hide-scrollbar", $d4d06657c043713f$var$Lt = "--fancybox-scrollbar-compensate", $d4d06657c043713f$var$Rt = "--fancybox-body-margin", $d4d06657c043713f$var$kt = "is-animated", $d4d06657c043713f$var$It = "is-compact", $d4d06657c043713f$var$Dt = "is-loading", $d4d06657c043713f$var$Ft = function() {
    var t = window.getSelection();
    return t && "Range" === t.type;
};
let $d4d06657c043713f$var$jt = null, $d4d06657c043713f$var$Ht = null;
const $d4d06657c043713f$var$Bt = new Map;
let $d4d06657c043713f$var$Nt = 0;
class $d4d06657c043713f$export$cb45b08d97cdc4fd extends $d4d06657c043713f$var$m {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$et.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "fsAPI", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.fsAPI = (()=>{
            let t, e = "", i = "", n = "";
            return document.fullscreenEnabled ? (e = "requestFullscreen", i = "exitFullscreen", n = "fullscreenElement") : document.webkitFullscreenEnabled && (e = "webkitRequestFullscreen", i = "webkitExitFullscreen", n = "webkitFullscreenElement"), e && (t = {
                request: function(t) {
                    return "webkitRequestFullscreen" === e ? t[e](Element.ALLOW_KEYBOARD_INPUT) : t[e]();
                },
                exit: function() {
                    return document[n] && document[i]();
                },
                isFullscreen: function() {
                    return document[n];
                }
            }), t;
        })(), this.id = e.id || ++$d4d06657c043713f$var$Nt, $d4d06657c043713f$var$Bt.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $d4d06657c043713f$var$et.Destroy) return;
        this.state = $d4d06657c043713f$var$et.Init, this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$d4d06657c043713f$var$G) return;
            const t = document.body;
            if (t.classList.contains($d4d06657c043713f$var$zt)) return;
            let e = window.innerWidth - document.documentElement.getBoundingClientRect().width;
            e < 0 && (e = 0);
            const i = t.currentStyle || window.getComputedStyle(t), n = parseFloat(i.marginRight);
            document.documentElement.style.setProperty($d4d06657c043713f$var$Lt, `${e}px`), n && t.style.setProperty($d4d06657c043713f$var$Rt, `${n}px`), t.classList.add($d4d06657c043713f$var$zt);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $d4d06657c043713f$var$et.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute("aria-hidden", "false");
            }, 16);
        }, e = this.fsAPI;
        this.option("Fullscreen.autoStart") && e && !e.isFullscreen() ? e.request(this.container).then(()=>t()).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $d4d06657c043713f$var$n(this.localize(this.option("tpl.main") || ""));
        s && (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($d4d06657c043713f$var$It, this.isCompact), $d4d06657c043713f$var$S(s, this.option("mainClass") || ""), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $d4d06657c043713f$var$S(document.documentElement, $d4d06657c043713f$var$At), $d4d06657c043713f$var$jt && $d4d06657c043713f$var$Ht || ($d4d06657c043713f$var$jt = document.createElement("span"), $d4d06657c043713f$var$S($d4d06657c043713f$var$jt, "fancybox-focus-guard"), $d4d06657c043713f$var$jt.setAttribute("tabindex", "0"), $d4d06657c043713f$var$jt.setAttribute("aria-hidden", "true"), $d4d06657c043713f$var$jt.setAttribute("aria-label", "Focus guard"), $d4d06657c043713f$var$Ht = $d4d06657c043713f$var$jt.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($d4d06657c043713f$var$jt, s), null === (e = s.parentElement) || void 0 === e || e.append($d4d06657c043713f$var$Ht)), this.option("animated") && ($d4d06657c043713f$var$S(s, $d4d06657c043713f$var$kt), setTimeout(()=>{
            this.isClosing() || $d4d06657c043713f$var$E(s, $d4d06657c043713f$var$kt);
        }, 350)), this.emit("initLayout"));
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $d4d06657c043713f$export$144901db2ea8e967(n, $d4d06657c043713f$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            var t;
            const e = this.getSlide();
            e && (null === (t = e.panzoom) || void 0 === t || t.updateControls()), this.manageCaption(e);
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            i.contentEl && (i.contentEl.remove(), i.contentEl = void 0);
            const n = i.el;
            n && ($d4d06657c043713f$var$E(n, "has-error"), $d4d06657c043713f$var$E(n, "has-unknown"), $d4d06657c043713f$var$E(n, `has-${i.type || "unknown"}`)), i.closeBtnEl && i.closeBtnEl.remove(), i.closeBtnEl = void 0, i.captionEl && i.captionEl.remove(), i.captionEl = void 0, i.spinnerEl && i.spinnerEl.remove(), i.spinnerEl = void 0, i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $d4d06657c043713f$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $d4d06657c043713f$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute("disabled"), i.removeAttribute("tabindex")) : (i.setAttribute("disabled", ""), i.setAttribute("tabindex", "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute("disabled"), i.removeAttribute("tabindex")) : (i.setAttribute("disabled", ""), i.setAttribute("tabindex", "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || "string" != typeof i.src || (n = i.src);
            const s = "disabled", o = "tabindex", a = "download", r = "href";
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute(s), t.removeAttribute(o), t.setAttribute(r, n), t.setAttribute(a, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute(s, ""), t.setAttribute(o, "-1"), t.removeAttribute(r), t.removeAttribute(a));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e, i;
        const { container: n, isCompact: s } = this;
        if (!n || this.isClosing()) return;
        !s && this.option("idle") && this.resetIdle();
        const o = document.activeElement;
        if ($d4d06657c043713f$var$Ft() && o && n.contains(o)) return;
        const a = t.composedPath()[0];
        if (a === (null === (e = this.carousel) || void 0 === e ? void 0 : e.container)) return;
        if (a.closest(".f-spinner") || a.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (a.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (a.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if (s && "image" === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let r = !1;
        if (a.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                a.matches($d4d06657c043713f$var$J) || o.blur();
            }
            if ($d4d06657c043713f$var$Ft()) return;
            r = this.option("contentClick");
        } else a.closest(".fancybox__carousel") && !a.matches($d4d06657c043713f$var$J) && (r = this.option("backdropClick"));
        "close" === r ? (t.preventDefault(), this.close(t)) : "next" === r ? (t.preventDefault(), this.next()) : "prev" === r && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        var e;
        let i = this.option("wheel", t);
        (null === (e = t.target) || void 0 === e ? void 0 : e.closest(".fancybox__thumbs")) && (i = "slide");
        const n = "slide" === i, s = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), o = Math.max(-1, Math.min(1, s)), a = Date.now();
        this.pwt && a - this.pwt < 300 ? n && t.preventDefault() : (this.pwt = a, this.emit("wheel", t), t.defaultPrevented || ("close" === i ? (t.preventDefault(), this.close(t)) : "slide" === i && (t.preventDefault(), this[o > 0 ? "prev" : "next"]())));
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i || t.ctrlKey || t.altKey || t.shiftKey) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $d4d06657c043713f$var$x(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        this.emit("keydown", e, t);
        const a = i[e];
        "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = $d4d06657c043713f$var$It, e = this.container;
        if (!e) return;
        const i = this.isCompact;
        e.classList.toggle(t, i), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $d4d06657c043713f$var$Pt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $d4d06657c043713f$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $d4d06657c043713f$var$S(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = "has-caption", o = this.container;
        if (!o) return;
        const a = this.isCompact || this.option("commonCaption"), r = !a;
        if (this.caption && this.stop(this.caption), r && this.caption && (this.caption.remove(), this.caption = null), a && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $d4d06657c043713f$var$E(t.el, s), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || a && !this.isCurrentSlide(t)) return;
        const l = t.el;
        let c = this.optionFor(t, "caption", "");
        if (!c) return void (a && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let h = null;
        if (r) {
            if (h = t.captionEl || null, l && !h) {
                const e = n + `_${this.id}_${t.index}`;
                h = document.createElement("div"), $d4d06657c043713f$var$S(h, n), h.setAttribute("id", e), t.captionEl = l.appendChild(h), $d4d06657c043713f$var$S(l, s), l.setAttribute("aria-labelledby", e);
            }
        } else {
            if (h = this.caption, h || (h = o.querySelector("." + n)), !h) {
                h = document.createElement("div"), h.dataset.fancyboxCaption = "", $d4d06657c043713f$var$S(h, n);
                (this.footer || o).prepend(h);
            }
            $d4d06657c043713f$var$S(o, s), this.caption = h;
        }
        h && (h.innerHTML = "", "string" == typeof c ? h.innerHTML = c : c instanceof HTMLElement && h.appendChild(c));
    }
    checkFocus(t) {
        var e;
        const i = document.activeElement || null;
        i && (null === (e = this.container) || void 0 === e ? void 0 : e.contains(i)) || this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = this.getSlide();
        if (!s || !(null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport)) return;
        if (!t && i && s.contains(i)) return;
        const a = o && o.state === $d4d06657c043713f$var$it.Ready ? o.el : null;
        if (!a || a.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const r = Array.from(s.querySelectorAll($d4d06657c043713f$var$J));
        let l = [], c = null;
        for (let t of r){
            const e = !t.offsetParent || t.closest('[aria-hidden="true"]'), i = a && a.contains(t), n = !this.carousel.viewport.contains(t);
            if (t === s || (i || n) && !e) {
                l.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && c || (c = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let h = null;
        t ? (!n || l.indexOf(n) < 0) && (h = c || s, l.length && (i === $d4d06657c043713f$var$Ht ? h = l[0] : this.lastFocus !== s && i !== $d4d06657c043713f$var$jt || (h = l[l.length - 1]))) : h = o && "image" === o.type ? s : c || s, h && $d4d06657c043713f$var$Q(h), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $d4d06657c043713f$var$E(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $d4d06657c043713f$var$S(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($d4d06657c043713f$var$x(e) ? o = e : (o = $d4d06657c043713f$var$n(e + ""), $d4d06657c043713f$var$x(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $d4d06657c043713f$var$x(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $d4d06657c043713f$var$x(o) ? ($d4d06657c043713f$var$S(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), "none" !== o.style.display && "none" !== getComputedStyle(o).getPropertyValue("display") || (o.style.display = t.display || this.option("defaultDisplay") || "flex"), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $d4d06657c043713f$var$it.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $d4d06657c043713f$var$it.Ready, this.emit("done", t), $d4d06657c043713f$var$S(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            this.option("autoFocus") && (this.option("autoFocus") ? this.focus() : this.checkFocus());
        }), this.isOpeningSlide(t) && !this.isCompact && this.option("idle") && this.setIdle());
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $d4d06657c043713f$var$it.Loading;
        const e = t.el;
        if (!e) return;
        $d4d06657c043713f$var$S(e, $d4d06657c043713f$var$Dt), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $d4d06657c043713f$var$it.Loading) {
                let i = $d4d06657c043713f$var$n($d4d06657c043713f$var$w);
                t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($d4d06657c043713f$var$E(e, $d4d06657c043713f$var$Dt), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $d4d06657c043713f$var$it.Loading && (this.emit("loaded", t), t.state = $d4d06657c043713f$var$it.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        var e;
        null === (e = this.carousel) || void 0 === e || e.emit("removeSlide", t);
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = this.fsAPI, s = ()=>{
            this.proceedClose(t, e);
        };
        n && n.isFullscreen() ? Promise.resolve(n.exit()).then(()=>s()) : s();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $d4d06657c043713f$var$S(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $d4d06657c043713f$var$E(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        const t = this.fsAPI;
        t && (t.isFullscreen() ? t.exit() : this.container && t.request(this.container));
    }
    isClosing() {
        return [
            $d4d06657c043713f$var$et.Closing,
            $d4d06657c043713f$var$et.CustomClosing,
            $d4d06657c043713f$var$et.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $d4d06657c043713f$var$et.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($d4d06657c043713f$var$U(r) ? $d4d06657c043713f$var$Q(r) : r.focus()), s && ($d4d06657c043713f$var$S(s, "is-closing"), s.setAttribute("aria-hidden", "true"), this.option("animated") && $d4d06657c043713f$var$S(s, $d4d06657c043713f$var$kt), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $d4d06657c043713f$var$it.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        this.emit("close", t), this.state !== $d4d06657c043713f$var$et.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $d4d06657c043713f$var$et.Destroy) return;
        this.state = $d4d06657c043713f$var$et.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $d4d06657c043713f$var$Bt.delete(this.id);
        const i = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($d4d06657c043713f$var$jt && ($d4d06657c043713f$var$jt.remove(), $d4d06657c043713f$var$jt = null), $d4d06657c043713f$var$Ht && ($d4d06657c043713f$var$Ht.remove(), $d4d06657c043713f$var$Ht = null), $d4d06657c043713f$var$E(document.documentElement, $d4d06657c043713f$var$At), (()=>{
            if (!$d4d06657c043713f$var$G) return;
            const t = document, e = t.body;
            e.classList.remove($d4d06657c043713f$var$zt), e.style.setProperty($d4d06657c043713f$var$Rt, ""), t.documentElement.style.setProperty($d4d06657c043713f$var$Lt, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$d4d06657c043713f$var$G) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : "string" == typeof t ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, "string" == typeof e && (s = e), "object" == typeof i && (o = i || {})), !n || !$d4d06657c043713f$var$x(n)) return;
        s = s || "[data-fancybox]";
        const a = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ("string" == typeof t ? (i = document.body, n = t) : (i = t, "string" == typeof e && (n = e)), !i) return;
        const s = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($d4d06657c043713f$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent);
        $d4d06657c043713f$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$d4d06657c043713f$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $d4d06657c043713f$var$u({}, $d4d06657c043713f$var$tt, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $d4d06657c043713f$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e) {
        let i = null, n = "";
        if ("string" == typeof t ? (i = document.body, n = t) : t instanceof HTMLElement && "string" == typeof e && (i = t, n = e), !i || !n) return !1;
        const s = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(i);
        if (!s) return !1;
        const o = s.get(n);
        return !!o && $d4d06657c043713f$export$cb45b08d97cdc4fd.fromNodes(Array.from(i.querySelectorAll(n)), o);
    }
    static fromNodes(t, e) {
        e = $d4d06657c043713f$var$u({}, $d4d06657c043713f$var$tt, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t.src || n.getAttribute("href") || n.getAttribute("currentSrc") || n.getAttribute("src") || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o.src || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset.src || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t)l[e] = t[e] + "";
            i.push(l);
        }
        return new $d4d06657c043713f$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $d4d06657c043713f$var$Bt.get(t);
        return Array.from($d4d06657c043713f$var$Bt.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $d4d06657c043713f$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $d4d06657c043713f$var$Bt.values())t.close(...e);
        else {
            const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.22"
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$tt
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Ot
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});




$d4d06657c043713f$export$cb45b08d97cdc4fd.bind('[data-fancybox="gallery"]');


"use strict";



"use strict";

const $63b1881c42f4055e$var$selectors = {
    container: "[data-tabs]",
    tabHeader: "[data-tabs-header]",
    tabPane: "[data-tabs-pane]",
    active: "active"
};
const $63b1881c42f4055e$var$setActive = (headers, panes, activeIndex)=>{
    headers.forEach((header, index)=>{
        header.classList[activeIndex === index ? "add" : "remove"]($63b1881c42f4055e$var$selectors.active);
    });
    panes.forEach((pane, index)=>{
        pane.classList[activeIndex === index ? "add" : "remove"]($63b1881c42f4055e$var$selectors.active);
    });
};
const $63b1881c42f4055e$var$initTabs = (container)=>{
    const headers = container.querySelectorAll($63b1881c42f4055e$var$selectors.tabHeader);
    const panes = container.querySelectorAll($63b1881c42f4055e$var$selectors.tabPane);
    headers?.forEach((header, activeIndex)=>header.addEventListener("click", ()=>$63b1881c42f4055e$var$setActive(headers, panes, activeIndex)));
    $63b1881c42f4055e$var$setActive(headers, panes, 0);
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll($63b1881c42f4055e$var$selectors.container);
    containers?.forEach($63b1881c42f4055e$var$initTabs);
}, {
    once: true
});


"use strict";



"use strict";


var $55b64b54797f1701$var$_plyr = $55b64b54797f1701$var$_interopRequireDefault((parcelRequire("24sIZ")));

var $55b64b54797f1701$var$_playerControls = $55b64b54797f1701$var$_interopRequireDefault((parcelRequire("9lDzm")));

var $55b64b54797f1701$var$_bodyScroll = $55b64b54797f1701$var$_interopRequireDefault((parcelRequire("6IDQ8")));

var $55b64b54797f1701$var$_overlay = $55b64b54797f1701$var$_interopRequireDefault((parcelRequire("be7LT")));
function $55b64b54797f1701$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $55b64b54797f1701$var$selectors = {
    player: "#player",
    container: ".video__content",
    play: "[data-video-button-play]",
    close: "[data-player-button-close]",
    duration: "[data-player-duration]"
};
const $55b64b54797f1701$var$elements = {
    player: null,
    play: null,
    close: null,
    duration: null
};
const $55b64b54797f1701$var$classes = {
    show: "video_show",
    hideControl: "hide-controls",
    playing: "playing"
};
function $55b64b54797f1701$var$init() {
    $55b64b54797f1701$var$elements.player = document.querySelector($55b64b54797f1701$var$selectors.player);
    if (!$55b64b54797f1701$var$elements.player) return null;
    $55b64b54797f1701$var$elements.play = document.querySelector($55b64b54797f1701$var$selectors.play);
    $55b64b54797f1701$var$elements.close = document.querySelector($55b64b54797f1701$var$selectors.close);
    const videoContainer = document.querySelector($55b64b54797f1701$var$selectors.container);
    const video = new $55b64b54797f1701$var$_plyr.default($55b64b54797f1701$var$elements.player, {
        controls: $55b64b54797f1701$var$_playerControls.default
    });
    const isSingleVideo = $55b64b54797f1701$var$elements.player.dataset.type === "video";
    function changeView(isValue) {
        videoContainer.classList[isValue]($55b64b54797f1701$var$classes.playing);
    }
    video.on("playing", ()=>{
        if (isSingleVideo) return;
        changeView("add");
        (0, $55b64b54797f1701$var$_bodyScroll.default)().disabledScroll();
        (0, $55b64b54797f1701$var$_overlay.default)().showOverlay();
    });
    video.on("exitfullscreen", ()=>{});
    $55b64b54797f1701$var$elements.close.addEventListener("click", ()=>{
        video.pause();
        video.stop();
        (0, $55b64b54797f1701$var$_overlay.default)().hideOverlay();
        (0, $55b64b54797f1701$var$_bodyScroll.default)().enabledScroll();
        changeView("remove");
    });
}
document.addEventListener("DOMContentLoaded", async function() {
    $55b64b54797f1701$var$init();
}, {
    once: true
});


"use strict";

var $5ff95e8910c63082$var$_swiper = $5ff95e8910c63082$var$_interopRequireWildcard((parcelRequire("e1ad9")));

function $5ff95e8910c63082$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5ff95e8910c63082$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5ff95e8910c63082$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5ff95e8910c63082$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
const $5ff95e8910c63082$var$initQuoteSlider = (container)=>{
    new $5ff95e8910c63082$var$_swiper.default(container.querySelector(".swiper"), {
        modules: [
            $5ff95e8910c63082$var$_swiper.Navigation,
            $5ff95e8910c63082$var$_swiper.Pagination
        ],
        rewind: true,
        slidesPerView: 1,
        spaceBetween: 32,
        navigation: {
            prevEl: container.querySelector(".prev"),
            nextEl: container.querySelector(".next")
        },
        pagination: {
            el: container.querySelector(".swiper-pagination")
        }
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll(".qs");
    containers?.forEach($5ff95e8910c63082$var$initQuoteSlider);
}, {
    once: true
});


"use strict";



"use strict";



"use strict";

var $d9a4ac9599f47c59$var$_swiper = $d9a4ac9599f47c59$var$_interopRequireWildcard((parcelRequire("e1ad9")));



function $d9a4ac9599f47c59$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d9a4ac9599f47c59$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d9a4ac9599f47c59$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d9a4ac9599f47c59$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
$d4d06657c043713f$export$cb45b08d97cdc4fd.bind('[data-fancybox="trip"]');
const $d9a4ac9599f47c59$var$selectors = {
    container: "[data-ta]",
    popup: "[data-ta-popup]",
    popupTrigger: "[data-ta-popup-trigger]",
    blockTab: '[data-ta-tab="block"]',
    popupTab: '[data-ta-tab="popup"]',
    popupPane: "[data-ta-pane]",
    active: "active"
};
const $d9a4ac9599f47c59$var$initTripAgendaPopup = (container)=>{
    const popup = container.querySelector($d9a4ac9599f47c59$var$selectors.popup);
    const triggers = container.querySelectorAll($d9a4ac9599f47c59$var$selectors.popupTrigger);
    triggers.forEach((trigger)=>trigger.addEventListener("click", ()=>{
            popup.classList.toggle($d9a4ac9599f47c59$var$selectors.active);
            document.body.classList.toggle("no-scroll");
        }));
};
const $d9a4ac9599f47c59$var$handleTabClick = (activeIndex, tabs, panes)=>{
    tabs.forEach((tab, index)=>tab.classList[activeIndex === index ? "add" : "remove"]($d9a4ac9599f47c59$var$selectors.active));
    panes.forEach((pane, index)=>pane.classList[activeIndex === index ? "add" : "remove"]($d9a4ac9599f47c59$var$selectors.active));
};
const $d9a4ac9599f47c59$var$initTripAgendaTabs = (container)=>{
    const blockTabs = container.querySelectorAll($d9a4ac9599f47c59$var$selectors.blockTab);
    const popupTabs = container.querySelectorAll($d9a4ac9599f47c59$var$selectors.popupTab);
    const panes = container.querySelectorAll($d9a4ac9599f47c59$var$selectors.popupPane);
    blockTabs.forEach((tab, activeIndex)=>tab.addEventListener("click", ()=>$d9a4ac9599f47c59$var$handleTabClick(activeIndex, popupTabs, panes)));
    popupTabs.forEach((tab, activeIndex)=>tab.addEventListener("click", ()=>$d9a4ac9599f47c59$var$handleTabClick(activeIndex, popupTabs, panes)));
};
const $d9a4ac9599f47c59$var$initTripAgendaSlider = (container)=>{
    const slides = container.querySelectorAll(".swiper-slide");
    new $d9a4ac9599f47c59$var$_swiper.default(container.querySelector(".swiper"), {
        modules: [
            $d9a4ac9599f47c59$var$_swiper.Navigation,
            $d9a4ac9599f47c59$var$_swiper.Scrollbar,
            $d9a4ac9599f47c59$var$_swiper.Pagination
        ],
        slidesPerView: 1,
        spaceBetween: 16,
        scrollbar: {
            el: container.querySelector(".swiper-scrollbar"),
            draggable: true
        },
        navigation: {
            prevEl: container.querySelector(".prev"),
            nextEl: container.querySelector(".next")
        },
        pagination: {
            el: container.querySelector(".swiper-pagination")
        },
        breakpoints: {
            1024: {
                slidesPerView: 2,
                spaceBetween: 24
            }
        }
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    const containers = document.querySelectorAll($d9a4ac9599f47c59$var$selectors.container);
    containers?.forEach((container)=>{
        $d9a4ac9599f47c59$var$initTripAgendaSlider(container);
        $d9a4ac9599f47c59$var$initTripAgendaPopup(container);
        $d9a4ac9599f47c59$var$initTripAgendaTabs(container);
    });
}, {
    once: true
});


"use strict";








var $b8f9b7833fa37166$var$_blazy = $b8f9b7833fa37166$var$_interopRequireDefault((parcelRequire("lXZdh")));
"use strict";
class $12ecf4776a3e1ac0$var$DataLayer {
    buttons;
    constructor(){
        window.dataLayer = window.dataLayer || [];
        this.buttons = document.querySelectorAll("[data-tracking]");
        Array.from(this.buttons).map((button)=>button.addEventListener("click", (e)=>{
                const event = e.currentTarget.dataset.trackingEvent;
                const label = e.currentTarget.dataset.trackingLabel;
                this.pushEvent(event, label);
            }));
    }
    pushEvent(event, label) {
        dataLayer.push({
            event: event || "",
            linktext: label || "",
            page_location: window.location.href
        });
    }
}
!async function() {
    if ("complete" === document.readyState) window.tracking = new $12ecf4776a3e1ac0$var$DataLayer();
    else window.addEventListener("load", ()=>{
        window.tracking = new $12ecf4776a3e1ac0$var$DataLayer();
    });
}();


"use strict";
document.addEventListener("DOMContentLoaded", async function() {
    const windowHeightCalc = ()=>{
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    windowHeightCalc();
    window.addEventListener("resize", ()=>{
        windowHeightCalc();
    });
}, {
    once: true
});


"use strict";
const $46ba4dcbcd3a7740$var$selectors = {
    accordion: "[data-accordion]",
    trigger: "[data-accordion-trigger]"
};
const $46ba4dcbcd3a7740$var$classes = {
    isOpen: "active"
};
const $46ba4dcbcd3a7740$var$elements = {
    accordion: null
};
const $46ba4dcbcd3a7740$var$accordionInit = ()=>{
    $46ba4dcbcd3a7740$var$elements.accordion = document.querySelectorAll($46ba4dcbcd3a7740$var$selectors.accordion);
    if (!$46ba4dcbcd3a7740$var$elements.accordion) return null;
    [
        ...$46ba4dcbcd3a7740$var$elements.accordion
    ].map((element)=>{
        const trigger = element.querySelector($46ba4dcbcd3a7740$var$selectors.trigger);
        if (!trigger) return null;
        trigger.addEventListener("click", ()=>element.classList[element.classList.contains($46ba4dcbcd3a7740$var$classes.isOpen) ? "remove" : "add"]($46ba4dcbcd3a7740$var$classes.isOpen));
    });
};
document.addEventListener("DOMContentLoaded", async function() {
    $46ba4dcbcd3a7740$var$accordionInit();
}, {
    once: true
});


var $d50e7c64a57c6e3a$exports = {};
"use strict";
Object.defineProperty($d50e7c64a57c6e3a$exports, "__esModule", {
    value: true
});
$d50e7c64a57c6e3a$exports.initTabs = void 0;
const $d50e7c64a57c6e3a$var$initTabs = ()=>{
    const selectors = {
        buttons: "[data-tab-index]"
    };
    const elements = {
        buttons: null
    };
    const queryElements = ()=>{
        elements.buttons = document.querySelectorAll(selectors.buttons);
        registerEvents();
        [
            ...elements.buttons
        ].reduce((acc, item)=>{
            const key = item.dataset.tabKey;
            if (acc.includes(key)) return acc;
            return [
                ...acc,
                key
            ];
        }, []).forEach((filterKey)=>{
            const buttons = [
                ...elements.buttons
            ].filter((el)=>el.dataset.tabKey === filterKey);
            buttons[0].click();
        });
    };
    const handleButtonClick = (e)=>{
        const key = e.currentTarget.dataset.tabKey;
        const index = e.currentTarget.dataset.tabIndex;
        const buttonsGroup = document.querySelectorAll(`[data-tab-key=${key}]`);
        const contentsGroup = document.querySelectorAll(`[data-tab-content-key=${key}]`);
        [
            ...buttonsGroup
        ].map((button)=>button.classList.remove("active"));
        e.currentTarget.classList.add("active");
        if (index === "*") {
            [
                ...contentsGroup
            ].map((content)=>content.style.display = "block");
            return null;
        }
        [
            ...contentsGroup
        ].forEach((content)=>{
            const isFind = content.dataset.tabContentIndex.split(",").includes(index);
            if (isFind) content.style.display = "block";
            else content.style.display = "none";
        });
    };
    const registerEvents = ()=>{
        [
            ...elements.buttons
        ].map((button)=>button.addEventListener("click", handleButtonClick));
    };
    queryElements();
};
$d50e7c64a57c6e3a$exports.initTabs = $d50e7c64a57c6e3a$var$initTabs;


function $b8f9b7833fa37166$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
document.addEventListener("DOMContentLoaded", async function() {
    (0, $b8f9b7833fa37166$var$_blazy.default)();
    (0, $d50e7c64a57c6e3a$exports.initTabs)();
}, {
    once: true
});

})();
//# sourceMappingURL=index.js.map
